/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/**
 * BallotReady Actions Beta
 *
 */
export type Action = DatabaseIdentifiable & Node & Slug & Timestamps & {
  __typename?: 'Action';
  body?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /**
   * For `CLICK` actions only. URL where click should lead.
   *
   */
  destinationUrl?: Maybe<Scalars['String']['output']>;
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputFields: Scalars['JSON']['output'];
  organization: Organization;
  /** Unique string used to reference object in URLs */
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: ActionType;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Action. */
export type ActionConnection = {
  __typename?: 'ActionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ActionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Action>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ActionEdge = {
  __typename?: 'ActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Action>;
};

export enum ActionType {
  CLICK = 'CLICK',
  OPT_IN = 'OPT_IN'
}

export type Address = DatabaseIdentifiable & Node & Timestamps & {
  __typename?: 'Address';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  state?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

/** Filtering options for addresses. */
export type AddressFilter = {
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressee?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Ballot measure arguments */
export type Argument = DatabaseIdentifiable & Node & {
  __typename?: 'Argument';
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  measure: Measure;
  proCon?: Maybe<Sentiment>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Ballot = DatabaseIdentifiable & Node & Timestamps & {
  __typename?: 'Ballot';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type BallotEvent = DatabaseIdentifiable & Node & Timestamps & {
  __typename?: 'BallotEvent';
  ballot: Ballot;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  details: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Body = DatabaseIdentifiable & GeographicalIdentifiers & Node & Timestamps & {
  __typename?: 'Body';
  bodyMembers?: Maybe<BodyMemberConnection>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /**
   * GEOIDs are numeric codes that uniquely identify all administrative/legal and statistical geographic areas for which the Census Bureau tabulates data.
   *
   * More information: https://www.census.gov/programs-surveys/geography/guidance/geo-identifiers.html
   *
   */
  geoId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * MAF/TIGER Feature Class Code, a census designated code of 1 letter and 4 numbers (e.g. G4000) designating what kind of geographical entity is being described (Congressional District, Incorporated Place, County or Equivalent Features, etc).
   *
   * More information: https://www.census.gov/library/reference/code-lists/mt-feature-class-codes.html
   *
   * List of commonly used MTFCC:
   *
   * * State: `G4000`
   * * County: `G4020`
   * * City: `G4110`
   *
   * Any MTFCC starting with `X` is a BallotReady defined custom code.
   *
   */
  mtfcc?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type BodyBodyMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Body. */
export type BodyConnection = {
  __typename?: 'BodyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BodyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Body>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BodyEdge = {
  __typename?: 'BodyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Body>;
};

/** Filtering options for bodies */
export type BodyFilter = {
  /**
   * Filter by GEOID.
   *
   * Supports 3 options:
   *
   * 1. Filter by a single, exact GEOID (e.g. `geoId: "02"` to find all state-level objects in Alaska)
   * 2. Filter by a single, inexact GEOID with a wild card at the end (e.g. `geoId: "02*"` to find all objects in Alaska)
   * 3. Filter by multiple exact GEOIDs at the same time (e.g. `geoId: ["02", "17"]` to return state-level objects in both Alaska and Illinois)
   *
   * More information about GEOIDs: https://www.census.gov/programs-surveys/geography/guidance/geo-identifiers.html
   *
   */
  geoId?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * MAF/TIGER Feature Class Code, a census designated code of 1 letter and 4 numbers (e.g. G4000) designating what kind of geographical entity is being described (Congressional District, Incorporated Place, County or Equivalent Features, etc).
   *
   * More information: https://www.census.gov/library/reference/code-lists/mt-feature-class-codes.html
   *
   * List of commonly used MTFCC:
   *
   * * State: `G4000`
   * * County: `G4020`
   * * City: `G4110`
   *
   */
  mtfcc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 2 character state code (e.g. `IL` for Illinois). */
  state?: InputMaybe<Scalars['String']['input']>;
};

export type BodyMember = DatabaseIdentifiable & Node & Timestamps & {
  __typename?: 'BodyMember';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  position: Position;
  /** The specific role this position plays in the body where relevant. */
  role?: Maybe<Member>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for BodyMember. */
export type BodyMemberConnection = {
  __typename?: 'BodyMemberConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BodyMemberEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BodyMember>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BodyMemberEdge = {
  __typename?: 'BodyMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BodyMember>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/**
 * A candidacy is an instance of a person (candidate) running for a position in a specific election (race).
 * This will have race-specific information about a person like their endorsements when running for their position, issue stances, and other information about their candidacy.
 *
 */
export type Candidacy = DatabaseIdentifiable & Node & Timestamps & {
  __typename?: 'Candidacy';
  candidate: Person;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  election: Election;
  endorsements: Array<Endorsement>;
  id: Scalars['ID']['output'];
  /** Returns true when a candidacy is included on a certified candidate list by their local election authority. We might record a candidacy before this threshold (i.e., a primary winner) but list them as uncertified (isCertified: false). */
  isCertified: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  parties: Array<Party>;
  position: Position;
  race: Race;
  /** The result of the election for this candidacy, if available. Will be null if the election has not yet been held. */
  result?: Maybe<ElectionResult>;
  stances: Array<Stance>;
  uncertified: Scalars['Boolean']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  withdrawn: Scalars['Boolean']['output'];
};

export type CandidateUrl = DatabaseIdentifiable & Node & {
  __typename?: 'CandidateUrl';
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  entryType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type CivicEngineMutation = {
  __typename?: 'CivicEngineMutation';
  createBallot?: Maybe<CreateBallotPayload>;
  createBallotEvent?: Maybe<CreateBallotEventPayload>;
  createContact?: Maybe<CreateConstituentContactPayload>;
};


export type CivicEngineMutationCreateBallotArgs = {
  input: CreateBallotInput;
};


export type CivicEngineMutationCreateBallotEventArgs = {
  input: CreateBallotEventInput;
};


export type CivicEngineMutationCreateContactArgs = {
  input: CreateConstituentContactInput;
};

export type CivicEngineQuery = {
  __typename?: 'CivicEngineQuery';
  actions: ActionConnection;
  /** Look up position info by government body.  Useful when you want information about a specific government body, like a state legislature or a school board.  Note that not all positions belong to a body. */
  bodies: BodyConnection;
  /** The complexity of the current query */
  complexity: Scalars['Int']['output'];
  /** Look up elections. */
  elections: ElectionConnection;
  /** List of issue categories */
  issues: IssueConnection;
  /** Look up ballot measures */
  measures: MeasureConnection;
  /**
   * List of known MTFCC
   *
   * Custom, BallotReady defined MTFCC start with X
   *
   */
  mtfcc: MtfccConnection;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  nodeBySlug?: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  /** Look up office holders */
  officeHolders: OfficeHolderConnection;
  /** List of organizations with researched endorsements */
  organizations: OrganizationConnection;
  /** Look up people (candidates) */
  people: PersonConnection;
  /** Look up places */
  places: PlaceConnection;
  /** Look up positions */
  positions: PositionConnection;
  /** Look up races */
  races: RaceConnection;
  /** Look up voting locations (in person voting and ballot drop off locations.) */
  votingLocations: VotingLocationConnection;
};


export type CivicEngineQueryActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CivicEngineQueryBodiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<BodyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationFilter>;
};


export type CivicEngineQueryElectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<ElectionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationFilter>;
  orderBy?: InputMaybe<ElectionOrder>;
};


export type CivicEngineQueryIssuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CivicEngineQueryMeasuresArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<MeasureFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationFilter>;
};


export type CivicEngineQueryMtfccArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CivicEngineQueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type CivicEngineQueryNodeBySlugArgs = {
  objectType: ObjectType;
  slug: Scalars['String']['input'];
};


export type CivicEngineQueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type CivicEngineQueryOfficeHoldersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<OfficeHolderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationFilter>;
  orderBy?: InputMaybe<OfficeHolderOrder>;
};


export type CivicEngineQueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<OrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CivicEngineQueryPeopleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<PersonFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CivicEngineQueryPlacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<PlaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationFilter>;
  orderBy?: InputMaybe<PlaceOrder>;
};


export type CivicEngineQueryPositionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<PositionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationFilter>;
};


export type CivicEngineQueryRacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<RaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationFilter>;
  orderBy?: InputMaybe<RaceOrder>;
};


export type CivicEngineQueryVotingLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy: VotingLocationFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationFilter>;
};

export type ConstituentContact = DatabaseIdentifiable & Node & Timestamps & {
  __typename?: 'ConstituentContact';
  address?: Maybe<Address>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateBallotEvent */
export type CreateBallotEventInput = {
  ballotId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['String']['input'];
};

/** Autogenerated return type of CreateBallotEvent. */
export type CreateBallotEventPayload = {
  __typename?: 'CreateBallotEventPayload';
  ballotEvent?: Maybe<BallotEvent>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateBallot */
export type CreateBallotInput = {
  address: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateBallot. */
export type CreateBallotPayload = {
  __typename?: 'CreateBallotPayload';
  ballot?: Maybe<Ballot>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engineToken?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateConstituentContact */
export type CreateConstituentContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location: LocationWithAddressInput;
  phone?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  utm?: InputMaybe<UtmInput>;
};

/** Autogenerated return type of CreateConstituentContact. */
export type CreateConstituentContactPayload = {
  __typename?: 'CreateConstituentContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ConstituentContact>;
  errors: Array<Scalars['String']['output']>;
};

/** ordering argument of a cursor */
export enum CursorOrdering {
  /** ascending ordering of the cursor */
  ASC = 'ASC',
  /** descending ordering of the cursor */
  DESC = 'DESC'
}

export type DatabaseIdentifiable = {
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
};

export enum DateSpecificity {
  DAY = 'DAY',
  MONTH = 'MONTH',
  YEAR = 'YEAR'
}

export type Degree = DatabaseIdentifiable & Node & {
  __typename?: 'Degree';
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /** Type of degree received (e.g., Bachelor's, Masters') */
  degree?: Maybe<Scalars['String']['output']>;
  /** Year graduated */
  gradYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Major studied (if listed or applicable) */
  major?: Maybe<Scalars['String']['output']>;
  /** School that the person received the degree from. If they went to a specialized school within a university, only the university name will be listed. */
  school?: Maybe<Scalars['String']['output']>;
};

export type Election = DatabaseIdentifiable & HasRaces & Node & Slug & Timestamps & {
  __typename?: 'Election';
  /** Deadline for election authorities to send out mail ballots by.  The actual date may be earlier. */
  ballotsSentOutBy?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Date on which candidate information is made available. This date determines when the Ballot Engine becomes active. */
  candidateInformationPublishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /** Default time zone. For elections spanning multiple time zones this returns the most common time zone. */
  defaultTimeZone: Scalars['String']['output'];
  /** The date of the election. */
  electionDay: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  measures: MeasureConnection;
  milestones: Array<Milestone>;
  /** A descriptive name for the election according to BallotReady's naming conventions (e.g. California Consolidated Municipal Election, Tuscaloosa Municipal General Election). */
  name: Scalars['String']['output'];
  originalElectionDate: Scalars['ISO8601Date']['output'];
  /** Total number of races connected to this object */
  raceCount: Scalars['Int']['output'];
  races: RaceConnection;
  /** Unique string used to reference object in URLs */
  slug: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  /** Default time zone. For elections spanning multiple time zones this returns the most common time zone. */
  timezone: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vipElections: Array<VipElection>;
  /**
   * Collection of dates and times when polling places are open
   *
   * A single date might have multiple entries. This could be because there are different times
   * for in person voting and dropping off your ballot. It could also be that a polling place is
   * closed part of the day (e.g. because of a lunch break).
   *
   */
  votingDays: VotingDayConnection;
  /** Date on which voting information is made available. This date determines when the Turnout Engine becomes active. */
  votingInformationPublishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Collection of voting locations */
  votingLocations: VotingLocationConnection;
};


export type ElectionMeasuresArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ElectionMilestonesArgs = {
  filterBy?: InputMaybe<MilestoneFilter>;
};


export type ElectionRacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<RaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RaceOrder>;
};


export type ElectionVotingDaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ElectionVotingLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Election. */
export type ElectionConnection = {
  __typename?: 'ElectionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ElectionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Election>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Options to filter nodes by timestamp (UTC). Combine arguments to search between timestamps. */
export type ElectionCreatedAtFilter = {
  /** Exact date. */
  eq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Greater than date. */
  gt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Greater than or equal to date. */
  gte?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Less than date. */
  lt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Less than or equal to date. */
  lte?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Options to filter nodes by date. Combine arguments to search between dates. */
export type ElectionDayFilter = {
  /** Exact date. */
  eq?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Greater than date. */
  gt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Greater than or equal to date. */
  gte?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Less than date. */
  lt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Less than or equal to date. */
  lte?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** An edge in a connection. */
export type ElectionEdge = {
  __typename?: 'ElectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Election>;
};

/** Filtering options for elections. */
export type ElectionFilter = {
  createdAt?: InputMaybe<ElectionCreatedAtFilter>;
  electionDay?: InputMaybe<ElectionDayFilter>;
  isRegular?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<ElectionLevelFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** 2 character state code (e.g. `IL` for Illinois). */
  state?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<ElectionUpdatedAtFilter>;
};

/** Options to filter election type. */
export type ElectionLevelFilter = {
  minimum: PositionLevel;
};

/** Ordering options for elections. */
export type ElectionOrder = {
  /** Possible directions in which to order a list of items when provided an `orderBy` argument. */
  direction: OrderDirection;
  /** Properties by which elections can be ordered. */
  field: ElectionOrderField;
};

export enum ElectionOrderField {
  /** Order elections by election day */
  ELECTION_DAY = 'ELECTION_DAY'
}

export enum ElectionResult {
  LOST = 'LOST',
  RUNOFF = 'RUNOFF',
  WON = 'WON'
}

/** Options to filter nodes by timestamp (UTC). Combine arguments to search between timestamps. */
export type ElectionUpdatedAtFilter = {
  /** Exact date. */
  eq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Greater than date. */
  gt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Greater than or equal to date. */
  gte?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Less than date. */
  lt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Less than or equal to date. */
  lte?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type Endorsement = DatabaseIdentifiable & Node & Timestamps & {
  __typename?: 'Endorsement';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  endorser?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  recommendation?: Maybe<Sentiment>;
  status: EndorsementStatusTypeField;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum EndorsementStatusTypeField {
  /** The candidacy has been confirmed by research */
  ACTIVE = 'ACTIVE',
  /** The candidate was not found to be running in this race by our researchers */
  NOT_FOUND = 'NOT_FOUND',
  /** The related position has not been researched yet */
  PENDING = 'PENDING'
}

/** columns and relationships of "entities" */
export type Entities = {
  __typename?: 'Entities';
  bio?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  displayNameLong: Scalars['String']['output'];
  displayNameShort?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  entityPersonRels: Array<EntityPersonRels>;
  /** An aggregate relationship */
  entityPersonRelsAggregate: EntityPersonRelsAggregate;
  entityType?: Maybe<EntityTypesEnum>;
  id: Scalars['uuid']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isIdVerified: Scalars['Boolean']['output'];
  /** an entity is a leader if it has any issues */
  isLeader?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  issueSupporterRels: Array<IssueSupporterRels>;
  /** An aggregate relationship */
  issueSupporterRelsAggregate: IssueSupporterRelsAggregate;
  /** An array relationship */
  issues: Array<Issues>;
  /** An aggregate relationship */
  issuesAggregate: IssuesAggregate;
  /** An object relationship */
  profilePhoto?: Maybe<Media>;
  profilePhotoId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "entities" */
export type EntitiesEntityPersonRelsArgs = {
  distinctOn?: InputMaybe<Array<EntityPersonRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityPersonRelsOrderBy>>;
  where?: InputMaybe<EntityPersonRelsBoolExp>;
};


/** columns and relationships of "entities" */
export type EntitiesEntityPersonRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EntityPersonRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityPersonRelsOrderBy>>;
  where?: InputMaybe<EntityPersonRelsBoolExp>;
};


/** columns and relationships of "entities" */
export type EntitiesIssueSupporterRelsArgs = {
  distinctOn?: InputMaybe<Array<IssueSupporterRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueSupporterRelsOrderBy>>;
  where?: InputMaybe<IssueSupporterRelsBoolExp>;
};


/** columns and relationships of "entities" */
export type EntitiesIssueSupporterRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssueSupporterRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueSupporterRelsOrderBy>>;
  where?: InputMaybe<IssueSupporterRelsBoolExp>;
};


/** columns and relationships of "entities" */
export type EntitiesIssuesArgs = {
  distinctOn?: InputMaybe<Array<IssuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssuesOrderBy>>;
  where?: InputMaybe<IssuesBoolExp>;
};


/** columns and relationships of "entities" */
export type EntitiesIssuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssuesOrderBy>>;
  where?: InputMaybe<IssuesBoolExp>;
};

/** aggregated selection of "entities" */
export type EntitiesAggregate = {
  __typename?: 'EntitiesAggregate';
  aggregate?: Maybe<EntitiesAggregateFields>;
  nodes: Array<Entities>;
};

export type EntitiesAggregateBoolExp = {
  bool_and?: InputMaybe<EntitiesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<EntitiesAggregateBoolExpBool_Or>;
  count?: InputMaybe<EntitiesAggregateBoolExpCount>;
};

/** aggregate fields of "entities" */
export type EntitiesAggregateFields = {
  __typename?: 'EntitiesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EntitiesMaxFields>;
  min?: Maybe<EntitiesMinFields>;
};


/** aggregate fields of "entities" */
export type EntitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EntitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "entities" */
export type EntitiesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EntitiesMaxOrderBy>;
  min?: InputMaybe<EntitiesMinOrderBy>;
};

/** input type for inserting array relation for remote table "entities" */
export type EntitiesArrRelInsertInput = {
  data: Array<EntitiesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EntitiesOnConflict>;
};

/** Boolean expression to filter rows from the table "entities". All fields are combined with a logical 'AND'. */
export type EntitiesBoolExp = {
  _and?: InputMaybe<Array<EntitiesBoolExp>>;
  _not?: InputMaybe<EntitiesBoolExp>;
  _or?: InputMaybe<Array<EntitiesBoolExp>>;
  bio?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  displayNameLong?: InputMaybe<StringComparisonExp>;
  displayNameShort?: InputMaybe<StringComparisonExp>;
  entityPersonRels?: InputMaybe<EntityPersonRelsBoolExp>;
  entityPersonRelsAggregate?: InputMaybe<EntityPersonRelsAggregateBoolExp>;
  entityType?: InputMaybe<EntityTypesEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isDisabled?: InputMaybe<BooleanComparisonExp>;
  isIdVerified?: InputMaybe<BooleanComparisonExp>;
  isLeader?: InputMaybe<BooleanComparisonExp>;
  issueSupporterRels?: InputMaybe<IssueSupporterRelsBoolExp>;
  issueSupporterRelsAggregate?: InputMaybe<IssueSupporterRelsAggregateBoolExp>;
  issues?: InputMaybe<IssuesBoolExp>;
  issuesAggregate?: InputMaybe<IssuesAggregateBoolExp>;
  profilePhoto?: InputMaybe<MediaBoolExp>;
  profilePhotoId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "entities" */
export enum EntitiesConstraint {
  /** unique or primary key constraint on columns "id" */
  ENTITIES_PKEY = 'entities_pkey'
}

/** input type for inserting data into table "entities" */
export type EntitiesInsertInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  displayNameLong?: InputMaybe<Scalars['String']['input']>;
  displayNameShort?: InputMaybe<Scalars['String']['input']>;
  entityPersonRels?: InputMaybe<EntityPersonRelsArrRelInsertInput>;
  entityType?: InputMaybe<EntityTypesEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIdVerified?: InputMaybe<Scalars['Boolean']['input']>;
  issueSupporterRels?: InputMaybe<IssueSupporterRelsArrRelInsertInput>;
  issues?: InputMaybe<IssuesArrRelInsertInput>;
  profilePhoto?: InputMaybe<MediaObjRelInsertInput>;
  profilePhotoId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type EntitiesMaxFields = {
  __typename?: 'EntitiesMaxFields';
  bio?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  displayNameLong?: Maybe<Scalars['String']['output']>;
  displayNameShort?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  profilePhotoId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "entities" */
export type EntitiesMaxOrderBy = {
  bio?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  displayNameLong?: InputMaybe<OrderBy>;
  displayNameShort?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  profilePhotoId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EntitiesMinFields = {
  __typename?: 'EntitiesMinFields';
  bio?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  displayNameLong?: Maybe<Scalars['String']['output']>;
  displayNameShort?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  profilePhotoId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "entities" */
export type EntitiesMinOrderBy = {
  bio?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  displayNameLong?: InputMaybe<OrderBy>;
  displayNameShort?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  profilePhotoId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "entities" */
export type EntitiesMutationResponse = {
  __typename?: 'EntitiesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Entities>;
};

/** input type for inserting object relation for remote table "entities" */
export type EntitiesObjRelInsertInput = {
  data: EntitiesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EntitiesOnConflict>;
};

/** on_conflict condition type for table "entities" */
export type EntitiesOnConflict = {
  constraint: EntitiesConstraint;
  updateColumns?: Array<EntitiesUpdateColumn>;
  where?: InputMaybe<EntitiesBoolExp>;
};

/** Ordering options when selecting data from "entities". */
export type EntitiesOrderBy = {
  bio?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  displayNameLong?: InputMaybe<OrderBy>;
  displayNameShort?: InputMaybe<OrderBy>;
  entityPersonRelsAggregate?: InputMaybe<EntityPersonRelsAggregateOrderBy>;
  entityType?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isDisabled?: InputMaybe<OrderBy>;
  isIdVerified?: InputMaybe<OrderBy>;
  isLeader?: InputMaybe<OrderBy>;
  issueSupporterRelsAggregate?: InputMaybe<IssueSupporterRelsAggregateOrderBy>;
  issuesAggregate?: InputMaybe<IssuesAggregateOrderBy>;
  profilePhoto?: InputMaybe<MediaOrderBy>;
  profilePhotoId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: entities */
export type EntitiesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "entities" */
export enum EntitiesSelectColumn {
  /** column name */
  BIO = 'bio',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DISPLAYNAMELONG = 'displayNameLong',
  /** column name */
  DISPLAYNAMESHORT = 'displayNameShort',
  /** column name */
  ENTITYTYPE = 'entityType',
  /** column name */
  ID = 'id',
  /** column name */
  ISDISABLED = 'isDisabled',
  /** column name */
  ISIDVERIFIED = 'isIdVerified',
  /** column name */
  PROFILEPHOTOID = 'profilePhotoId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** select "entitiesAggregateBoolExpBool_andArgumentsColumns" columns of table "entities" */
export enum EntitiesSelectColumnEntitiesAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  ISDISABLED = 'isDisabled',
  /** column name */
  ISIDVERIFIED = 'isIdVerified'
}

/** select "entitiesAggregateBoolExpBool_orArgumentsColumns" columns of table "entities" */
export enum EntitiesSelectColumnEntitiesAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  ISDISABLED = 'isDisabled',
  /** column name */
  ISIDVERIFIED = 'isIdVerified'
}

/** input type for updating data in table "entities" */
export type EntitiesSetInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  displayNameLong?: InputMaybe<Scalars['String']['input']>;
  displayNameShort?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EntityTypesEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIdVerified?: InputMaybe<Scalars['Boolean']['input']>;
  profilePhotoId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "entities" */
export type EntitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EntitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EntitiesStreamCursorValueInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  displayNameLong?: InputMaybe<Scalars['String']['input']>;
  displayNameShort?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EntityTypesEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIdVerified?: InputMaybe<Scalars['Boolean']['input']>;
  profilePhotoId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "entities" */
export enum EntitiesUpdateColumn {
  /** column name */
  BIO = 'bio',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DISPLAYNAMELONG = 'displayNameLong',
  /** column name */
  DISPLAYNAMESHORT = 'displayNameShort',
  /** column name */
  ENTITYTYPE = 'entityType',
  /** column name */
  ID = 'id',
  /** column name */
  ISDISABLED = 'isDisabled',
  /** column name */
  ISIDVERIFIED = 'isIdVerified',
  /** column name */
  PROFILEPHOTOID = 'profilePhotoId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type EntitiesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntitiesSetInput>;
  /** filter the rows which have to be updated */
  where: EntitiesBoolExp;
};

/** columns and relationships of "entity_person_rels" */
export type EntityPersonRels = {
  __typename?: 'EntityPersonRels';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  entity: Entities;
  entityId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  person: Persons;
  personId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "entity_person_rels" */
export type EntityPersonRelsAggregate = {
  __typename?: 'EntityPersonRelsAggregate';
  aggregate?: Maybe<EntityPersonRelsAggregateFields>;
  nodes: Array<EntityPersonRels>;
};

export type EntityPersonRelsAggregateBoolExp = {
  count?: InputMaybe<EntityPersonRelsAggregateBoolExpCount>;
};

/** aggregate fields of "entity_person_rels" */
export type EntityPersonRelsAggregateFields = {
  __typename?: 'EntityPersonRelsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EntityPersonRelsMaxFields>;
  min?: Maybe<EntityPersonRelsMinFields>;
};


/** aggregate fields of "entity_person_rels" */
export type EntityPersonRelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EntityPersonRelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "entity_person_rels" */
export type EntityPersonRelsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EntityPersonRelsMaxOrderBy>;
  min?: InputMaybe<EntityPersonRelsMinOrderBy>;
};

/** input type for inserting array relation for remote table "entity_person_rels" */
export type EntityPersonRelsArrRelInsertInput = {
  data: Array<EntityPersonRelsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EntityPersonRelsOnConflict>;
};

/** Boolean expression to filter rows from the table "entity_person_rels". All fields are combined with a logical 'AND'. */
export type EntityPersonRelsBoolExp = {
  _and?: InputMaybe<Array<EntityPersonRelsBoolExp>>;
  _not?: InputMaybe<EntityPersonRelsBoolExp>;
  _or?: InputMaybe<Array<EntityPersonRelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  entity?: InputMaybe<EntitiesBoolExp>;
  entityId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  person?: InputMaybe<PersonsBoolExp>;
  personId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "entity_person_rels" */
export enum EntityPersonRelsConstraint {
  /** unique or primary key constraint on columns "person_id", "entity_id" */
  ENTITY_PERSON_RELS_PERSON_ID_ENTITY_ID_KEY = 'entity_person_rels_person_id_entity_id_key',
  /** unique or primary key constraint on columns "id" */
  ENTITY_PERSON_RELS_PKEY = 'entity_person_rels_pkey'
}

/** input type for inserting data into table "entity_person_rels" */
export type EntityPersonRelsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entity?: InputMaybe<EntitiesObjRelInsertInput>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  person?: InputMaybe<PersonsObjRelInsertInput>;
  personId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type EntityPersonRelsMaxFields = {
  __typename?: 'EntityPersonRelsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  entityId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  personId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "entity_person_rels" */
export type EntityPersonRelsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  entityId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  personId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EntityPersonRelsMinFields = {
  __typename?: 'EntityPersonRelsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  entityId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  personId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "entity_person_rels" */
export type EntityPersonRelsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  entityId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  personId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "entity_person_rels" */
export type EntityPersonRelsMutationResponse = {
  __typename?: 'EntityPersonRelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityPersonRels>;
};

/** on_conflict condition type for table "entity_person_rels" */
export type EntityPersonRelsOnConflict = {
  constraint: EntityPersonRelsConstraint;
  updateColumns?: Array<EntityPersonRelsUpdateColumn>;
  where?: InputMaybe<EntityPersonRelsBoolExp>;
};

/** Ordering options when selecting data from "entity_person_rels". */
export type EntityPersonRelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  entity?: InputMaybe<EntitiesOrderBy>;
  entityId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  person?: InputMaybe<PersonsOrderBy>;
  personId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: entity_person_rels */
export type EntityPersonRelsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "entity_person_rels" */
export enum EntityPersonRelsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ENTITYID = 'entityId',
  /** column name */
  ID = 'id',
  /** column name */
  PERSONID = 'personId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "entity_person_rels" */
export type EntityPersonRelsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  personId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "entity_person_rels" */
export type EntityPersonRelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EntityPersonRelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityPersonRelsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  personId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "entity_person_rels" */
export enum EntityPersonRelsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ENTITYID = 'entityId',
  /** column name */
  ID = 'id',
  /** column name */
  PERSONID = 'personId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type EntityPersonRelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityPersonRelsSetInput>;
  /** filter the rows which have to be updated */
  where: EntityPersonRelsBoolExp;
};

/** columns and relationships of "entity_types" */
export type EntityTypes = {
  __typename?: 'EntityTypes';
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "entity_types" */
export type EntityTypesAggregate = {
  __typename?: 'EntityTypesAggregate';
  aggregate?: Maybe<EntityTypesAggregateFields>;
  nodes: Array<EntityTypes>;
};

/** aggregate fields of "entity_types" */
export type EntityTypesAggregateFields = {
  __typename?: 'EntityTypesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EntityTypesMaxFields>;
  min?: Maybe<EntityTypesMinFields>;
};


/** aggregate fields of "entity_types" */
export type EntityTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EntityTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "entity_types". All fields are combined with a logical 'AND'. */
export type EntityTypesBoolExp = {
  _and?: InputMaybe<Array<EntityTypesBoolExp>>;
  _not?: InputMaybe<EntityTypesBoolExp>;
  _or?: InputMaybe<Array<EntityTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "entity_types" */
export enum EntityTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  ENTITY_TYPES_PKEY = 'entity_types_pkey'
}

export enum EntityTypesEnum {
  /** Nonprofit Organization */
  NONPROFIT501C3 = 'NONPROFIT501C3',
  /** Nonprofit Organization */
  NONPROFIT501C4 = 'NONPROFIT501C4',
  /** The unique identity organization of a human being in the persons table. */
  PERSONAL = 'PERSONAL'
}

/** Boolean expression to compare columns of type "EntityTypesEnum". All fields are combined with logical 'AND'. */
export type EntityTypesEnumComparisonExp = {
  _eq?: InputMaybe<EntityTypesEnum>;
  _in?: InputMaybe<Array<EntityTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<EntityTypesEnum>;
  _nin?: InputMaybe<Array<EntityTypesEnum>>;
};

/** input type for inserting data into table "entity_types" */
export type EntityTypesInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EntityTypesMaxFields = {
  __typename?: 'EntityTypesMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EntityTypesMinFields = {
  __typename?: 'EntityTypesMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "entity_types" */
export type EntityTypesMutationResponse = {
  __typename?: 'EntityTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityTypes>;
};

/** on_conflict condition type for table "entity_types" */
export type EntityTypesOnConflict = {
  constraint: EntityTypesConstraint;
  updateColumns?: Array<EntityTypesUpdateColumn>;
  where?: InputMaybe<EntityTypesBoolExp>;
};

/** Ordering options when selecting data from "entity_types". */
export type EntityTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: entity_types */
export type EntityTypesPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "entity_types" */
export enum EntityTypesSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "entity_types" */
export type EntityTypesSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "entity_types" */
export type EntityTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EntityTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "entity_types" */
export enum EntityTypesUpdateColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

export type EntityTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityTypesSetInput>;
  /** filter the rows which have to be updated */
  where: EntityTypesBoolExp;
};

export type Experience = DatabaseIdentifiable & Node & {
  __typename?: 'Experience';
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  end?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organization?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "external_links" */
export type ExternalLinks = {
  __typename?: 'ExternalLinks';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  issueExternalLinkRels: Array<IssueExternalLinkRels>;
  /** An aggregate relationship */
  issueExternalLinkRelsAggregate: IssueExternalLinkRelsAggregate;
  link: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "external_links" */
export type ExternalLinksIssueExternalLinkRelsArgs = {
  distinctOn?: InputMaybe<Array<IssueExternalLinkRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueExternalLinkRelsOrderBy>>;
  where?: InputMaybe<IssueExternalLinkRelsBoolExp>;
};


/** columns and relationships of "external_links" */
export type ExternalLinksIssueExternalLinkRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssueExternalLinkRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueExternalLinkRelsOrderBy>>;
  where?: InputMaybe<IssueExternalLinkRelsBoolExp>;
};

/** aggregated selection of "external_links" */
export type ExternalLinksAggregate = {
  __typename?: 'ExternalLinksAggregate';
  aggregate?: Maybe<ExternalLinksAggregateFields>;
  nodes: Array<ExternalLinks>;
};

/** aggregate fields of "external_links" */
export type ExternalLinksAggregateFields = {
  __typename?: 'ExternalLinksAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ExternalLinksMaxFields>;
  min?: Maybe<ExternalLinksMinFields>;
};


/** aggregate fields of "external_links" */
export type ExternalLinksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ExternalLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "external_links". All fields are combined with a logical 'AND'. */
export type ExternalLinksBoolExp = {
  _and?: InputMaybe<Array<ExternalLinksBoolExp>>;
  _not?: InputMaybe<ExternalLinksBoolExp>;
  _or?: InputMaybe<Array<ExternalLinksBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  issueExternalLinkRels?: InputMaybe<IssueExternalLinkRelsBoolExp>;
  issueExternalLinkRelsAggregate?: InputMaybe<IssueExternalLinkRelsAggregateBoolExp>;
  link?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "external_links" */
export enum ExternalLinksConstraint {
  /** unique or primary key constraint on columns "id" */
  EXTERNAL_LINKS_PKEY = 'external_links_pkey'
}

/** input type for inserting data into table "external_links" */
export type ExternalLinksInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issueExternalLinkRels?: InputMaybe<IssueExternalLinkRelsArrRelInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ExternalLinksMaxFields = {
  __typename?: 'ExternalLinksMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type ExternalLinksMinFields = {
  __typename?: 'ExternalLinksMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "external_links" */
export type ExternalLinksMutationResponse = {
  __typename?: 'ExternalLinksMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ExternalLinks>;
};

/** input type for inserting object relation for remote table "external_links" */
export type ExternalLinksObjRelInsertInput = {
  data: ExternalLinksInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ExternalLinksOnConflict>;
};

/** on_conflict condition type for table "external_links" */
export type ExternalLinksOnConflict = {
  constraint: ExternalLinksConstraint;
  updateColumns?: Array<ExternalLinksUpdateColumn>;
  where?: InputMaybe<ExternalLinksBoolExp>;
};

/** Ordering options when selecting data from "external_links". */
export type ExternalLinksOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  issueExternalLinkRelsAggregate?: InputMaybe<IssueExternalLinkRelsAggregateOrderBy>;
  link?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: external_links */
export type ExternalLinksPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "external_links" */
export enum ExternalLinksSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  LINK = 'link',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "external_links" */
export type ExternalLinksSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "external_links" */
export type ExternalLinksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ExternalLinksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ExternalLinksStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "external_links" */
export enum ExternalLinksUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  LINK = 'link',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type ExternalLinksUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ExternalLinksSetInput>;
  /** filter the rows which have to be updated */
  where: ExternalLinksBoolExp;
};

export type FilingPeriod = DatabaseIdentifiable & Node & Timestamps & {
  __typename?: 'FilingPeriod';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /** Filing deadline. */
  endOn?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  /** Additional details about a filing period. For example: 'day after primary runoff'(different dates depending on election), 'set by the political party' (exact dates unknown), 'Cape Elizabeth' (regional differences). */
  notes?: Maybe<Scalars['String']['output']>;
  /** Earliest filing date. Could be blank when there is no official start date. */
  startOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Different types of filing periods exist for some positions. The most common examples are when there are different periods for candidacy declaration and nominating papers. */
  type?: Maybe<FilingPeriodType>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** FilingPeriod types */
export enum FilingPeriodType {
  DECLARATION = 'DECLARATION',
  NOMINATION = 'NOMINATION'
}

export type Form = DatabaseIdentifiable & Node & {
  __typename?: 'Form';
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  fields: Array<FormField>;
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  type: FormType;
  url: Scalars['String']['output'];
};

export type FormField = {
  __typename?: 'FormField';
  /**
   * Whether the underlying form marks this field as required.
   *
   * Note that it is NOT required to pass a value, regardless of the value of this field. Not
   * passing a value will simply result in it being blank on the form.'
   *
   */
  isRequired: Scalars['Boolean']['output'];
  /** Textual description of field. Could be used as form label. */
  label?: Maybe<Scalars['String']['output']>;
  /** Field name. Use this when passing values to the `sendForm` mutation. */
  name: Scalars['String']['output'];
  /** List of possible values (e.g. party names for a `PARTY` field) */
  options?: Maybe<Array<Scalars['String']['output']>>;
  /** Data type of this field. */
  type: Scalars['String']['output'];
};

/** Filtering options for forms. */
export type FormFilter = {
  locale?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<FormType>>;
};

export enum FormType {
  REGISTRATION = 'REGISTRATION',
  REQUEST_BALLOT = 'REQUEST_BALLOT'
}

export type Geofence = DatabaseIdentifiable & GeographicalIdentifiers & Node & Timestamps & {
  __typename?: 'Geofence';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /**
   * GEOIDs are numeric codes that uniquely identify all administrative/legal and statistical geographic areas for which the Census Bureau tabulates data.
   *
   * More information: https://www.census.gov/programs-surveys/geography/guidance/geo-identifiers.html
   *
   */
  geoId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * MAF/TIGER Feature Class Code, a census designated code of 1 letter and 4 numbers (e.g. G4000) designating what kind of geographical entity is being described (Congressional District, Incorporated Place, County or Equivalent Features, etc).
   *
   * More information: https://www.census.gov/library/reference/code-lists/mt-feature-class-codes.html
   *
   * List of commonly used MTFCC:
   *
   * * State: `G4000`
   * * County: `G4020`
   * * City: `G4110`
   *
   * Any MTFCC starting with `X` is a BallotReady defined custom code.
   *
   */
  mtfcc?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  validFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  validTo?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** The connection type for Geofence. */
export type GeofenceConnection = {
  __typename?: 'GeofenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GeofenceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Geofence>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type GeofenceEdge = {
  __typename?: 'GeofenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Geofence>;
};

/** Filtering options for geofences. */
export type GeofenceFilter = {
  /**
   * Filter by GEOID.
   *
   * Supports 3 options:
   *
   * 1. Filter by a single, exact GEOID (e.g. `geoId: "02"` to find all state-level objects in Alaska)
   * 2. Filter by a single, inexact GEOID with a wild card at the end (e.g. `geoId: "02*"` to find all objects in Alaska)
   * 3. Filter by multiple exact GEOIDs at the same time (e.g. `geoId: ["02", "17"]` to return state-level objects in both Alaska and Illinois)
   *
   * More information about GEOIDs: https://www.census.gov/programs-surveys/geography/guidance/geo-identifiers.html
   *
   */
  geoId?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * MAF/TIGER Feature Class Code, a census designated code of 1 letter and 4 numbers (e.g. G4000) designating what kind of geographical entity is being described (Congressional District, Incorporated Place, County or Equivalent Features, etc).
   *
   * More information: https://www.census.gov/library/reference/code-lists/mt-feature-class-codes.html
   *
   * List of commonly used MTFCC:
   *
   * * State: `G4000`
   * * County: `G4020`
   * * City: `G4110`
   *
   */
  mtfcc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 2 character state code (e.g. `IL` for Illinois). */
  state?: InputMaybe<Scalars['String']['input']>;
  /** single date input to return geofences valid on this date */
  validOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Objects with geographocal identifiers. */
export type GeographicalIdentifiers = {
  /**
   * GEOIDs are numeric codes that uniquely identify all administrative/legal and statistical geographic areas for which the Census Bureau tabulates data.
   *
   * More information: https://www.census.gov/programs-surveys/geography/guidance/geo-identifiers.html
   *
   */
  geoId?: Maybe<Scalars['String']['output']>;
  /**
   * MAF/TIGER Feature Class Code, a census designated code of 1 letter and 4 numbers (e.g. G4000) designating what kind of geographical entity is being described (Congressional District, Incorporated Place, County or Equivalent Features, etc).
   *
   * More information: https://www.census.gov/library/reference/code-lists/mt-feature-class-codes.html
   *
   * List of commonly used MTFCC:
   *
   * * State: `G4000`
   * * County: `G4020`
   * * City: `G4110`
   *
   * Any MTFCC starting with `X` is a BallotReady defined custom code.
   *
   */
  mtfcc?: Maybe<Scalars['String']['output']>;
};

export type HasCandidacies = {
  candidacies: Array<Candidacy>;
};


export type HasCandidaciesCandidaciesArgs = {
  includeUncertified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HasOfficeHolders = {
  officeHolders: OfficeHolderConnection;
};


export type HasOfficeHoldersOfficeHoldersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<OfficeHolderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OfficeHolderOrder>;
};

export type HasRaces = {
  /** Total number of races connected to this object */
  raceCount: Scalars['Int']['output'];
  races: RaceConnection;
};


export type HasRacesRacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<RaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RaceOrder>;
};

export type Headshot = {
  __typename?: 'Headshot';
  defaultUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export enum IdFilterOperator {
  /** Filtering with operator ALL should include only objects that match all provided ids */
  ALL = 'ALL',
  /** Filtering with operator ANY should include objects that match any of the provided ids */
  ANY = 'ANY'
}

/** Object linking to a person's images (headshot) */
export type ImageUrl = {
  __typename?: 'ImageUrl';
  /** Currently supported types are `default` and `thumb`. */
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** columns and relationships of "influence_targets" */
export type InfluenceTargets = {
  __typename?: 'InfluenceTargets';
  civicEngineId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  issueInfluenceTargetRels: Array<IssueInfluenceTargetRels>;
  /** An aggregate relationship */
  issueInfluenceTargetRelsAggregate: IssueInfluenceTargetRelsAggregate;
  /** An object relationship */
  jurisdiction: Jurisdictions;
  jurisdictionId: Scalars['uuid']['output'];
  /** An array relationship */
  measures: Array<Measures>;
  /** An aggregate relationship */
  measuresAggregate: MeasuresAggregate;
  /** An array relationship */
  offices: Array<Offices>;
  /** An aggregate relationship */
  officesAggregate: OfficesAggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "influence_targets" */
export type InfluenceTargetsIssueInfluenceTargetRelsArgs = {
  distinctOn?: InputMaybe<Array<IssueInfluenceTargetRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueInfluenceTargetRelsOrderBy>>;
  where?: InputMaybe<IssueInfluenceTargetRelsBoolExp>;
};


/** columns and relationships of "influence_targets" */
export type InfluenceTargetsIssueInfluenceTargetRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssueInfluenceTargetRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueInfluenceTargetRelsOrderBy>>;
  where?: InputMaybe<IssueInfluenceTargetRelsBoolExp>;
};


/** columns and relationships of "influence_targets" */
export type InfluenceTargetsMeasuresArgs = {
  distinctOn?: InputMaybe<Array<MeasuresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeasuresOrderBy>>;
  where?: InputMaybe<MeasuresBoolExp>;
};


/** columns and relationships of "influence_targets" */
export type InfluenceTargetsMeasuresAggregateArgs = {
  distinctOn?: InputMaybe<Array<MeasuresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeasuresOrderBy>>;
  where?: InputMaybe<MeasuresBoolExp>;
};


/** columns and relationships of "influence_targets" */
export type InfluenceTargetsOfficesArgs = {
  distinctOn?: InputMaybe<Array<OfficesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OfficesOrderBy>>;
  where?: InputMaybe<OfficesBoolExp>;
};


/** columns and relationships of "influence_targets" */
export type InfluenceTargetsOfficesAggregateArgs = {
  distinctOn?: InputMaybe<Array<OfficesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OfficesOrderBy>>;
  where?: InputMaybe<OfficesBoolExp>;
};

/** aggregated selection of "influence_targets" */
export type InfluenceTargetsAggregate = {
  __typename?: 'InfluenceTargetsAggregate';
  aggregate?: Maybe<InfluenceTargetsAggregateFields>;
  nodes: Array<InfluenceTargets>;
};

export type InfluenceTargetsAggregateBoolExp = {
  count?: InputMaybe<InfluenceTargetsAggregateBoolExpCount>;
};

/** aggregate fields of "influence_targets" */
export type InfluenceTargetsAggregateFields = {
  __typename?: 'InfluenceTargetsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<InfluenceTargetsMaxFields>;
  min?: Maybe<InfluenceTargetsMinFields>;
};


/** aggregate fields of "influence_targets" */
export type InfluenceTargetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InfluenceTargetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "influence_targets" */
export type InfluenceTargetsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InfluenceTargetsMaxOrderBy>;
  min?: InputMaybe<InfluenceTargetsMinOrderBy>;
};

/** input type for inserting array relation for remote table "influence_targets" */
export type InfluenceTargetsArrRelInsertInput = {
  data: Array<InfluenceTargetsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<InfluenceTargetsOnConflict>;
};

/** Boolean expression to filter rows from the table "influence_targets". All fields are combined with a logical 'AND'. */
export type InfluenceTargetsBoolExp = {
  _and?: InputMaybe<Array<InfluenceTargetsBoolExp>>;
  _not?: InputMaybe<InfluenceTargetsBoolExp>;
  _or?: InputMaybe<Array<InfluenceTargetsBoolExp>>;
  civicEngineId?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  issueInfluenceTargetRels?: InputMaybe<IssueInfluenceTargetRelsBoolExp>;
  issueInfluenceTargetRelsAggregate?: InputMaybe<IssueInfluenceTargetRelsAggregateBoolExp>;
  jurisdiction?: InputMaybe<JurisdictionsBoolExp>;
  jurisdictionId?: InputMaybe<UuidComparisonExp>;
  measures?: InputMaybe<MeasuresBoolExp>;
  measuresAggregate?: InputMaybe<MeasuresAggregateBoolExp>;
  offices?: InputMaybe<OfficesBoolExp>;
  officesAggregate?: InputMaybe<OfficesAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "influence_targets" */
export enum InfluenceTargetsConstraint {
  /** unique or primary key constraint on columns "id" */
  INFLUENCE_TARGETS_PKEY = 'influence_targets_pkey'
}

/** input type for inserting data into table "influence_targets" */
export type InfluenceTargetsInsertInput = {
  civicEngineId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issueInfluenceTargetRels?: InputMaybe<IssueInfluenceTargetRelsArrRelInsertInput>;
  jurisdiction?: InputMaybe<JurisdictionsObjRelInsertInput>;
  jurisdictionId?: InputMaybe<Scalars['uuid']['input']>;
  measures?: InputMaybe<MeasuresArrRelInsertInput>;
  offices?: InputMaybe<OfficesArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type InfluenceTargetsMaxFields = {
  __typename?: 'InfluenceTargetsMaxFields';
  civicEngineId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jurisdictionId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "influence_targets" */
export type InfluenceTargetsMaxOrderBy = {
  civicEngineId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jurisdictionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InfluenceTargetsMinFields = {
  __typename?: 'InfluenceTargetsMinFields';
  civicEngineId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jurisdictionId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "influence_targets" */
export type InfluenceTargetsMinOrderBy = {
  civicEngineId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jurisdictionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "influence_targets" */
export type InfluenceTargetsMutationResponse = {
  __typename?: 'InfluenceTargetsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<InfluenceTargets>;
};

/** input type for inserting object relation for remote table "influence_targets" */
export type InfluenceTargetsObjRelInsertInput = {
  data: InfluenceTargetsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<InfluenceTargetsOnConflict>;
};

/** on_conflict condition type for table "influence_targets" */
export type InfluenceTargetsOnConflict = {
  constraint: InfluenceTargetsConstraint;
  updateColumns?: Array<InfluenceTargetsUpdateColumn>;
  where?: InputMaybe<InfluenceTargetsBoolExp>;
};

/** Ordering options when selecting data from "influence_targets". */
export type InfluenceTargetsOrderBy = {
  civicEngineId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  issueInfluenceTargetRelsAggregate?: InputMaybe<IssueInfluenceTargetRelsAggregateOrderBy>;
  jurisdiction?: InputMaybe<JurisdictionsOrderBy>;
  jurisdictionId?: InputMaybe<OrderBy>;
  measuresAggregate?: InputMaybe<MeasuresAggregateOrderBy>;
  officesAggregate?: InputMaybe<OfficesAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: influence_targets */
export type InfluenceTargetsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "influence_targets" */
export enum InfluenceTargetsSelectColumn {
  /** column name */
  CIVICENGINEID = 'civicEngineId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  JURISDICTIONID = 'jurisdictionId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "influence_targets" */
export type InfluenceTargetsSetInput = {
  civicEngineId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictionId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "influence_targets" */
export type InfluenceTargetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InfluenceTargetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InfluenceTargetsStreamCursorValueInput = {
  civicEngineId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictionId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "influence_targets" */
export enum InfluenceTargetsUpdateColumn {
  /** column name */
  CIVICENGINEID = 'civicEngineId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  JURISDICTIONID = 'jurisdictionId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type InfluenceTargetsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InfluenceTargetsSetInput>;
  /** filter the rows which have to be updated */
  where: InfluenceTargetsBoolExp;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**
 * An issue can be something like "Economy" or "Environment" that a candidate issue statement might be in regards to,
 * or something that a position can be related to (i.e. a city council position might have the issues "Taxes/Budget" and "Infrastructure/Transportation").
 *
 */
export type Issue = DatabaseIdentifiable & Node & {
  __typename?: 'Issue';
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  expandedText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentIssue?: Maybe<Issue>;
  pluginEnabled?: Maybe<Scalars['Boolean']['output']>;
  responseType?: Maybe<Scalars['String']['output']>;
  rowOrder?: Maybe<Scalars['Int']['output']>;
};

/** The connection type for Issue. */
export type IssueConnection = {
  __typename?: 'IssueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IssueEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Issue>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IssueEdge = {
  __typename?: 'IssueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Issue>;
};

/** columns and relationships of "issue_external_link_rels" */
export type IssueExternalLinkRels = {
  __typename?: 'IssueExternalLinkRels';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  externalLink: ExternalLinks;
  externalLinkId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  issue: Issues;
  issueId: Scalars['uuid']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "issue_external_link_rels" */
export type IssueExternalLinkRelsAggregate = {
  __typename?: 'IssueExternalLinkRelsAggregate';
  aggregate?: Maybe<IssueExternalLinkRelsAggregateFields>;
  nodes: Array<IssueExternalLinkRels>;
};

export type IssueExternalLinkRelsAggregateBoolExp = {
  count?: InputMaybe<IssueExternalLinkRelsAggregateBoolExpCount>;
};

/** aggregate fields of "issue_external_link_rels" */
export type IssueExternalLinkRelsAggregateFields = {
  __typename?: 'IssueExternalLinkRelsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<IssueExternalLinkRelsMaxFields>;
  min?: Maybe<IssueExternalLinkRelsMinFields>;
};


/** aggregate fields of "issue_external_link_rels" */
export type IssueExternalLinkRelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IssueExternalLinkRelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "issue_external_link_rels" */
export type IssueExternalLinkRelsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IssueExternalLinkRelsMaxOrderBy>;
  min?: InputMaybe<IssueExternalLinkRelsMinOrderBy>;
};

/** input type for inserting array relation for remote table "issue_external_link_rels" */
export type IssueExternalLinkRelsArrRelInsertInput = {
  data: Array<IssueExternalLinkRelsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<IssueExternalLinkRelsOnConflict>;
};

/** Boolean expression to filter rows from the table "issue_external_link_rels". All fields are combined with a logical 'AND'. */
export type IssueExternalLinkRelsBoolExp = {
  _and?: InputMaybe<Array<IssueExternalLinkRelsBoolExp>>;
  _not?: InputMaybe<IssueExternalLinkRelsBoolExp>;
  _or?: InputMaybe<Array<IssueExternalLinkRelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  externalLink?: InputMaybe<ExternalLinksBoolExp>;
  externalLinkId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  issue?: InputMaybe<IssuesBoolExp>;
  issueId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "issue_external_link_rels" */
export enum IssueExternalLinkRelsConstraint {
  /** unique or primary key constraint on columns "id" */
  ISSUE_EXTERNAL_LINK_RELS_PKEY = 'issue_external_link_rels_pkey'
}

/** input type for inserting data into table "issue_external_link_rels" */
export type IssueExternalLinkRelsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  externalLink?: InputMaybe<ExternalLinksObjRelInsertInput>;
  externalLinkId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issue?: InputMaybe<IssuesObjRelInsertInput>;
  issueId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type IssueExternalLinkRelsMaxFields = {
  __typename?: 'IssueExternalLinkRelsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  externalLinkId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  issueId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "issue_external_link_rels" */
export type IssueExternalLinkRelsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  externalLinkId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  issueId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IssueExternalLinkRelsMinFields = {
  __typename?: 'IssueExternalLinkRelsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  externalLinkId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  issueId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "issue_external_link_rels" */
export type IssueExternalLinkRelsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  externalLinkId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  issueId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "issue_external_link_rels" */
export type IssueExternalLinkRelsMutationResponse = {
  __typename?: 'IssueExternalLinkRelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<IssueExternalLinkRels>;
};

/** on_conflict condition type for table "issue_external_link_rels" */
export type IssueExternalLinkRelsOnConflict = {
  constraint: IssueExternalLinkRelsConstraint;
  updateColumns?: Array<IssueExternalLinkRelsUpdateColumn>;
  where?: InputMaybe<IssueExternalLinkRelsBoolExp>;
};

/** Ordering options when selecting data from "issue_external_link_rels". */
export type IssueExternalLinkRelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  externalLink?: InputMaybe<ExternalLinksOrderBy>;
  externalLinkId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  issue?: InputMaybe<IssuesOrderBy>;
  issueId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: issue_external_link_rels */
export type IssueExternalLinkRelsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "issue_external_link_rels" */
export enum IssueExternalLinkRelsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  EXTERNALLINKID = 'externalLinkId',
  /** column name */
  ID = 'id',
  /** column name */
  ISSUEID = 'issueId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "issue_external_link_rels" */
export type IssueExternalLinkRelsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  externalLinkId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issueId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "issue_external_link_rels" */
export type IssueExternalLinkRelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IssueExternalLinkRelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IssueExternalLinkRelsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  externalLinkId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issueId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "issue_external_link_rels" */
export enum IssueExternalLinkRelsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  EXTERNALLINKID = 'externalLinkId',
  /** column name */
  ID = 'id',
  /** column name */
  ISSUEID = 'issueId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type IssueExternalLinkRelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IssueExternalLinkRelsSetInput>;
  /** filter the rows which have to be updated */
  where: IssueExternalLinkRelsBoolExp;
};

/** Options for ID based filtering. */
export type IssueIdFilter = {
  id: Array<Scalars['ID']['input']>;
  operator: IdFilterOperator;
};

/** columns and relationships of "issue_influence_target_rels" */
export type IssueInfluenceTargetRels = {
  __typename?: 'IssueInfluenceTargetRels';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  influenceTarget: InfluenceTargets;
  influenceTargetId: Scalars['uuid']['output'];
  /** An object relationship */
  issue: Issues;
  issueId: Scalars['uuid']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsAggregate = {
  __typename?: 'IssueInfluenceTargetRelsAggregate';
  aggregate?: Maybe<IssueInfluenceTargetRelsAggregateFields>;
  nodes: Array<IssueInfluenceTargetRels>;
};

export type IssueInfluenceTargetRelsAggregateBoolExp = {
  count?: InputMaybe<IssueInfluenceTargetRelsAggregateBoolExpCount>;
};

/** aggregate fields of "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsAggregateFields = {
  __typename?: 'IssueInfluenceTargetRelsAggregateFields';
  avg?: Maybe<IssueInfluenceTargetRelsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<IssueInfluenceTargetRelsMaxFields>;
  min?: Maybe<IssueInfluenceTargetRelsMinFields>;
  stddev?: Maybe<IssueInfluenceTargetRelsStddevFields>;
  stddevPop?: Maybe<IssueInfluenceTargetRelsStddevPopFields>;
  stddevSamp?: Maybe<IssueInfluenceTargetRelsStddevSampFields>;
  sum?: Maybe<IssueInfluenceTargetRelsSumFields>;
  varPop?: Maybe<IssueInfluenceTargetRelsVarPopFields>;
  varSamp?: Maybe<IssueInfluenceTargetRelsVarSampFields>;
  variance?: Maybe<IssueInfluenceTargetRelsVarianceFields>;
};


/** aggregate fields of "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IssueInfluenceTargetRelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsAggregateOrderBy = {
  avg?: InputMaybe<IssueInfluenceTargetRelsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IssueInfluenceTargetRelsMaxOrderBy>;
  min?: InputMaybe<IssueInfluenceTargetRelsMinOrderBy>;
  stddev?: InputMaybe<IssueInfluenceTargetRelsStddevOrderBy>;
  stddevPop?: InputMaybe<IssueInfluenceTargetRelsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<IssueInfluenceTargetRelsStddevSampOrderBy>;
  sum?: InputMaybe<IssueInfluenceTargetRelsSumOrderBy>;
  varPop?: InputMaybe<IssueInfluenceTargetRelsVarPopOrderBy>;
  varSamp?: InputMaybe<IssueInfluenceTargetRelsVarSampOrderBy>;
  variance?: InputMaybe<IssueInfluenceTargetRelsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsArrRelInsertInput = {
  data: Array<IssueInfluenceTargetRelsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<IssueInfluenceTargetRelsOnConflict>;
};

/** aggregate avg on columns */
export type IssueInfluenceTargetRelsAvgFields = {
  __typename?: 'IssueInfluenceTargetRelsAvgFields';
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsAvgOrderBy = {
  weight?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "issue_influence_target_rels". All fields are combined with a logical 'AND'. */
export type IssueInfluenceTargetRelsBoolExp = {
  _and?: InputMaybe<Array<IssueInfluenceTargetRelsBoolExp>>;
  _not?: InputMaybe<IssueInfluenceTargetRelsBoolExp>;
  _or?: InputMaybe<Array<IssueInfluenceTargetRelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  influenceTarget?: InputMaybe<InfluenceTargetsBoolExp>;
  influenceTargetId?: InputMaybe<UuidComparisonExp>;
  issue?: InputMaybe<IssuesBoolExp>;
  issueId?: InputMaybe<UuidComparisonExp>;
  subtitle?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  weight?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "issue_influence_target_rels" */
export enum IssueInfluenceTargetRelsConstraint {
  /** unique or primary key constraint on columns "id" */
  SWAY_SCORES_PKEY = 'sway_scores_pkey'
}

/** input type for incrementing numeric columns in table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsIncInput = {
  weight?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  influenceTarget?: InputMaybe<InfluenceTargetsObjRelInsertInput>;
  influenceTargetId?: InputMaybe<Scalars['uuid']['input']>;
  issue?: InputMaybe<IssuesObjRelInsertInput>;
  issueId?: InputMaybe<Scalars['uuid']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type IssueInfluenceTargetRelsMaxFields = {
  __typename?: 'IssueInfluenceTargetRelsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  influenceTargetId?: Maybe<Scalars['uuid']['output']>;
  issueId?: Maybe<Scalars['uuid']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  influenceTargetId?: InputMaybe<OrderBy>;
  issueId?: InputMaybe<OrderBy>;
  subtitle?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  weight?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IssueInfluenceTargetRelsMinFields = {
  __typename?: 'IssueInfluenceTargetRelsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  influenceTargetId?: Maybe<Scalars['uuid']['output']>;
  issueId?: Maybe<Scalars['uuid']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  influenceTargetId?: InputMaybe<OrderBy>;
  issueId?: InputMaybe<OrderBy>;
  subtitle?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  weight?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsMutationResponse = {
  __typename?: 'IssueInfluenceTargetRelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<IssueInfluenceTargetRels>;
};

/** on_conflict condition type for table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsOnConflict = {
  constraint: IssueInfluenceTargetRelsConstraint;
  updateColumns?: Array<IssueInfluenceTargetRelsUpdateColumn>;
  where?: InputMaybe<IssueInfluenceTargetRelsBoolExp>;
};

/** Ordering options when selecting data from "issue_influence_target_rels". */
export type IssueInfluenceTargetRelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  influenceTarget?: InputMaybe<InfluenceTargetsOrderBy>;
  influenceTargetId?: InputMaybe<OrderBy>;
  issue?: InputMaybe<IssuesOrderBy>;
  issueId?: InputMaybe<OrderBy>;
  subtitle?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  weight?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: issue_influence_target_rels */
export type IssueInfluenceTargetRelsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "issue_influence_target_rels" */
export enum IssueInfluenceTargetRelsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  INFLUENCETARGETID = 'influenceTargetId',
  /** column name */
  ISSUEID = 'issueId',
  /** column name */
  SUBTITLE = 'subtitle',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WEIGHT = 'weight'
}

/** input type for updating data in table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  influenceTargetId?: InputMaybe<Scalars['uuid']['input']>;
  issueId?: InputMaybe<Scalars['uuid']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type IssueInfluenceTargetRelsStddevFields = {
  __typename?: 'IssueInfluenceTargetRelsStddevFields';
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsStddevOrderBy = {
  weight?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type IssueInfluenceTargetRelsStddevPopFields = {
  __typename?: 'IssueInfluenceTargetRelsStddevPopFields';
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsStddevPopOrderBy = {
  weight?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type IssueInfluenceTargetRelsStddevSampFields = {
  __typename?: 'IssueInfluenceTargetRelsStddevSampFields';
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsStddevSampOrderBy = {
  weight?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IssueInfluenceTargetRelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IssueInfluenceTargetRelsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  influenceTargetId?: InputMaybe<Scalars['uuid']['input']>;
  issueId?: InputMaybe<Scalars['uuid']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type IssueInfluenceTargetRelsSumFields = {
  __typename?: 'IssueInfluenceTargetRelsSumFields';
  weight?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsSumOrderBy = {
  weight?: InputMaybe<OrderBy>;
};

/** update columns of table "issue_influence_target_rels" */
export enum IssueInfluenceTargetRelsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  INFLUENCETARGETID = 'influenceTargetId',
  /** column name */
  ISSUEID = 'issueId',
  /** column name */
  SUBTITLE = 'subtitle',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WEIGHT = 'weight'
}

export type IssueInfluenceTargetRelsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IssueInfluenceTargetRelsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IssueInfluenceTargetRelsSetInput>;
  /** filter the rows which have to be updated */
  where: IssueInfluenceTargetRelsBoolExp;
};

/** aggregate varPop on columns */
export type IssueInfluenceTargetRelsVarPopFields = {
  __typename?: 'IssueInfluenceTargetRelsVarPopFields';
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsVarPopOrderBy = {
  weight?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type IssueInfluenceTargetRelsVarSampFields = {
  __typename?: 'IssueInfluenceTargetRelsVarSampFields';
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsVarSampOrderBy = {
  weight?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type IssueInfluenceTargetRelsVarianceFields = {
  __typename?: 'IssueInfluenceTargetRelsVarianceFields';
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "issue_influence_target_rels" */
export type IssueInfluenceTargetRelsVarianceOrderBy = {
  weight?: InputMaybe<OrderBy>;
};

/** columns and relationships of "issue_media_rels" */
export type IssueMediaRels = {
  __typename?: 'IssueMediaRels';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  issue: Issues;
  issueId: Scalars['uuid']['output'];
  mediaId: Scalars['uuid']['output'];
  /** An object relationship */
  medium: Media;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "issue_media_rels" */
export type IssueMediaRelsAggregate = {
  __typename?: 'IssueMediaRelsAggregate';
  aggregate?: Maybe<IssueMediaRelsAggregateFields>;
  nodes: Array<IssueMediaRels>;
};

export type IssueMediaRelsAggregateBoolExp = {
  count?: InputMaybe<IssueMediaRelsAggregateBoolExpCount>;
};

/** aggregate fields of "issue_media_rels" */
export type IssueMediaRelsAggregateFields = {
  __typename?: 'IssueMediaRelsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<IssueMediaRelsMaxFields>;
  min?: Maybe<IssueMediaRelsMinFields>;
};


/** aggregate fields of "issue_media_rels" */
export type IssueMediaRelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IssueMediaRelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "issue_media_rels" */
export type IssueMediaRelsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IssueMediaRelsMaxOrderBy>;
  min?: InputMaybe<IssueMediaRelsMinOrderBy>;
};

/** input type for inserting array relation for remote table "issue_media_rels" */
export type IssueMediaRelsArrRelInsertInput = {
  data: Array<IssueMediaRelsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<IssueMediaRelsOnConflict>;
};

/** Boolean expression to filter rows from the table "issue_media_rels". All fields are combined with a logical 'AND'. */
export type IssueMediaRelsBoolExp = {
  _and?: InputMaybe<Array<IssueMediaRelsBoolExp>>;
  _not?: InputMaybe<IssueMediaRelsBoolExp>;
  _or?: InputMaybe<Array<IssueMediaRelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  issue?: InputMaybe<IssuesBoolExp>;
  issueId?: InputMaybe<UuidComparisonExp>;
  mediaId?: InputMaybe<UuidComparisonExp>;
  medium?: InputMaybe<MediaBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "issue_media_rels" */
export enum IssueMediaRelsConstraint {
  /** unique or primary key constraint on columns "issue_id", "media_id" */
  ISSUE_MEDIA_RELS_ISSUE_ID_MEDIA_ID_KEY = 'issue_media_rels_issue_id_media_id_key',
  /** unique or primary key constraint on columns "id" */
  ISSUE_MEDIA_RELS_PKEY = 'issue_media_rels_pkey'
}

/** input type for inserting data into table "issue_media_rels" */
export type IssueMediaRelsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issue?: InputMaybe<IssuesObjRelInsertInput>;
  issueId?: InputMaybe<Scalars['uuid']['input']>;
  mediaId?: InputMaybe<Scalars['uuid']['input']>;
  medium?: InputMaybe<MediaObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type IssueMediaRelsMaxFields = {
  __typename?: 'IssueMediaRelsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  issueId?: Maybe<Scalars['uuid']['output']>;
  mediaId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "issue_media_rels" */
export type IssueMediaRelsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  issueId?: InputMaybe<OrderBy>;
  mediaId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IssueMediaRelsMinFields = {
  __typename?: 'IssueMediaRelsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  issueId?: Maybe<Scalars['uuid']['output']>;
  mediaId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "issue_media_rels" */
export type IssueMediaRelsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  issueId?: InputMaybe<OrderBy>;
  mediaId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "issue_media_rels" */
export type IssueMediaRelsMutationResponse = {
  __typename?: 'IssueMediaRelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<IssueMediaRels>;
};

/** on_conflict condition type for table "issue_media_rels" */
export type IssueMediaRelsOnConflict = {
  constraint: IssueMediaRelsConstraint;
  updateColumns?: Array<IssueMediaRelsUpdateColumn>;
  where?: InputMaybe<IssueMediaRelsBoolExp>;
};

/** Ordering options when selecting data from "issue_media_rels". */
export type IssueMediaRelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  issue?: InputMaybe<IssuesOrderBy>;
  issueId?: InputMaybe<OrderBy>;
  mediaId?: InputMaybe<OrderBy>;
  medium?: InputMaybe<MediaOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: issue_media_rels */
export type IssueMediaRelsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "issue_media_rels" */
export enum IssueMediaRelsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISSUEID = 'issueId',
  /** column name */
  MEDIAID = 'mediaId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "issue_media_rels" */
export type IssueMediaRelsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issueId?: InputMaybe<Scalars['uuid']['input']>;
  mediaId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "issue_media_rels" */
export type IssueMediaRelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IssueMediaRelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IssueMediaRelsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issueId?: InputMaybe<Scalars['uuid']['input']>;
  mediaId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "issue_media_rels" */
export enum IssueMediaRelsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISSUEID = 'issueId',
  /** column name */
  MEDIAID = 'mediaId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type IssueMediaRelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IssueMediaRelsSetInput>;
  /** filter the rows which have to be updated */
  where: IssueMediaRelsBoolExp;
};

/** columns and relationships of "issue_supporter_rels" */
export type IssueSupporterRels = {
  __typename?: 'IssueSupporterRels';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  entity?: Maybe<Entities>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  issue: Issues;
  issueId: Scalars['uuid']['output'];
  supporterId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "issue_supporter_rels" */
export type IssueSupporterRelsAggregate = {
  __typename?: 'IssueSupporterRelsAggregate';
  aggregate?: Maybe<IssueSupporterRelsAggregateFields>;
  nodes: Array<IssueSupporterRels>;
};

export type IssueSupporterRelsAggregateBoolExp = {
  count?: InputMaybe<IssueSupporterRelsAggregateBoolExpCount>;
};

/** aggregate fields of "issue_supporter_rels" */
export type IssueSupporterRelsAggregateFields = {
  __typename?: 'IssueSupporterRelsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<IssueSupporterRelsMaxFields>;
  min?: Maybe<IssueSupporterRelsMinFields>;
};


/** aggregate fields of "issue_supporter_rels" */
export type IssueSupporterRelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IssueSupporterRelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "issue_supporter_rels" */
export type IssueSupporterRelsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IssueSupporterRelsMaxOrderBy>;
  min?: InputMaybe<IssueSupporterRelsMinOrderBy>;
};

/** input type for inserting array relation for remote table "issue_supporter_rels" */
export type IssueSupporterRelsArrRelInsertInput = {
  data: Array<IssueSupporterRelsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<IssueSupporterRelsOnConflict>;
};

/** Boolean expression to filter rows from the table "issue_supporter_rels". All fields are combined with a logical 'AND'. */
export type IssueSupporterRelsBoolExp = {
  _and?: InputMaybe<Array<IssueSupporterRelsBoolExp>>;
  _not?: InputMaybe<IssueSupporterRelsBoolExp>;
  _or?: InputMaybe<Array<IssueSupporterRelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  entity?: InputMaybe<EntitiesBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  issue?: InputMaybe<IssuesBoolExp>;
  issueId?: InputMaybe<UuidComparisonExp>;
  supporterId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "issue_supporter_rels" */
export enum IssueSupporterRelsConstraint {
  /** unique or primary key constraint on columns "issue_id", "supporter_id" */
  ISSUE_SUPPORTER_RELS_ISSUE_ID_SUPPORTER_ID_KEY = 'issue_supporter_rels_issue_id_supporter_id_key',
  /** unique or primary key constraint on columns "id" */
  ISSUE_SUPPORTER_RELS_PKEY = 'issue_supporter_rels_pkey'
}

/** input type for inserting data into table "issue_supporter_rels" */
export type IssueSupporterRelsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entity?: InputMaybe<EntitiesObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issue?: InputMaybe<IssuesObjRelInsertInput>;
  issueId?: InputMaybe<Scalars['uuid']['input']>;
  supporterId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type IssueSupporterRelsMaxFields = {
  __typename?: 'IssueSupporterRelsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  issueId?: Maybe<Scalars['uuid']['output']>;
  supporterId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "issue_supporter_rels" */
export type IssueSupporterRelsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  issueId?: InputMaybe<OrderBy>;
  supporterId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IssueSupporterRelsMinFields = {
  __typename?: 'IssueSupporterRelsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  issueId?: Maybe<Scalars['uuid']['output']>;
  supporterId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "issue_supporter_rels" */
export type IssueSupporterRelsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  issueId?: InputMaybe<OrderBy>;
  supporterId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "issue_supporter_rels" */
export type IssueSupporterRelsMutationResponse = {
  __typename?: 'IssueSupporterRelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<IssueSupporterRels>;
};

/** on_conflict condition type for table "issue_supporter_rels" */
export type IssueSupporterRelsOnConflict = {
  constraint: IssueSupporterRelsConstraint;
  updateColumns?: Array<IssueSupporterRelsUpdateColumn>;
  where?: InputMaybe<IssueSupporterRelsBoolExp>;
};

/** Ordering options when selecting data from "issue_supporter_rels". */
export type IssueSupporterRelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  entity?: InputMaybe<EntitiesOrderBy>;
  id?: InputMaybe<OrderBy>;
  issue?: InputMaybe<IssuesOrderBy>;
  issueId?: InputMaybe<OrderBy>;
  supporterId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: issue_supporter_rels */
export type IssueSupporterRelsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "issue_supporter_rels" */
export enum IssueSupporterRelsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISSUEID = 'issueId',
  /** column name */
  SUPPORTERID = 'supporterId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "issue_supporter_rels" */
export type IssueSupporterRelsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issueId?: InputMaybe<Scalars['uuid']['input']>;
  supporterId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "issue_supporter_rels" */
export type IssueSupporterRelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IssueSupporterRelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IssueSupporterRelsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issueId?: InputMaybe<Scalars['uuid']['input']>;
  supporterId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "issue_supporter_rels" */
export enum IssueSupporterRelsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISSUEID = 'issueId',
  /** column name */
  SUPPORTERID = 'supporterId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type IssueSupporterRelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IssueSupporterRelsSetInput>;
  /** filter the rows which have to be updated */
  where: IssueSupporterRelsBoolExp;
};

/** columns and relationships of "issues" */
export type Issues = {
  __typename?: 'Issues';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isActive: Scalars['Boolean']['output'];
  /** An array relationship */
  issueExternalLinkRels: Array<IssueExternalLinkRels>;
  /** An aggregate relationship */
  issueExternalLinkRelsAggregate: IssueExternalLinkRelsAggregate;
  /** An array relationship */
  issueInfluenceTargetRels: Array<IssueInfluenceTargetRels>;
  /** An aggregate relationship */
  issueInfluenceTargetRelsAggregate: IssueInfluenceTargetRelsAggregate;
  /** An array relationship */
  issueMediaRels: Array<IssueMediaRels>;
  /** An aggregate relationship */
  issueMediaRelsAggregate: IssueMediaRelsAggregate;
  /** An array relationship */
  issueSupporterRels: Array<IssueSupporterRels>;
  /** An aggregate relationship */
  issueSupporterRelsAggregate: IssueSupporterRelsAggregate;
  /** An object relationship */
  leader: Entities;
  leaderId: Scalars['uuid']['output'];
  location?: Maybe<Scalars['String']['output']>;
  slogan?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "get_issue_supporter_count" */
  supporterCount?: Maybe<Scalars['Int']['output']>;
  topic: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** A computed field, executes function "get_verified_supporter_count" */
  verifiedSupporterCount?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "issues" */
export type IssuesIssueExternalLinkRelsArgs = {
  distinctOn?: InputMaybe<Array<IssueExternalLinkRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueExternalLinkRelsOrderBy>>;
  where?: InputMaybe<IssueExternalLinkRelsBoolExp>;
};


/** columns and relationships of "issues" */
export type IssuesIssueExternalLinkRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssueExternalLinkRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueExternalLinkRelsOrderBy>>;
  where?: InputMaybe<IssueExternalLinkRelsBoolExp>;
};


/** columns and relationships of "issues" */
export type IssuesIssueInfluenceTargetRelsArgs = {
  distinctOn?: InputMaybe<Array<IssueInfluenceTargetRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueInfluenceTargetRelsOrderBy>>;
  where?: InputMaybe<IssueInfluenceTargetRelsBoolExp>;
};


/** columns and relationships of "issues" */
export type IssuesIssueInfluenceTargetRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssueInfluenceTargetRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueInfluenceTargetRelsOrderBy>>;
  where?: InputMaybe<IssueInfluenceTargetRelsBoolExp>;
};


/** columns and relationships of "issues" */
export type IssuesIssueMediaRelsArgs = {
  distinctOn?: InputMaybe<Array<IssueMediaRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueMediaRelsOrderBy>>;
  where?: InputMaybe<IssueMediaRelsBoolExp>;
};


/** columns and relationships of "issues" */
export type IssuesIssueMediaRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssueMediaRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueMediaRelsOrderBy>>;
  where?: InputMaybe<IssueMediaRelsBoolExp>;
};


/** columns and relationships of "issues" */
export type IssuesIssueSupporterRelsArgs = {
  distinctOn?: InputMaybe<Array<IssueSupporterRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueSupporterRelsOrderBy>>;
  where?: InputMaybe<IssueSupporterRelsBoolExp>;
};


/** columns and relationships of "issues" */
export type IssuesIssueSupporterRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssueSupporterRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueSupporterRelsOrderBy>>;
  where?: InputMaybe<IssueSupporterRelsBoolExp>;
};

/** aggregated selection of "issues" */
export type IssuesAggregate = {
  __typename?: 'IssuesAggregate';
  aggregate?: Maybe<IssuesAggregateFields>;
  nodes: Array<Issues>;
};

export type IssuesAggregateBoolExp = {
  bool_and?: InputMaybe<IssuesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<IssuesAggregateBoolExpBool_Or>;
  count?: InputMaybe<IssuesAggregateBoolExpCount>;
};

/** aggregate fields of "issues" */
export type IssuesAggregateFields = {
  __typename?: 'IssuesAggregateFields';
  avg?: Maybe<IssuesAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<IssuesMaxFields>;
  min?: Maybe<IssuesMinFields>;
  stddev?: Maybe<IssuesStddevFields>;
  stddevPop?: Maybe<IssuesStddevPopFields>;
  stddevSamp?: Maybe<IssuesStddevSampFields>;
  sum?: Maybe<IssuesSumFields>;
  varPop?: Maybe<IssuesVarPopFields>;
  varSamp?: Maybe<IssuesVarSampFields>;
  variance?: Maybe<IssuesVarianceFields>;
};


/** aggregate fields of "issues" */
export type IssuesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IssuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "issues" */
export type IssuesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IssuesMaxOrderBy>;
  min?: InputMaybe<IssuesMinOrderBy>;
};

/** input type for inserting array relation for remote table "issues" */
export type IssuesArrRelInsertInput = {
  data: Array<IssuesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<IssuesOnConflict>;
};

/** aggregate avg on columns */
export type IssuesAvgFields = {
  __typename?: 'IssuesAvgFields';
  /** A computed field, executes function "get_issue_supporter_count" */
  supporterCount?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "get_verified_supporter_count" */
  verifiedSupporterCount?: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to filter rows from the table "issues". All fields are combined with a logical 'AND'. */
export type IssuesBoolExp = {
  _and?: InputMaybe<Array<IssuesBoolExp>>;
  _not?: InputMaybe<IssuesBoolExp>;
  _or?: InputMaybe<Array<IssuesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  issueExternalLinkRels?: InputMaybe<IssueExternalLinkRelsBoolExp>;
  issueExternalLinkRelsAggregate?: InputMaybe<IssueExternalLinkRelsAggregateBoolExp>;
  issueInfluenceTargetRels?: InputMaybe<IssueInfluenceTargetRelsBoolExp>;
  issueInfluenceTargetRelsAggregate?: InputMaybe<IssueInfluenceTargetRelsAggregateBoolExp>;
  issueMediaRels?: InputMaybe<IssueMediaRelsBoolExp>;
  issueMediaRelsAggregate?: InputMaybe<IssueMediaRelsAggregateBoolExp>;
  issueSupporterRels?: InputMaybe<IssueSupporterRelsBoolExp>;
  issueSupporterRelsAggregate?: InputMaybe<IssueSupporterRelsAggregateBoolExp>;
  leader?: InputMaybe<EntitiesBoolExp>;
  leaderId?: InputMaybe<UuidComparisonExp>;
  location?: InputMaybe<StringComparisonExp>;
  slogan?: InputMaybe<StringComparisonExp>;
  summary?: InputMaybe<StringComparisonExp>;
  supporterCount?: InputMaybe<IntComparisonExp>;
  topic?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  verifiedSupporterCount?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "issues" */
export enum IssuesConstraint {
  /** unique or primary key constraint on columns "id" */
  ISSUES_PKEY = 'issues_pkey'
}

/** input type for inserting data into table "issues" */
export type IssuesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  issueExternalLinkRels?: InputMaybe<IssueExternalLinkRelsArrRelInsertInput>;
  issueInfluenceTargetRels?: InputMaybe<IssueInfluenceTargetRelsArrRelInsertInput>;
  issueMediaRels?: InputMaybe<IssueMediaRelsArrRelInsertInput>;
  issueSupporterRels?: InputMaybe<IssueSupporterRelsArrRelInsertInput>;
  leader?: InputMaybe<EntitiesObjRelInsertInput>;
  leaderId?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  slogan?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type IssuesMaxFields = {
  __typename?: 'IssuesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  leaderId?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  slogan?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "get_issue_supporter_count" */
  supporterCount?: Maybe<Scalars['Int']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "get_verified_supporter_count" */
  verifiedSupporterCount?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "issues" */
export type IssuesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  leaderId?: InputMaybe<OrderBy>;
  location?: InputMaybe<OrderBy>;
  slogan?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  topic?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IssuesMinFields = {
  __typename?: 'IssuesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  leaderId?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  slogan?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "get_issue_supporter_count" */
  supporterCount?: Maybe<Scalars['Int']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "get_verified_supporter_count" */
  verifiedSupporterCount?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "issues" */
export type IssuesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  leaderId?: InputMaybe<OrderBy>;
  location?: InputMaybe<OrderBy>;
  slogan?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  topic?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "issues" */
export type IssuesMutationResponse = {
  __typename?: 'IssuesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Issues>;
};

/** input type for inserting object relation for remote table "issues" */
export type IssuesObjRelInsertInput = {
  data: IssuesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<IssuesOnConflict>;
};

/** on_conflict condition type for table "issues" */
export type IssuesOnConflict = {
  constraint: IssuesConstraint;
  updateColumns?: Array<IssuesUpdateColumn>;
  where?: InputMaybe<IssuesBoolExp>;
};

/** Ordering options when selecting data from "issues". */
export type IssuesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  issueExternalLinkRelsAggregate?: InputMaybe<IssueExternalLinkRelsAggregateOrderBy>;
  issueInfluenceTargetRelsAggregate?: InputMaybe<IssueInfluenceTargetRelsAggregateOrderBy>;
  issueMediaRelsAggregate?: InputMaybe<IssueMediaRelsAggregateOrderBy>;
  issueSupporterRelsAggregate?: InputMaybe<IssueSupporterRelsAggregateOrderBy>;
  leader?: InputMaybe<EntitiesOrderBy>;
  leaderId?: InputMaybe<OrderBy>;
  location?: InputMaybe<OrderBy>;
  slogan?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  supporterCount?: InputMaybe<OrderBy>;
  topic?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  verifiedSupporterCount?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: issues */
export type IssuesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "issues" */
export enum IssuesSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISACTIVE = 'isActive',
  /** column name */
  LEADERID = 'leaderId',
  /** column name */
  LOCATION = 'location',
  /** column name */
  SLOGAN = 'slogan',
  /** column name */
  SUMMARY = 'summary',
  /** column name */
  TOPIC = 'topic',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** select "issuesAggregateBoolExpBool_andArgumentsColumns" columns of table "issues" */
export enum IssuesSelectColumnIssuesAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  ISACTIVE = 'isActive'
}

/** select "issuesAggregateBoolExpBool_orArgumentsColumns" columns of table "issues" */
export enum IssuesSelectColumnIssuesAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  ISACTIVE = 'isActive'
}

/** input type for updating data in table "issues" */
export type IssuesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  leaderId?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  slogan?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type IssuesStddevFields = {
  __typename?: 'IssuesStddevFields';
  /** A computed field, executes function "get_issue_supporter_count" */
  supporterCount?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "get_verified_supporter_count" */
  verifiedSupporterCount?: Maybe<Scalars['Int']['output']>;
};

/** aggregate stddevPop on columns */
export type IssuesStddevPopFields = {
  __typename?: 'IssuesStddevPopFields';
  /** A computed field, executes function "get_issue_supporter_count" */
  supporterCount?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "get_verified_supporter_count" */
  verifiedSupporterCount?: Maybe<Scalars['Int']['output']>;
};

/** aggregate stddevSamp on columns */
export type IssuesStddevSampFields = {
  __typename?: 'IssuesStddevSampFields';
  /** A computed field, executes function "get_issue_supporter_count" */
  supporterCount?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "get_verified_supporter_count" */
  verifiedSupporterCount?: Maybe<Scalars['Int']['output']>;
};

/** Streaming cursor of the table "issues" */
export type IssuesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IssuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IssuesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  leaderId?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  slogan?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type IssuesSumFields = {
  __typename?: 'IssuesSumFields';
  /** A computed field, executes function "get_issue_supporter_count" */
  supporterCount?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "get_verified_supporter_count" */
  verifiedSupporterCount?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "issues" */
export enum IssuesUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISACTIVE = 'isActive',
  /** column name */
  LEADERID = 'leaderId',
  /** column name */
  LOCATION = 'location',
  /** column name */
  SLOGAN = 'slogan',
  /** column name */
  SUMMARY = 'summary',
  /** column name */
  TOPIC = 'topic',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type IssuesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IssuesSetInput>;
  /** filter the rows which have to be updated */
  where: IssuesBoolExp;
};

/** aggregate varPop on columns */
export type IssuesVarPopFields = {
  __typename?: 'IssuesVarPopFields';
  /** A computed field, executes function "get_issue_supporter_count" */
  supporterCount?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "get_verified_supporter_count" */
  verifiedSupporterCount?: Maybe<Scalars['Int']['output']>;
};

/** aggregate varSamp on columns */
export type IssuesVarSampFields = {
  __typename?: 'IssuesVarSampFields';
  /** A computed field, executes function "get_issue_supporter_count" */
  supporterCount?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "get_verified_supporter_count" */
  verifiedSupporterCount?: Maybe<Scalars['Int']['output']>;
};

/** aggregate variance on columns */
export type IssuesVarianceFields = {
  __typename?: 'IssuesVarianceFields';
  /** A computed field, executes function "get_issue_supporter_count" */
  supporterCount?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "get_verified_supporter_count" */
  verifiedSupporterCount?: Maybe<Scalars['Int']['output']>;
};

/** columns and relationships of "jurisdictions" */
export type Jurisdictions = {
  __typename?: 'Jurisdictions';
  createdAt: Scalars['timestamptz']['output'];
  geoid?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  influenceTargets: Array<InfluenceTargets>;
  /** An aggregate relationship */
  influenceTargetsAggregate: InfluenceTargetsAggregate;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  voterVerificationJurisdictionRels: Array<VoterVerificationJurisdictionRels>;
  /** An aggregate relationship */
  voterVerificationJurisdictionRelsAggregate: VoterVerificationJurisdictionRelsAggregate;
};


/** columns and relationships of "jurisdictions" */
export type JurisdictionsInfluenceTargetsArgs = {
  distinctOn?: InputMaybe<Array<InfluenceTargetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InfluenceTargetsOrderBy>>;
  where?: InputMaybe<InfluenceTargetsBoolExp>;
};


/** columns and relationships of "jurisdictions" */
export type JurisdictionsInfluenceTargetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InfluenceTargetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InfluenceTargetsOrderBy>>;
  where?: InputMaybe<InfluenceTargetsBoolExp>;
};


/** columns and relationships of "jurisdictions" */
export type JurisdictionsVoterVerificationJurisdictionRelsArgs = {
  distinctOn?: InputMaybe<Array<VoterVerificationJurisdictionRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoterVerificationJurisdictionRelsOrderBy>>;
  where?: InputMaybe<VoterVerificationJurisdictionRelsBoolExp>;
};


/** columns and relationships of "jurisdictions" */
export type JurisdictionsVoterVerificationJurisdictionRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VoterVerificationJurisdictionRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoterVerificationJurisdictionRelsOrderBy>>;
  where?: InputMaybe<VoterVerificationJurisdictionRelsBoolExp>;
};

/** aggregated selection of "jurisdictions" */
export type JurisdictionsAggregate = {
  __typename?: 'JurisdictionsAggregate';
  aggregate?: Maybe<JurisdictionsAggregateFields>;
  nodes: Array<Jurisdictions>;
};

/** aggregate fields of "jurisdictions" */
export type JurisdictionsAggregateFields = {
  __typename?: 'JurisdictionsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<JurisdictionsMaxFields>;
  min?: Maybe<JurisdictionsMinFields>;
};


/** aggregate fields of "jurisdictions" */
export type JurisdictionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JurisdictionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "jurisdictions". All fields are combined with a logical 'AND'. */
export type JurisdictionsBoolExp = {
  _and?: InputMaybe<Array<JurisdictionsBoolExp>>;
  _not?: InputMaybe<JurisdictionsBoolExp>;
  _or?: InputMaybe<Array<JurisdictionsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  geoid?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  influenceTargets?: InputMaybe<InfluenceTargetsBoolExp>;
  influenceTargetsAggregate?: InputMaybe<InfluenceTargetsAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  voterVerificationJurisdictionRels?: InputMaybe<VoterVerificationJurisdictionRelsBoolExp>;
  voterVerificationJurisdictionRelsAggregate?: InputMaybe<VoterVerificationJurisdictionRelsAggregateBoolExp>;
};

/** unique or primary key constraints on table "jurisdictions" */
export enum JurisdictionsConstraint {
  /** unique or primary key constraint on columns "geoid" */
  JURISDICTIONS_GEOID_KEY = 'jurisdictions_geoid_key',
  /** unique or primary key constraint on columns "id" */
  JURISDICTIONS_PKEY = 'jurisdictions_pkey'
}

/** input type for inserting data into table "jurisdictions" */
export type JurisdictionsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  geoid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  influenceTargets?: InputMaybe<InfluenceTargetsArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  voterVerificationJurisdictionRels?: InputMaybe<VoterVerificationJurisdictionRelsArrRelInsertInput>;
};

/** aggregate max on columns */
export type JurisdictionsMaxFields = {
  __typename?: 'JurisdictionsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  geoid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type JurisdictionsMinFields = {
  __typename?: 'JurisdictionsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  geoid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "jurisdictions" */
export type JurisdictionsMutationResponse = {
  __typename?: 'JurisdictionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Jurisdictions>;
};

/** input type for inserting object relation for remote table "jurisdictions" */
export type JurisdictionsObjRelInsertInput = {
  data: JurisdictionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<JurisdictionsOnConflict>;
};

/** on_conflict condition type for table "jurisdictions" */
export type JurisdictionsOnConflict = {
  constraint: JurisdictionsConstraint;
  updateColumns?: Array<JurisdictionsUpdateColumn>;
  where?: InputMaybe<JurisdictionsBoolExp>;
};

/** Ordering options when selecting data from "jurisdictions". */
export type JurisdictionsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  geoid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  influenceTargetsAggregate?: InputMaybe<InfluenceTargetsAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  voterVerificationJurisdictionRelsAggregate?: InputMaybe<VoterVerificationJurisdictionRelsAggregateOrderBy>;
};

/** primary key columns input for table: jurisdictions */
export type JurisdictionsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "jurisdictions" */
export enum JurisdictionsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  GEOID = 'geoid',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "jurisdictions" */
export type JurisdictionsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  geoid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "jurisdictions" */
export type JurisdictionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JurisdictionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JurisdictionsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  geoid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "jurisdictions" */
export enum JurisdictionsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  GEOID = 'geoid',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type JurisdictionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JurisdictionsSetInput>;
  /** filter the rows which have to be updated */
  where: JurisdictionsBoolExp;
};

/** Options for location based filtering. */
export type LocationFilter = {
  address?: InputMaybe<Scalars['String']['input']>;
  point?: InputMaybe<Point>;
  /** 5 digit ZCTA code. ZIP Code Tabulation Areas (ZCTAs) are generalized areal representations of United States Postal Service (USPS) ZIP Code service areas. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type LocationWithAddressInput = {
  address?: InputMaybe<AddressInput>;
  point?: InputMaybe<Point>;
  state: Scalars['String']['input'];
};

/** Ballot measures */
export type Measure = DatabaseIdentifiable & GeographicalIdentifiers & Node & Slug & Timestamps & {
  __typename?: 'Measure';
  arguments?: Maybe<Array<Argument>>;
  /** What does a 'no' vote mean? */
  conSnippet?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  election: Election;
  endorsements: Array<Endorsement>;
  /**
   * GEOIDs are numeric codes that uniquely identify all administrative/legal and statistical geographic areas for which the Census Bureau tabulates data.
   *
   * More information: https://www.census.gov/programs-surveys/geography/guidance/geo-identifiers.html
   *
   */
  geoId?: Maybe<Scalars['String']['output']>;
  /** True if we do not have the exact geospatial data for this measure, and instead we are using a higher level geographical unit so as to be inclusive (e.g. using the boundaries for an entire city if we do not have data for the individual city council districts). */
  hasUnknownBoundaries: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  issue?: Maybe<Issue>;
  /**
   * MAF/TIGER Feature Class Code, a census designated code of 1 letter and 4 numbers (e.g. G4000) designating what kind of geographical entity is being described (Congressional District, Incorporated Place, County or Equivalent Features, etc).
   *
   * More information: https://www.census.gov/library/reference/code-lists/mt-feature-class-codes.html
   *
   * List of commonly used MTFCC:
   *
   * * State: `G4000`
   * * County: `G4020`
   * * City: `G4110`
   *
   * Any MTFCC starting with `X` is a BallotReady defined custom code.
   *
   */
  mtfcc?: Maybe<Scalars['String']['output']>;
  /** Name as it appears on the ballot */
  name?: Maybe<Scalars['String']['output']>;
  party: Party;
  /** What does a 'yes' vote mean? */
  proSnippet?: Maybe<Scalars['String']['output']>;
  /** Unique string used to reference object in URLs */
  slug: Scalars['String']['output'];
  state: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  /** Descriptive title */
  title?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Measure. */
export type MeasureConnection = {
  __typename?: 'MeasureConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MeasureEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Measure>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MeasureEdge = {
  __typename?: 'MeasureEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Measure>;
};

/** Filtering options for measures. */
export type MeasureFilter = {
  electionDay?: InputMaybe<ElectionDayFilter>;
  /**
   * Filter by GEOID.
   *
   * Supports 3 options:
   *
   * 1. Filter by a single, exact GEOID (e.g. `geoId: "02"` to find all state-level objects in Alaska)
   * 2. Filter by a single, inexact GEOID with a wild card at the end (e.g. `geoId: "02*"` to find all objects in Alaska)
   * 3. Filter by multiple exact GEOIDs at the same time (e.g. `geoId: ["02", "17"]` to return state-level objects in both Alaska and Illinois)
   *
   * More information about GEOIDs: https://www.census.gov/programs-surveys/geography/guidance/geo-identifiers.html
   *
   */
  geoId?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * MAF/TIGER Feature Class Code, a census designated code of 1 letter and 4 numbers (e.g. G4000) designating what kind of geographical entity is being described (Congressional District, Incorporated Place, County or Equivalent Features, etc).
   *
   * More information: https://www.census.gov/library/reference/code-lists/mt-feature-class-codes.html
   *
   * List of commonly used MTFCC:
   *
   * * State: `G4000`
   * * County: `G4020`
   * * City: `G4110`
   *
   */
  mtfcc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 2 character state code (e.g. `IL` for Illinois). */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "measures" */
export type Measures = {
  __typename?: 'Measures';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  influenceTarget: InfluenceTargets;
  influenceTargetId: Scalars['uuid']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "measures" */
export type MeasuresAggregate = {
  __typename?: 'MeasuresAggregate';
  aggregate?: Maybe<MeasuresAggregateFields>;
  nodes: Array<Measures>;
};

export type MeasuresAggregateBoolExp = {
  count?: InputMaybe<MeasuresAggregateBoolExpCount>;
};

/** aggregate fields of "measures" */
export type MeasuresAggregateFields = {
  __typename?: 'MeasuresAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<MeasuresMaxFields>;
  min?: Maybe<MeasuresMinFields>;
};


/** aggregate fields of "measures" */
export type MeasuresAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MeasuresSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "measures" */
export type MeasuresAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MeasuresMaxOrderBy>;
  min?: InputMaybe<MeasuresMinOrderBy>;
};

/** input type for inserting array relation for remote table "measures" */
export type MeasuresArrRelInsertInput = {
  data: Array<MeasuresInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<MeasuresOnConflict>;
};

/** Boolean expression to filter rows from the table "measures". All fields are combined with a logical 'AND'. */
export type MeasuresBoolExp = {
  _and?: InputMaybe<Array<MeasuresBoolExp>>;
  _not?: InputMaybe<MeasuresBoolExp>;
  _or?: InputMaybe<Array<MeasuresBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  influenceTarget?: InputMaybe<InfluenceTargetsBoolExp>;
  influenceTargetId?: InputMaybe<UuidComparisonExp>;
  summary?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "measures" */
export enum MeasuresConstraint {
  /** unique or primary key constraint on columns "id" */
  MEASURES_PKEY = 'measures_pkey'
}

/** input type for inserting data into table "measures" */
export type MeasuresInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  influenceTarget?: InputMaybe<InfluenceTargetsObjRelInsertInput>;
  influenceTargetId?: InputMaybe<Scalars['uuid']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type MeasuresMaxFields = {
  __typename?: 'MeasuresMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  influenceTargetId?: Maybe<Scalars['uuid']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "measures" */
export type MeasuresMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  influenceTargetId?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MeasuresMinFields = {
  __typename?: 'MeasuresMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  influenceTargetId?: Maybe<Scalars['uuid']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "measures" */
export type MeasuresMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  influenceTargetId?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "measures" */
export type MeasuresMutationResponse = {
  __typename?: 'MeasuresMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Measures>;
};

/** on_conflict condition type for table "measures" */
export type MeasuresOnConflict = {
  constraint: MeasuresConstraint;
  updateColumns?: Array<MeasuresUpdateColumn>;
  where?: InputMaybe<MeasuresBoolExp>;
};

/** Ordering options when selecting data from "measures". */
export type MeasuresOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  influenceTarget?: InputMaybe<InfluenceTargetsOrderBy>;
  influenceTargetId?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: measures */
export type MeasuresPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "measures" */
export enum MeasuresSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  INFLUENCETARGETID = 'influenceTargetId',
  /** column name */
  SUMMARY = 'summary',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "measures" */
export type MeasuresSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  influenceTargetId?: InputMaybe<Scalars['uuid']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "measures" */
export type MeasuresStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MeasuresStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MeasuresStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  influenceTargetId?: InputMaybe<Scalars['uuid']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "measures" */
export enum MeasuresUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  INFLUENCETARGETID = 'influenceTargetId',
  /** column name */
  SUMMARY = 'summary',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type MeasuresUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MeasuresSetInput>;
  /** filter the rows which have to be updated */
  where: MeasuresBoolExp;
};

/** columns and relationships of "media" */
export type Media = {
  __typename?: 'Media';
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  entities: Array<Entities>;
  /** An aggregate relationship */
  entitiesAggregate: EntitiesAggregate;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  issueMediaRels: Array<IssueMediaRels>;
  /** An aggregate relationship */
  issueMediaRelsAggregate: IssueMediaRelsAggregate;
  link: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "media" */
export type MediaEntitiesArgs = {
  distinctOn?: InputMaybe<Array<EntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntitiesOrderBy>>;
  where?: InputMaybe<EntitiesBoolExp>;
};


/** columns and relationships of "media" */
export type MediaEntitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntitiesOrderBy>>;
  where?: InputMaybe<EntitiesBoolExp>;
};


/** columns and relationships of "media" */
export type MediaIssueMediaRelsArgs = {
  distinctOn?: InputMaybe<Array<IssueMediaRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueMediaRelsOrderBy>>;
  where?: InputMaybe<IssueMediaRelsBoolExp>;
};


/** columns and relationships of "media" */
export type MediaIssueMediaRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssueMediaRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueMediaRelsOrderBy>>;
  where?: InputMaybe<IssueMediaRelsBoolExp>;
};

/** aggregated selection of "media" */
export type MediaAggregate = {
  __typename?: 'MediaAggregate';
  aggregate?: Maybe<MediaAggregateFields>;
  nodes: Array<Media>;
};

/** aggregate fields of "media" */
export type MediaAggregateFields = {
  __typename?: 'MediaAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<MediaMaxFields>;
  min?: Maybe<MediaMinFields>;
};


/** aggregate fields of "media" */
export type MediaAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MediaSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "media". All fields are combined with a logical 'AND'. */
export type MediaBoolExp = {
  _and?: InputMaybe<Array<MediaBoolExp>>;
  _not?: InputMaybe<MediaBoolExp>;
  _or?: InputMaybe<Array<MediaBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  entities?: InputMaybe<EntitiesBoolExp>;
  entitiesAggregate?: InputMaybe<EntitiesAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  issueMediaRels?: InputMaybe<IssueMediaRelsBoolExp>;
  issueMediaRelsAggregate?: InputMaybe<IssueMediaRelsAggregateBoolExp>;
  link?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "media" */
export enum MediaConstraint {
  /** unique or primary key constraint on columns "id" */
  MEDIA_PKEY = 'media_pkey'
}

/** input type for inserting data into table "media" */
export type MediaInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entities?: InputMaybe<EntitiesArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issueMediaRels?: InputMaybe<IssueMediaRelsArrRelInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type MediaMaxFields = {
  __typename?: 'MediaMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type MediaMinFields = {
  __typename?: 'MediaMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "media" */
export type MediaMutationResponse = {
  __typename?: 'MediaMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Media>;
};

/** input type for inserting object relation for remote table "media" */
export type MediaObjRelInsertInput = {
  data: MediaInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<MediaOnConflict>;
};

/** on_conflict condition type for table "media" */
export type MediaOnConflict = {
  constraint: MediaConstraint;
  updateColumns?: Array<MediaUpdateColumn>;
  where?: InputMaybe<MediaBoolExp>;
};

/** Ordering options when selecting data from "media". */
export type MediaOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  entitiesAggregate?: InputMaybe<EntitiesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  issueMediaRelsAggregate?: InputMaybe<IssueMediaRelsAggregateOrderBy>;
  link?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: media */
export type MediaPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "media" */
export enum MediaSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  LINK = 'link',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "media" */
export type MediaSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "media" */
export type MediaStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MediaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MediaStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "media" */
export enum MediaUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  LINK = 'link',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type MediaUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MediaSetInput>;
  /** filter the rows which have to be updated */
  where: MediaBoolExp;
};

export enum Member {
  BOARD_MEMBER = 'BOARD_MEMBER',
  INSPECTOR_GENERAL = 'INSPECTOR_GENERAL',
  LEGAL = 'LEGAL',
  LOWER_REGIONAL_DIRECTOR = 'LOWER_REGIONAL_DIRECTOR',
  OTHER = 'OTHER',
  PRIMARY_DIRECTOR = 'PRIMARY_DIRECTOR',
  SECONDARY_DIRECTOR = 'SECONDARY_DIRECTOR'
}

export type Milestone = {
  __typename?: 'Milestone';
  category: MilestoneCategory;
  channel: MilestoneChannel;
  /**
   * Date in election default time zone (see `Election.timezone`)'
   *
   * Note that `datetime` might contain more detail (an exact time). However, some milestones
   * are only as specific as a date.
   *
   */
  date: Scalars['ISO8601Date']['output'];
  /**
   * UTC timestamp of exact milestone date AND time. Might be `null` when exact time is unknown.
   *
   * Use `Election.timezone` to determine date and time in election local timezone. Some
   * elections span multiple timezones so we recommend displaying the timezone abbreviation to
   * user when using these milestones for display purposes. If known, the user's local timezone
   * can be used to calculate exact date/time for user.
   *
   */
  datetime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Additional qualifiers that determine the type of milestone.
   *
   * For exmaple, a deadline milestone to  mail in a ballot might either be a 'received by' or a
   * 'postmarked' deadline.
   *
   */
  features: Array<MilestoneFeature>;
  /**
   * Whether this is a deadline (`CLOSE`) or a start milestone (`OPEN`).
   *
   */
  type: MilestoneObject;
};

export enum MilestoneCategory {
  EARLY_VOTING = 'EARLY_VOTING',
  REGISTRATION = 'REGISTRATION',
  REQUEST_BALLOT = 'REQUEST_BALLOT',
  VOTING = 'VOTING'
}

export enum MilestoneChannel {
  BY_MAIL = 'BY_MAIL',
  DROP_OFF = 'DROP_OFF',
  IN_PERSON = 'IN_PERSON',
  ONLINE = 'ONLINE',
  SAME_DAY = 'SAME_DAY'
}

export enum MilestoneFeature {
  POSTMARKED = 'POSTMARKED',
  RECEIVED = 'RECEIVED'
}

/** Filtering options for milestones. */
export type MilestoneFilter = {
  category?: InputMaybe<Array<MilestoneCategory>>;
  channel?: InputMaybe<Array<MilestoneChannel>>;
  type?: InputMaybe<Array<MilestoneObject>>;
};

export enum MilestoneObject {
  CLOSE = 'CLOSE',
  OPEN = 'OPEN'
}

/**
 * List of known MTFCC
 *
 * Custom, BallotReady defined MTFCC start with X
 *
 */
export type Mtfcc = DatabaseIdentifiable & Node & {
  __typename?: 'Mtfcc';
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  mtfcc: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** The connection type for Mtfcc. */
export type MtfccConnection = {
  __typename?: 'MtfccConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MtfccEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Mtfcc>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MtfccEdge = {
  __typename?: 'MtfccEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Mtfcc>;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

export type NormalizedPosition = DatabaseIdentifiable & Node & {
  __typename?: 'NormalizedPosition';
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /** Generic description of this position. */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Issues this type of position has been tagged with. */
  issues: Array<Issue>;
  /**
   * MAF/TIGER Feature Class Code, a census designated code of 1 letter and 4 numbers (e.g. G4000) designating what kind of geographical entity is being described (Congressional District, Incorporated Place, County or Equivalent Features, etc).
   *
   * More information: https://www.census.gov/library/reference/code-lists/mt-feature-class-codes.html
   *
   */
  mtfcc?: Maybe<Scalars['String']['output']>;
  /** A name for the type of position. */
  name: Scalars['String']['output'];
};

/** Object types for which `globalId` lookup using `databaseId` is available. */
export enum ObjectType {
  ACTION = 'ACTION',
  ADDRESS = 'ADDRESS',
  ARGUMENT = 'ARGUMENT',
  ASSIGNMENT = 'ASSIGNMENT',
  BODY = 'BODY',
  BODY_MEMBER = 'BODY_MEMBER',
  CANDIDACY = 'CANDIDACY',
  CANDIDATE_URL = 'CANDIDATE_URL',
  CONSTITUENT_CONTACT = 'CONSTITUENT_CONTACT',
  DATASET_VERSION = 'DATASET_VERSION',
  DEGREE = 'DEGREE',
  ELECTION = 'ELECTION',
  ELECTION_TYPE = 'ELECTION_TYPE',
  ENDORSEMENT = 'ENDORSEMENT',
  EXPERIENCE = 'EXPERIENCE',
  FILING_PERIOD = 'FILING_PERIOD',
  FORM = 'FORM',
  GEOFENCE = 'GEOFENCE',
  ISSUE = 'ISSUE',
  MEASURE = 'MEASURE',
  MTFCC = 'MTFCC',
  NORMALIZED_POSITION = 'NORMALIZED_POSITION',
  OFFICE_HOLDER = 'OFFICE_HOLDER',
  OFFICE_HOLDER_URL = 'OFFICE_HOLDER_URL',
  ORGANIZATION = 'ORGANIZATION',
  PARTY = 'PARTY',
  PERSON = 'PERSON',
  PLACE = 'PLACE',
  POSITION = 'POSITION',
  POSITION_AUDIT = 'POSITION_AUDIT',
  POSITION_DATE_FORMULA = 'POSITION_DATE_FORMULA',
  POSITION_ELECTION_ASSIGNMENT = 'POSITION_ELECTION_ASSIGNMENT',
  POSITION_ELECTION_FREQUENCY = 'POSITION_ELECTION_FREQUENCY',
  RACE = 'RACE',
  STANCE = 'STANCE',
  SUBSCRIPTION = 'SUBSCRIPTION',
  TENANT = 'TENANT',
  TENANT_DATASET = 'TENANT_DATASET',
  TENANT_ELECTION = 'TENANT_ELECTION',
  TENANT_ORGANIZATION = 'TENANT_ORGANIZATION',
  VOTING_DAY = 'VOTING_DAY',
  VOTING_LOCATION = 'VOTING_LOCATION'
}

/**
 * An officeholder record is a term that a person in our database holds a position.  Each officeholder record is one term (not one unique person/position combination).
 * You can query this object for information about the term dates, office contact info, and any official websites the officeholder has.
 *
 */
export type OfficeHolder = DatabaseIdentifiable & Node & Timestamps & {
  __typename?: 'OfficeHolder';
  addresses: Array<Address>;
  centralPhone?: Maybe<Scalars['String']['output']>;
  contacts: Array<Contact>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /** When the officeholder term ended. While a date value, actual precision is based on `specificity.`  */
  endAt?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  isAppointed: Scalars['Boolean']['output'];
  /** True when the office holder is currently in office, false when they previously held office */
  isCurrent: Scalars['Boolean']['output'];
  /** Records if the officeholder term is out of the normal schedule for the position (i.e., filling an unexpired term or a vacancy). */
  isOffCycle: Scalars['Boolean']['output'];
  isVacant: Scalars['Boolean']['output'];
  officePhone?: Maybe<Scalars['String']['output']>;
  /** Records if the officeholder's title is significantly different than the position name on the ballot.  If null, the title is equalent to `Position.name`. */
  officeTitle?: Maybe<Scalars['String']['output']>;
  otherPhone?: Maybe<Scalars['String']['output']>;
  parties: Array<Party>;
  /** The party record associated with this office holder record. */
  party?: Maybe<Party>;
  /** The person record associated with this office holder record. When no person associated this means this is a vacant position. */
  person?: Maybe<Person>;
  position: Position;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  /** Indication of term date accuracy */
  specificity?: Maybe<DateSpecificity>;
  /** When the officeholder term started. While a date value, actual precision is based on `specificity.`  */
  startAt?: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * The total number of years this person has held this office.
   *
   * Terms do not have to be consecutive. This field will return the same value for this person regardless of the `OfficeHolder` entry being observed.
   *
   * Complexity: 5
   *
   */
  totalYearsInOffice: Scalars['Int']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Collection of URLs associated with this officeholder. Typically includes government website and social media accounts. */
  urls: Array<Url>;
};


/**
 * An officeholder record is a term that a person in our database holds a position.  Each officeholder record is one term (not one unique person/position combination).
 * You can query this object for information about the term dates, office contact info, and any official websites the officeholder has.
 *
 */
export type OfficeHolderUrlsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for OfficeHolder. */
export type OfficeHolderConnection = {
  __typename?: 'OfficeHolderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OfficeHolderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OfficeHolder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OfficeHolderEdge = {
  __typename?: 'OfficeHolderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OfficeHolder>;
};

/** Options to filter nodes by date. Combine arguments to search between dates. */
export type OfficeHolderEndDateFilter = {
  /** Exact date. */
  eq?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Greater than date. */
  gt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Greater than or equal to date. */
  gte?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Less than date. */
  lt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Less than or equal to date. */
  lte?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Filtering options for office holders. */
export type OfficeHolderFilter = {
  endAt?: InputMaybe<OfficeHolderEndDateFilter>;
  isAppointed?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isJudicial?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<OfficeHolderStartDateFilter>;
};

/** Ordering options for office holders. */
export type OfficeHolderOrder = {
  /** Possible directions in which to order a list of items when provided an `orderBy` argument. */
  direction: OrderDirection;
  /** Properties by which office holders can be ordered. */
  field: OfficeHolderOrderField;
};

export enum OfficeHolderOrderField {
  /** Order office holders by end date */
  END_AT = 'END_AT',
  /** Order office holders by start date */
  START_AT = 'START_AT'
}

/** Options to filter nodes by date. Combine arguments to search between dates. */
export type OfficeHolderStartDateFilter = {
  /** Exact date. */
  eq?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Greater than date. */
  gt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Greater than or equal to date. */
  gte?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Less than date. */
  lt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Less than or equal to date. */
  lte?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type OfficeHolderUrl = DatabaseIdentifiable & Node & {
  __typename?: 'OfficeHolderUrl';
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  entryType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

/** columns and relationships of "offices" */
export type Offices = {
  __typename?: 'Offices';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  influenceTarget: InfluenceTargets;
  influenceTargetId: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "offices" */
export type OfficesAggregate = {
  __typename?: 'OfficesAggregate';
  aggregate?: Maybe<OfficesAggregateFields>;
  nodes: Array<Offices>;
};

export type OfficesAggregateBoolExp = {
  count?: InputMaybe<OfficesAggregateBoolExpCount>;
};

/** aggregate fields of "offices" */
export type OfficesAggregateFields = {
  __typename?: 'OfficesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<OfficesMaxFields>;
  min?: Maybe<OfficesMinFields>;
};


/** aggregate fields of "offices" */
export type OfficesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OfficesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "offices" */
export type OfficesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OfficesMaxOrderBy>;
  min?: InputMaybe<OfficesMinOrderBy>;
};

/** input type for inserting array relation for remote table "offices" */
export type OfficesArrRelInsertInput = {
  data: Array<OfficesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<OfficesOnConflict>;
};

/** Boolean expression to filter rows from the table "offices". All fields are combined with a logical 'AND'. */
export type OfficesBoolExp = {
  _and?: InputMaybe<Array<OfficesBoolExp>>;
  _not?: InputMaybe<OfficesBoolExp>;
  _or?: InputMaybe<Array<OfficesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  influenceTarget?: InputMaybe<InfluenceTargetsBoolExp>;
  influenceTargetId?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "offices" */
export enum OfficesConstraint {
  /** unique or primary key constraint on columns "id" */
  OFFICES_PKEY = 'offices_pkey'
}

/** input type for inserting data into table "offices" */
export type OfficesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  influenceTarget?: InputMaybe<InfluenceTargetsObjRelInsertInput>;
  influenceTargetId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type OfficesMaxFields = {
  __typename?: 'OfficesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  influenceTargetId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "offices" */
export type OfficesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  influenceTargetId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type OfficesMinFields = {
  __typename?: 'OfficesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  influenceTargetId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "offices" */
export type OfficesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  influenceTargetId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "offices" */
export type OfficesMutationResponse = {
  __typename?: 'OfficesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Offices>;
};

/** on_conflict condition type for table "offices" */
export type OfficesOnConflict = {
  constraint: OfficesConstraint;
  updateColumns?: Array<OfficesUpdateColumn>;
  where?: InputMaybe<OfficesBoolExp>;
};

/** Ordering options when selecting data from "offices". */
export type OfficesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  influenceTarget?: InputMaybe<InfluenceTargetsOrderBy>;
  influenceTargetId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: offices */
export type OfficesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "offices" */
export enum OfficesSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  INFLUENCETARGETID = 'influenceTargetId',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "offices" */
export type OfficesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  influenceTargetId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "offices" */
export type OfficesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: OfficesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OfficesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  influenceTargetId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "offices" */
export enum OfficesUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  INFLUENCETARGETID = 'influenceTargetId',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type OfficesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OfficesSetInput>;
  /** filter the rows which have to be updated */
  where: OfficesBoolExp;
};

/** column ordering options */
export enum OrderBy {
  /** in ascending order, nulls last */
  ASC = 'ASC',
  /** in ascending order, nulls first */
  ASC_NULLS_FIRST = 'ASC_NULLS_FIRST',
  /** in ascending order, nulls last */
  ASC_NULLS_LAST = 'ASC_NULLS_LAST',
  /** in descending order, nulls first */
  DESC = 'DESC',
  /** in descending order, nulls first */
  DESC_NULLS_FIRST = 'DESC_NULLS_FIRST',
  /** in descending order, nulls last */
  DESC_NULLS_LAST = 'DESC_NULLS_LAST'
}

export enum OrderDirection {
  /** Specifies an ascending order for a given `orderBy` argument. */
  ASC = 'ASC',
  /** Specifies a descending order for a given `orderBy` argument. */
  DESC = 'DESC'
}

/** List of organizations with researched endorsements */
export type Organization = DatabaseIdentifiable & Node & Timestamps & {
  __typename?: 'Organization';
  /** If the organization has affiliates or chapters, they may be listed here. */
  children: Array<Organization>;
  color?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue?: Maybe<Issue>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** If the organization is an affiliate of a larger organization, it may have a parent organization listed here. */
  parent?: Maybe<Organization>;
  retiredAt?: Maybe<Scalars['ISO8601Date']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** URL with type of url for the organization (i.e., website). */
  urls: Array<Url>;
};

/** The connection type for Organization. */
export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Organization>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Organization>;
};

/** Filtering options for organizations. */
export type OrganizationFilter = {
  /** Parent organization ID */
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Party = DatabaseIdentifiable & Node & Timestamps & {
  __typename?: 'Party';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Abbreviated name. Note that these are not unique. */
  shortName: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/**
 * Contains data about any person who appears in our database as a candidate or an officeholder (or both).
 * This is where data like education, job experience and other biographical information is stored.
 * For issue stances, endorsements, or other information about a candidate you should query the Candidacy object.
 * For term dates, office location, or other officeholder information, use the OfficeHolder object.
 *
 */
export type Person = DatabaseIdentifiable & HasCandidacies & HasOfficeHolders & Node & Slug & Timestamps & {
  __typename?: 'Person';
  /** Plain text bio for the person */
  bioText?: Maybe<Scalars['String']['output']>;
  /** Congressional Member ID from the Biographical Directory of the United States Congress */
  bioguideId?: Maybe<Scalars['String']['output']>;
  candidacies: Array<Candidacy>;
  contacts: Array<Contact>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /** List of person's educational degrees */
  degrees: Array<Degree>;
  email?: Maybe<Scalars['String']['output']>;
  /** List of person's professional experience. */
  experiences: Array<Experience>;
  /** First name as it appears on candidate lists released by local election authorities. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Formatted full name based on name components. */
  fullName: Scalars['String']['output'];
  headshot: Headshot;
  id: Scalars['ID']['output'];
  /** Collection of URLs for different types of candidate photos. */
  images: Array<ImageUrl>;
  /** Last name as it appears on candidate lists released by local election authorities. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Middle name as it appears on candidate lists released by local election authorities. */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Alternative name as it appears on candidate lists released by local election authorities. */
  nickname?: Maybe<Scalars['String']['output']>;
  officeHolders: OfficeHolderConnection;
  phone?: Maybe<Scalars['String']['output']>;
  /** Unique string used to reference object in URLs */
  slug: Scalars['String']['output'];
  /** Suffix as it appears on candidate lists released by local election authorities. */
  suffix?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Collection of URLs associated with this person. Typically includes campaign website and social media accounts. */
  urls: Array<Url>;
};


/**
 * Contains data about any person who appears in our database as a candidate or an officeholder (or both).
 * This is where data like education, job experience and other biographical information is stored.
 * For issue stances, endorsements, or other information about a candidate you should query the Candidacy object.
 * For term dates, office location, or other officeholder information, use the OfficeHolder object.
 *
 */
export type PersonCandidaciesArgs = {
  includeUncertified?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Contains data about any person who appears in our database as a candidate or an officeholder (or both).
 * This is where data like education, job experience and other biographical information is stored.
 * For issue stances, endorsements, or other information about a candidate you should query the Candidacy object.
 * For term dates, office location, or other officeholder information, use the OfficeHolder object.
 *
 */
export type PersonOfficeHoldersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<OfficeHolderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OfficeHolderOrder>;
};


/**
 * Contains data about any person who appears in our database as a candidate or an officeholder (or both).
 * This is where data like education, job experience and other biographical information is stored.
 * For issue stances, endorsements, or other information about a candidate you should query the Candidacy object.
 * For term dates, office location, or other officeholder information, use the OfficeHolder object.
 *
 */
export type PersonUrlsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Person. */
export type PersonConnection = {
  __typename?: 'PersonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PersonEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Person>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PersonEdge = {
  __typename?: 'PersonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Person>;
};

/** Filtering options for people. */
export type PersonFilter = {
  bioguideId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "persons" */
export type Persons = {
  __typename?: 'Persons';
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  entityPersonRels: Array<EntityPersonRels>;
  /** An aggregate relationship */
  entityPersonRelsAggregate: EntityPersonRelsAggregate;
  firstName: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  lastName: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** An array relationship */
  voterVerifications: Array<VoterVerifications>;
  /** An aggregate relationship */
  voterVerificationsAggregate: VoterVerificationsAggregate;
};


/** columns and relationships of "persons" */
export type PersonsEntityPersonRelsArgs = {
  distinctOn?: InputMaybe<Array<EntityPersonRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityPersonRelsOrderBy>>;
  where?: InputMaybe<EntityPersonRelsBoolExp>;
};


/** columns and relationships of "persons" */
export type PersonsEntityPersonRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EntityPersonRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityPersonRelsOrderBy>>;
  where?: InputMaybe<EntityPersonRelsBoolExp>;
};


/** columns and relationships of "persons" */
export type PersonsVoterVerificationsArgs = {
  distinctOn?: InputMaybe<Array<VoterVerificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoterVerificationsOrderBy>>;
  where?: InputMaybe<VoterVerificationsBoolExp>;
};


/** columns and relationships of "persons" */
export type PersonsVoterVerificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VoterVerificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoterVerificationsOrderBy>>;
  where?: InputMaybe<VoterVerificationsBoolExp>;
};

/** aggregated selection of "persons" */
export type PersonsAggregate = {
  __typename?: 'PersonsAggregate';
  aggregate?: Maybe<PersonsAggregateFields>;
  nodes: Array<Persons>;
};

/** aggregate fields of "persons" */
export type PersonsAggregateFields = {
  __typename?: 'PersonsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<PersonsMaxFields>;
  min?: Maybe<PersonsMinFields>;
};


/** aggregate fields of "persons" */
export type PersonsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PersonsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "persons". All fields are combined with a logical 'AND'. */
export type PersonsBoolExp = {
  _and?: InputMaybe<Array<PersonsBoolExp>>;
  _not?: InputMaybe<PersonsBoolExp>;
  _or?: InputMaybe<Array<PersonsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  entityPersonRels?: InputMaybe<EntityPersonRelsBoolExp>;
  entityPersonRelsAggregate?: InputMaybe<EntityPersonRelsAggregateBoolExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  voterVerifications?: InputMaybe<VoterVerificationsBoolExp>;
  voterVerificationsAggregate?: InputMaybe<VoterVerificationsAggregateBoolExp>;
};

/** unique or primary key constraints on table "persons" */
export enum PersonsConstraint {
  /** unique or primary key constraint on columns "id" */
  PERSONS_PKEY = 'persons_pkey'
}

/** input type for inserting data into table "persons" */
export type PersonsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityPersonRels?: InputMaybe<EntityPersonRelsArrRelInsertInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  voterVerifications?: InputMaybe<VoterVerificationsArrRelInsertInput>;
};

/** aggregate max on columns */
export type PersonsMaxFields = {
  __typename?: 'PersonsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type PersonsMinFields = {
  __typename?: 'PersonsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "persons" */
export type PersonsMutationResponse = {
  __typename?: 'PersonsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Persons>;
};

/** input type for inserting object relation for remote table "persons" */
export type PersonsObjRelInsertInput = {
  data: PersonsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PersonsOnConflict>;
};

/** on_conflict condition type for table "persons" */
export type PersonsOnConflict = {
  constraint: PersonsConstraint;
  updateColumns?: Array<PersonsUpdateColumn>;
  where?: InputMaybe<PersonsBoolExp>;
};

/** Ordering options when selecting data from "persons". */
export type PersonsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  entityPersonRelsAggregate?: InputMaybe<EntityPersonRelsAggregateOrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  voterVerificationsAggregate?: InputMaybe<VoterVerificationsAggregateOrderBy>;
};

/** primary key columns input for table: persons */
export type PersonsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "persons" */
export enum PersonsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  FIRSTNAME = 'firstName',
  /** column name */
  ID = 'id',
  /** column name */
  LASTNAME = 'lastName',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "persons" */
export type PersonsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "persons" */
export type PersonsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PersonsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PersonsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "persons" */
export enum PersonsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  FIRSTNAME = 'firstName',
  /** column name */
  ID = 'id',
  /** column name */
  LASTNAME = 'lastName',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type PersonsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PersonsSetInput>;
  /** filter the rows which have to be updated */
  where: PersonsBoolExp;
};

/** An area (such as state, city, or county). You can find voting and registration information associated with a place, as well as positions organized by place. */
export type Place = DatabaseIdentifiable & GeographicalIdentifiers & Node & Slug & Timestamps & {
  __typename?: 'Place';
  addresses: Array<Address>;
  /**
   * Whether someone who is younger than eighteen (18) is allowed to vote in a primary election.
   *
   * Some places allow a person to register to vote before they turn eighteen, as long as they
   * turn eighteen before the General Election. In a subset of these places a voter is allowed
   * to already vote in a Primary Election even wehn they are not eighteen yet.
   *
   */
  canVoteInPrimaryWhen18ByGeneral?: Maybe<Scalars['Boolean']['output']>;
  contacts: Array<Contact>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  dissolved: Scalars['Boolean']['output'];
  forms: Array<Form>;
  /**
   * GEOIDs are numeric codes that uniquely identify all administrative/legal and statistical geographic areas for which the Census Bureau tabulates data.
   *
   * More information: https://www.census.gov/programs-surveys/geography/guidance/geo-identifiers.html
   *
   */
  geoId?: Maybe<Scalars['String']['output']>;
  hasVoteByMail: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isPrintingEnabled: Scalars['Boolean']['output'];
  isReceiverOfVoteByMailRequests: Scalars['Boolean']['output'];
  /**
   * MAF/TIGER Feature Class Code, a census designated code of 1 letter and 4 numbers (e.g. G4000) designating what kind of geographical entity is being described (Congressional District, Incorporated Place, County or Equivalent Features, etc).
   *
   * More information: https://www.census.gov/library/reference/code-lists/mt-feature-class-codes.html
   *
   * List of commonly used MTFCC:
   *
   * * State: `G4000`
   * * County: `G4020`
   * * City: `G4110`
   *
   * Any MTFCC starting with `X` is a BallotReady defined custom code.
   *
   */
  mtfcc?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /**
   * Returns positions associated with this place. Defaults to positions currently associated with this place. To view historical or future position associations use the `validOn` argument. A position association could change because of redistricting for example.'
   *
   */
  positions: PositionConnection;
  primaryType?: Maybe<Scalars['String']['output']>;
  registrationOptions: Array<RegistrationOption>;
  /** Unique string used to reference object in URLs */
  slug: Scalars['String']['output'];
  state: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Type of url directing to the online resource for the place. Types include `absentee_excuses`, `absentee` (where to start an application to vote absentee), `id_requirements`, `board_of_elections` (local only),`state_election_authority`,`voter_information`,`voter_registration_portal`,`vote_by_mail_portal`,`voter_registration_check`,`track_ballot`, and `polling_places`. */
  urls: Array<Url>;
};


/** An area (such as state, city, or county). You can find voting and registration information associated with a place, as well as positions organized by place. */
export type PlaceAddressesArgs = {
  filterBy?: InputMaybe<AddressFilter>;
};


/** An area (such as state, city, or county). You can find voting and registration information associated with a place, as well as positions organized by place. */
export type PlaceFormsArgs = {
  filterBy?: InputMaybe<FormFilter>;
};


/** An area (such as state, city, or county). You can find voting and registration information associated with a place, as well as positions organized by place. */
export type PlacePositionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  validOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** The connection type for Place. */
export type PlaceConnection = {
  __typename?: 'PlaceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PlaceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Place>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlaceEdge = {
  __typename?: 'PlaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Place>;
};

/** Filtering options for places. */
export type PlaceFilter = {
  /**
   * Filter by GEOID.
   *
   * Supports 3 options:
   *
   * 1. Filter by a single, exact GEOID (e.g. `geoId: "02"` to find all state-level objects in Alaska)
   * 2. Filter by a single, inexact GEOID with a wild card at the end (e.g. `geoId: "02*"` to find all objects in Alaska)
   * 3. Filter by multiple exact GEOIDs at the same time (e.g. `geoId: ["02", "17"]` to return state-level objects in both Alaska and Illinois)
   *
   * More information about GEOIDs: https://www.census.gov/programs-surveys/geography/guidance/geo-identifiers.html
   *
   */
  geoId?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * MAF/TIGER Feature Class Code, a census designated code of 1 letter and 4 numbers (e.g. G4000) designating what kind of geographical entity is being described (Congressional District, Incorporated Place, County or Equivalent Features, etc).
   *
   * More information: https://www.census.gov/library/reference/code-lists/mt-feature-class-codes.html
   *
   * List of commonly used MTFCC:
   *
   * * State: `G4000`
   * * County: `G4020`
   * * City: `G4110`
   *
   */
  mtfcc?: InputMaybe<Array<Scalars['String']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** 2 character state code (e.g. `IL` for Illinois). */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Ordering options for places. */
export type PlaceOrder = {
  /** Possible directions in which to order a list of items when provided an `orderBy` argument. */
  direction: OrderDirection;
  /** Properties by which places can be ordered. */
  field: PlaceOrderField;
};

export enum PlaceOrderField {
  /** Order places by locality. Ex: Towns/villages have high locality whereas states have low locality */
  LOCALITY = 'LOCALITY'
}

/** A geographic point on Earth's surface. */
export type Point = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

/**
 * A unique office that someone can run or hold office for.
 * A position can have multiple seats if they are elected the same way (i.e. a school board position). You can query filing requirements, election schedule, and other information about the position here.
 *
 */
export type Position = DatabaseIdentifiable & GeographicalIdentifiers & HasOfficeHolders & Node & Slug & Timestamps & {
  __typename?: 'Position';
  /** `true` if the position is normally appointed. */
  appointed: Scalars['Boolean']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /** Additional detail relevant to the position name, depending on how the position appears on the ballot. For example, local court judges are responsible for adjudicating cases in Civil and Criminal Courts at the trial-level in certain specific areas, such as small-claims court or drug court. */
  description?: Maybe<Scalars['String']['output']>;
  electionFrequencies: Array<PositionElectionFrequency>;
  eligibilityRequirements?: Maybe<Scalars['String']['output']>;
  /** Position time commitment, where it is made publicly available. */
  employmentType?: Maybe<Scalars['String']['output']>;
  /** Typically includes address line 1, address line 2, city, state, zip for where to submit filing paperwork. */
  filingAddress?: Maybe<Scalars['String']['output']>;
  /** Phone number for the relevant local election authority. */
  filingPhone?: Maybe<Scalars['String']['output']>;
  /** Associated filing fees and petition signatures required to run. */
  filingRequirements?: Maybe<Scalars['String']['output']>;
  /**
   * GEOIDs are numeric codes that uniquely identify all administrative/legal and statistical geographic areas for which the Census Bureau tabulates data.
   *
   * More information: https://www.census.gov/programs-surveys/geography/guidance/geo-identifiers.html
   *
   */
  geoId?: Maybe<Scalars['String']['output']>;
  /** Metadata about the geospatial boundaries (geofences) tied to this position */
  geofences: GeofenceConnection;
  /** A boolean marked as true if a candidate can win the position outright in the primary by receiving a certain threshold of the vote percentage (e.g., 50%) */
  hasMajorityVotePrimary: Scalars['Boolean']['output'];
  /** True when a primary election is usually held for this position. */
  hasPrimary?: Maybe<Scalars['Boolean']['output']>;
  /** True when general election uses ranked choice voting. The maximum number of votes allowed is available in `rankedChoiceMaxVotesGeneral` */
  hasRankedChoiceGeneral: Scalars['Boolean']['output'];
  /** True when general election uses ranked choice voting. The maximum number of votes allowed is available in `rankedChoiceMaxVotesPrimary` */
  hasRankedChoicePrimary: Scalars['Boolean']['output'];
  /** True if we do not have the exact geospatial data for this position, and instead we are using a higher level geographical unit so as to be inclusive (e.g. using the boundaries for an entire city if we do not have data for the individual city council districts). */
  hasUnknownBoundaries: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Issues this position has been tagged with. */
  issues: Array<Issue>;
  /** True when this is a judicial position. */
  judicial: Scalars['Boolean']['output'];
  /** The level of the position. */
  level: PositionLevel;
  /** The maximum amount a potential candidate would have to pay to file to run for the position. */
  maximumFilingFee?: Maybe<Scalars['Float']['output']>;
  /** The minimum age you must be to run for the position */
  minimumAge?: Maybe<Scalars['Int']['output']>;
  /**
   * MAF/TIGER Feature Class Code, a census designated code of 1 letter and 4 numbers (e.g. G4000) designating what kind of geographical entity is being described (Congressional District, Incorporated Place, County or Equivalent Features, etc).
   *
   * More information: https://www.census.gov/library/reference/code-lists/mt-feature-class-codes.html
   *
   * List of commonly used MTFCC:
   *
   * * State: `G4000`
   * * County: `G4020`
   * * City: `G4110`
   *
   * Any MTFCC starting with `X` is a BallotReady defined custom code.
   *
   */
  mtfcc?: Maybe<Scalars['String']['output']>;
  /** If true, a potential candidate must be a registered voter in order to file to run for office. If null, the data has not been collected yet. */
  mustBeRegisteredVoter?: Maybe<Scalars['Boolean']['output']>;
  /** If true, a potential candidate must be a resident of the jurisdiction area of the position in order to file to run for office. If null, the data has not been collected yet. */
  mustBeResident?: Maybe<Scalars['Boolean']['output']>;
  /** If true, a potential candidate must have some sort of professional experiences in order to file to run for office. If null, the data has not been collected yet. */
  mustHaveProfessionalExperience?: Maybe<Scalars['Boolean']['output']>;
  /** A name for the position. In some instances position names are referred to differently on their own websites than on the ballot. In this case, we choose a broad name that encompasses both ballot and BallotReady position naming conventions. */
  name: Scalars['String']['output'];
  normalizedPosition: NormalizedPosition;
  officeHolders: OfficeHolderConnection;
  /** The relevant local election authority a prospective candidate would need to contact for filing procedures as it is available on the election authority's website. */
  paperworkInstructions?: Maybe<Scalars['String']['output']>;
  /** The partisan nature of the position (e.g. partisan, nonpartisan). */
  partisanType?: Maybe<Scalars['String']['output']>;
  /**
   * Returns places (localities like county, city, etc.) associated with this position. Defaults to places currently associated with this position. To view historical or future place associations use the `validOn` argument. A place association could change because of redistricting for example.'
   *
   */
  places: PlaceConnection;
  races: RaceConnection;
  /** Maximum number of votes allowed in ranked choice general election. */
  rankedChoiceMaxVotesGeneral?: Maybe<Scalars['Int']['output']>;
  /** Maximum number of votes allowed in ranked choice general election. */
  rankedChoiceMaxVotesPrimary?: Maybe<Scalars['Int']['output']>;
  /** True when incumbent is retained in an election. Mostly relevant for judicial positions. */
  retention: Scalars['Boolean']['output'];
  /** Indicates the order in which positions will appear on a ballot. */
  rowOrder: Scalars['Int']['output'];
  /** Describes whether this field is a running mate for another position and what kind of running mate this position is. If this field is null, it is not a running mate. If the field is primary, the running mate affiliation occurs in the primary and continues to the general. If the value is general, the running mate affiliation does not occur until the general. This field will appear with a set value on positions like the vice president and lieutenant governors. */
  runningMateStyle?: Maybe<RunningMate>;
  /** Position salary information where it is made publicly available. */
  salary?: Maybe<Scalars['String']['output']>;
  /** The maximum number of people who will be elected to that position during a given election. Also see `selectionsAllowed`. */
  seats: Scalars['Int']['output'];
  /** The maximum number of candidates a voter can select on their ballot. Note that this could be different than `seats`. */
  selectionsAllowed: Scalars['Int']['output'];
  /** Unique string used to reference object in URLs */
  slug: Scalars['String']['output'];
  staggeredTerm: Scalars['Boolean']['output'];
  state?: Maybe<Scalars['String']['output']>;
  /** Area name as it appears on the ballot (e.g. 'District', 'Ward', 'Township') */
  subAreaName?: Maybe<Scalars['String']['output']>;
  /** Area value as it appears on the ballot (e.g. '1A', 'G') */
  subAreaValue?: Maybe<Scalars['String']['output']>;
  /** BallotReady organizes position and candidate research into five Tiers: (1) Federal, (2) State, (3) County & Municipal, (4) Small Town, Township & School Board, and (5) Special Districts and local small population positions */
  tier: Scalars['Int']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/**
 * A unique office that someone can run or hold office for.
 * A position can have multiple seats if they are elected the same way (i.e. a school board position). You can query filing requirements, election schedule, and other information about the position here.
 *
 */
export type PositionGeofencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<GeofenceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A unique office that someone can run or hold office for.
 * A position can have multiple seats if they are elected the same way (i.e. a school board position). You can query filing requirements, election schedule, and other information about the position here.
 *
 */
export type PositionOfficeHoldersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<OfficeHolderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OfficeHolderOrder>;
};


/**
 * A unique office that someone can run or hold office for.
 * A position can have multiple seats if they are elected the same way (i.e. a school board position). You can query filing requirements, election schedule, and other information about the position here.
 *
 */
export type PositionPlacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  validOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


/**
 * A unique office that someone can run or hold office for.
 * A position can have multiple seats if they are elected the same way (i.e. a school board position). You can query filing requirements, election schedule, and other information about the position here.
 *
 */
export type PositionRacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<RaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RaceOrder>;
};

/** The connection type for Position. */
export type PositionConnection = {
  __typename?: 'PositionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PositionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Position>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Options to filter nodes by timestamp (UTC). Combine arguments to search between timestamps. */
export type PositionCreatedAtFilter = {
  /** Exact date. */
  eq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Greater than date. */
  gt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Greater than or equal to date. */
  gte?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Less than date. */
  lt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Less than or equal to date. */
  lte?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** An edge in a connection. */
export type PositionEdge = {
  __typename?: 'PositionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /**
   * True when position fully encompasses the geographical area searched for (e.g. ZCTA area). Only set when filtering by ZCTA (ZIP), it will return `null` in all other cases.'
   *
   * Complexity: 3
   *
   */
  isContained?: Maybe<Scalars['Boolean']['output']>;
  /** The item at the end of the edge. */
  node?: Maybe<Position>;
};

export type PositionElectionFrequency = DatabaseIdentifiable & Node & {
  __typename?: 'PositionElectionFrequency';
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /** Array of integers used to calculate when next election is. Use with referenceYear (Ex. [2, 4]: An election occurs two years after referenceYear and then again, 4 years after that election */
  frequency: Array<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  position: Position;
  /** Year to be used as a base when caclulating future or past election years. Use with frequency */
  referenceYear: Scalars['Int']['output'];
  seats?: Maybe<Array<Scalars['Int']['output']>>;
  /** The date this frequency becomes valid */
  validFrom: Scalars['ISO8601Date']['output'];
  /** The date on which this frequency expires */
  validTo?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Filtering options for positions. */
export type PositionFilter = {
  createdAt?: InputMaybe<PositionCreatedAtFilter>;
  electionDay?: InputMaybe<ElectionDayFilter>;
  /**
   * Filter by GEOID.
   *
   * Supports 3 options:
   *
   * 1. Filter by a single, exact GEOID (e.g. `geoId: "02"` to find all state-level objects in Alaska)
   * 2. Filter by a single, inexact GEOID with a wild card at the end (e.g. `geoId: "02*"` to find all objects in Alaska)
   * 3. Filter by multiple exact GEOIDs at the same time (e.g. `geoId: ["02", "17"]` to return state-level objects in both Alaska and Illinois)
   *
   * More information about GEOIDs: https://www.census.gov/programs-surveys/geography/guidance/geo-identifiers.html
   *
   */
  geoId?: InputMaybe<Array<Scalars['String']['input']>>;
  isAppointed?: InputMaybe<Scalars['Boolean']['input']>;
  isJudicial?: InputMaybe<Scalars['Boolean']['input']>;
  issue?: InputMaybe<IssueIdFilter>;
  /** The level of the position: local, city, county, regional, state, federal or township */
  level?: InputMaybe<Array<PositionLevel>>;
  /**
   * MAF/TIGER Feature Class Code, a census designated code of 1 letter and 4 numbers (e.g. G4000) designating what kind of geographical entity is being described (Congressional District, Incorporated Place, County or Equivalent Features, etc).
   *
   * More information: https://www.census.gov/library/reference/code-lists/mt-feature-class-codes.html
   *
   * List of commonly used MTFCC:
   *
   * * State: `G4000`
   * * County: `G4020`
   * * City: `G4110`
   *
   */
  mtfcc?: InputMaybe<Array<Scalars['String']['input']>>;
  normalizedPositionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** 2 character state code (e.g. `IL` for Illinois). */
  state?: InputMaybe<Scalars['String']['input']>;
  /** BallotReady tiers used to classify positions data (1-5). */
  tier?: InputMaybe<Array<Scalars['Int']['input']>>;
  updatedAt?: InputMaybe<PositionUpdatedAtFilter>;
};

export enum PositionLevel {
  CITY = 'CITY',
  COUNTY = 'COUNTY',
  FEDERAL = 'FEDERAL',
  LOCAL = 'LOCAL',
  REGIONAL = 'REGIONAL',
  STATE = 'STATE',
  TOWNSHIP = 'TOWNSHIP'
}

/** Options to filter nodes by timestamp (UTC). Combine arguments to search between timestamps. */
export type PositionUpdatedAtFilter = {
  /** Exact date. */
  eq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Greater than date. */
  gt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Greater than or equal to date. */
  gte?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Less than date. */
  lt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Less than or equal to date. */
  lte?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/**
 * A unique instance of a position and election combination in the BallotReady database.
 * You can query this object for information about the race, such as what kind of race it is (isRunoff, isRecall, isPrimary, etc.) pull in the candidacies of the people running in the race, and more.
 *
 */
export type Race = DatabaseIdentifiable & HasCandidacies & Node & Timestamps & {
  __typename?: 'Race';
  candidacies: Array<Candidacy>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  election: Election;
  /** Dates between which a person can file paperwork to run for office and any pertinent notes. Note about data structure: We usually replace filing periods for a race rather than update them, so createdAt and updatedAt will usually be the same and createdAt does not reflect the first date we had a filingPeriod listed for race.  */
  filingPeriods: Array<FilingPeriod>;
  id: Scalars['ID']['output'];
  /** When true, this race was scheduled but will not appear on the ballot for some reason.For example, in some places if only one candidate files to run for a position, then the race will not appear on the ballot. */
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** True if the race is partisan */
  isPartisan?: Maybe<Scalars['Boolean']['output']>;
  /** True if the race is primary */
  isPrimary: Scalars['Boolean']['output'];
  /** True if the race is a recall election */
  isRecall: Scalars['Boolean']['output'];
  /** True if the race is a runoff */
  isRunoff: Scalars['Boolean']['output'];
  /** True if the race is for an unexpired term (i.e. off-schedule) */
  isUnexpired: Scalars['Boolean']['output'];
  position: Position;
  /** The maximum number of people who will be elected to this position during a given election. */
  seats?: Maybe<Scalars['Int']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/**
 * A unique instance of a position and election combination in the BallotReady database.
 * You can query this object for information about the race, such as what kind of race it is (isRunoff, isRecall, isPrimary, etc.) pull in the candidacies of the people running in the race, and more.
 *
 */
export type RaceCandidaciesArgs = {
  includeUncertified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for Race. */
export type RaceConnection = {
  __typename?: 'RaceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RaceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Race>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Options to filter nodes by timestamp (UTC). Combine arguments to search between timestamps. */
export type RaceCreatedAtFilter = {
  /** Exact date. */
  eq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Greater than date. */
  gt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Greater than or equal to date. */
  gte?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Less than date. */
  lt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Less than or equal to date. */
  lte?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** An edge in a connection. */
export type RaceEdge = {
  __typename?: 'RaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Race>;
};

/** Filtering options for races. */
export type RaceFilter = {
  createdAt?: InputMaybe<RaceCreatedAtFilter>;
  electionDay?: InputMaybe<ElectionDayFilter>;
  electionId?: InputMaybe<Scalars['ID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** The level of the position. */
  level?: InputMaybe<Array<PositionLevel>>;
  /** 2 character state code (e.g. `IL` for Illinois) */
  state?: InputMaybe<Scalars['String']['input']>;
  /** BallotReady tiers used to classify positions data (1-5). */
  tier?: InputMaybe<Array<Scalars['Int']['input']>>;
  updatedAt?: InputMaybe<RaceUpdatedAtFilter>;
};

/** Ordering options for races. */
export type RaceOrder = {
  /** Possible directions in which to order a list of items when provided an `orderBy` argument. */
  direction: OrderDirection;
  /** Properties by which races can be ordered. */
  field: RaceOrderField;
};

export enum RaceOrderField {
  /** Order races by election day */
  ELECTION_DAY = 'ELECTION_DAY',
  /** Order races by row order */
  ROW_ORDER = 'ROW_ORDER'
}

/** Options to filter nodes by timestamp (UTC). Combine arguments to search between timestamps. */
export type RaceUpdatedAtFilter = {
  /** Exact date. */
  eq?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Greater than date. */
  gt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Greater than or equal to date. */
  gte?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Less than date. */
  lt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Less than or equal to date. */
  lte?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** columns and relationships of "registered_voters" */
export type RegisteredVoters = {
  __typename?: 'RegisteredVoters';
  voterbaseId: Scalars['String']['output'];
};

/** aggregated selection of "registered_voters" */
export type RegisteredVotersAggregate = {
  __typename?: 'RegisteredVotersAggregate';
  aggregate?: Maybe<RegisteredVotersAggregateFields>;
  nodes: Array<RegisteredVoters>;
};

/** aggregate fields of "registered_voters" */
export type RegisteredVotersAggregateFields = {
  __typename?: 'RegisteredVotersAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RegisteredVotersMaxFields>;
  min?: Maybe<RegisteredVotersMinFields>;
};


/** aggregate fields of "registered_voters" */
export type RegisteredVotersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RegisteredVotersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "registered_voters". All fields are combined with a logical 'AND'. */
export type RegisteredVotersBoolExp = {
  _and?: InputMaybe<Array<RegisteredVotersBoolExp>>;
  _not?: InputMaybe<RegisteredVotersBoolExp>;
  _or?: InputMaybe<Array<RegisteredVotersBoolExp>>;
  voterbaseId?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "registered_voters" */
export enum RegisteredVotersConstraint {
  /** unique or primary key constraint on columns "voterbase_id" */
  REGISTERED_VOTERS_PKEY = 'registered_voters_pkey'
}

/** input type for inserting data into table "registered_voters" */
export type RegisteredVotersInsertInput = {
  voterbaseId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type RegisteredVotersMaxFields = {
  __typename?: 'RegisteredVotersMaxFields';
  voterbaseId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type RegisteredVotersMinFields = {
  __typename?: 'RegisteredVotersMinFields';
  voterbaseId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "registered_voters" */
export type RegisteredVotersMutationResponse = {
  __typename?: 'RegisteredVotersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RegisteredVoters>;
};

/** on_conflict condition type for table "registered_voters" */
export type RegisteredVotersOnConflict = {
  constraint: RegisteredVotersConstraint;
  updateColumns?: Array<RegisteredVotersUpdateColumn>;
  where?: InputMaybe<RegisteredVotersBoolExp>;
};

/** Ordering options when selecting data from "registered_voters". */
export type RegisteredVotersOrderBy = {
  voterbaseId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: registered_voters */
export type RegisteredVotersPkColumnsInput = {
  voterbaseId: Scalars['String']['input'];
};

/** select columns of table "registered_voters" */
export enum RegisteredVotersSelectColumn {
  /** column name */
  VOTERBASEID = 'voterbaseId'
}

/** input type for updating data in table "registered_voters" */
export type RegisteredVotersSetInput = {
  voterbaseId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "registered_voters" */
export type RegisteredVotersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RegisteredVotersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RegisteredVotersStreamCursorValueInput = {
  voterbaseId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "registered_voters" */
export enum RegisteredVotersUpdateColumn {
  /** column name */
  VOTERBASEID = 'voterbaseId'
}

export type RegisteredVotersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RegisteredVotersSetInput>;
  /** filter the rows which have to be updated */
  where: RegisteredVotersBoolExp;
};

export type RegistrationOption = DatabaseIdentifiable & Node & Timestamps & {
  __typename?: 'RegistrationOption';
  /**
   * Will be `null` if no upcoming election in our database yet.
   *
   * Complexity: 5
   *
   */
  availableIfDateOfBirthBeforeOrEquals?: Maybe<Scalars['ISO8601Date']['output']>;
  channel: RegistrationOptionChannel;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /** List of documents needed to register */
  documents: Array<Scalars['String']['output']>;
  /** List of eligiblity requirements */
  eligibility: Array<Scalars['String']['output']>;
  /** Added context for a regisration option */
  features: Array<RegistrationOptionFeature>;
  id: Scalars['ID']['output'];
  /** Whether a state-issued ID is required to register to vote. */
  isIdRequired: Scalars['Boolean']['output'];
  /** Whether this is a preregistration option */
  isPreregistration: Scalars['Boolean']['output'];
  place: Place;
  /** A safe estimate for the registration deadline in number of days before an election */
  safestRegistrationDeadlineInDays?: Maybe<Scalars['Int']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum RegistrationOptionChannel {
  API = 'API',
  BY_FORM = 'BY_FORM',
  ELECTION_OFFICE = 'ELECTION_OFFICE',
  NO_REGISTRATION = 'NO_REGISTRATION',
  ONLINE = 'ONLINE',
  SAME_DAY_EARLY = 'SAME_DAY_EARLY',
  SAME_DAY_ELECTION = 'SAME_DAY_ELECTION'
}

export enum RegistrationOptionFeature {
  POSTMARKED = 'POSTMARKED',
  RECEIVED = 'RECEIVED'
}

export enum RunningMate {
  GENERAL = 'GENERAL',
  PRIMARY = 'PRIMARY'
}

export enum Sentiment {
  CON = 'CON',
  PRO = 'PRO'
}

/** Objects with slug. */
export type Slug = {
  /** Unique string used to reference object in URLs */
  slug: Scalars['String']['output'];
};

export type Stance = DatabaseIdentifiable & Node & {
  __typename?: 'Stance';
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Issue category that the candidate's statement is about (i.e. Education, Economy). For a full list of issue categories we research, query the `issues` object at the top level. */
  issue: Issue;
  locale?: Maybe<Scalars['String']['output']>;
  /** Source of the candidate's issue statement */
  referenceUrl?: Maybe<Scalars['String']['output']>;
  /** The candidate's exact statement about an issue, usually pulled from their campaign website. */
  statement?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestedCandidacy = DatabaseIdentifiable & Node & Timestamps & {
  __typename?: 'SuggestedCandidacy';
  candidate?: Maybe<Person>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  election: Election;
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  parties: Array<Party>;
  position: Position;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Objects with lifecycle timestamps. */
export type Timestamps = {
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

export type Url = DatabaseIdentifiable & {
  __typename?: 'Url';
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Type of url. Common types include `website`, `instagram`, and `facebook`. */
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'Users';
  createdAt: Scalars['timestamptz']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isDisabled: Scalars['Boolean']['output'];
  oryId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  person: Persons;
  personId: Scalars['uuid']['output'];
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "users" */
export type UsersAggregate = {
  __typename?: 'UsersAggregate';
  aggregate?: Maybe<UsersAggregateFields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type UsersAggregateFields = {
  __typename?: 'UsersAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<UsersMaxFields>;
  min?: Maybe<UsersMinFields>;
};


/** aggregate fields of "users" */
export type UsersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type UsersBoolExp = {
  _and?: InputMaybe<Array<UsersBoolExp>>;
  _not?: InputMaybe<UsersBoolExp>;
  _or?: InputMaybe<Array<UsersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isDisabled?: InputMaybe<BooleanComparisonExp>;
  oryId?: InputMaybe<UuidComparisonExp>;
  person?: InputMaybe<PersonsBoolExp>;
  personId?: InputMaybe<UuidComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "users" */
export enum UsersConstraint {
  /** unique or primary key constraint on columns "ory_id" */
  USERS_ORY_ID_KEY = 'users_ory_id_key',
  /** unique or primary key constraint on columns "person_id" */
  USERS_PERSON_ID_KEY = 'users_person_id_key',
  /** unique or primary key constraint on columns "id" */
  USERS_PKEY = 'users_pkey'
}

/** input type for inserting data into table "users" */
export type UsersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  oryId?: InputMaybe<Scalars['uuid']['input']>;
  person?: InputMaybe<PersonsObjRelInsertInput>;
  personId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type UsersMaxFields = {
  __typename?: 'UsersMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  oryId?: Maybe<Scalars['uuid']['output']>;
  personId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type UsersMinFields = {
  __typename?: 'UsersMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  oryId?: Maybe<Scalars['uuid']['output']>;
  personId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "users" */
export type UsersMutationResponse = {
  __typename?: 'UsersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type UsersObjRelInsertInput = {
  data: UsersInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UsersOnConflict>;
};

/** on_conflict condition type for table "users" */
export type UsersOnConflict = {
  constraint: UsersConstraint;
  updateColumns?: Array<UsersUpdateColumn>;
  where?: InputMaybe<UsersBoolExp>;
};

/** Ordering options when selecting data from "users". */
export type UsersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isDisabled?: InputMaybe<OrderBy>;
  oryId?: InputMaybe<OrderBy>;
  person?: InputMaybe<PersonsOrderBy>;
  personId?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: users */
export type UsersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "users" */
export enum UsersSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  EMAIL = 'email',
  /** column name */
  ID = 'id',
  /** column name */
  ISDISABLED = 'isDisabled',
  /** column name */
  ORYID = 'oryId',
  /** column name */
  PERSONID = 'personId',
  /** column name */
  PHONENUMBER = 'phoneNumber',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "users" */
export type UsersSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  oryId?: InputMaybe<Scalars['uuid']['input']>;
  personId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "users" */
export type UsersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UsersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  oryId?: InputMaybe<Scalars['uuid']['input']>;
  personId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "users" */
export enum UsersUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  EMAIL = 'email',
  /** column name */
  ID = 'id',
  /** column name */
  ISDISABLED = 'isDisabled',
  /** column name */
  ORYID = 'oryId',
  /** column name */
  PERSONID = 'personId',
  /** column name */
  PHONENUMBER = 'phoneNumber',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type UsersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersSetInput>;
  /** filter the rows which have to be updated */
  where: UsersBoolExp;
};

export type UtmInput = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/**
 *       VIP (Voter Information Project / [Google Civic API](https://developers.google.com/civic-information)) election ID
 *
 */
export type VipElection = {
  __typename?: 'VipElection';
  /** Optional party to handle cases where VIP has multiple elections for a single election (e.g. Texas party primaries) */
  party?: Maybe<Party>;
  /** VIP election ID */
  vipId: Scalars['Int']['output'];
};

/** columns and relationships of "voter_verification_jurisdiction_rels" */
export type VoterVerificationJurisdictionRels = {
  __typename?: 'VoterVerificationJurisdictionRels';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  jurisdiction: Jurisdictions;
  jurisdictionId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  voterVerification: VoterVerifications;
  voterVerificationId: Scalars['uuid']['output'];
};

/** aggregated selection of "voter_verification_jurisdiction_rels" */
export type VoterVerificationJurisdictionRelsAggregate = {
  __typename?: 'VoterVerificationJurisdictionRelsAggregate';
  aggregate?: Maybe<VoterVerificationJurisdictionRelsAggregateFields>;
  nodes: Array<VoterVerificationJurisdictionRels>;
};

export type VoterVerificationJurisdictionRelsAggregateBoolExp = {
  count?: InputMaybe<VoterVerificationJurisdictionRelsAggregateBoolExpCount>;
};

/** aggregate fields of "voter_verification_jurisdiction_rels" */
export type VoterVerificationJurisdictionRelsAggregateFields = {
  __typename?: 'VoterVerificationJurisdictionRelsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<VoterVerificationJurisdictionRelsMaxFields>;
  min?: Maybe<VoterVerificationJurisdictionRelsMinFields>;
};


/** aggregate fields of "voter_verification_jurisdiction_rels" */
export type VoterVerificationJurisdictionRelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VoterVerificationJurisdictionRelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "voter_verification_jurisdiction_rels" */
export type VoterVerificationJurisdictionRelsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VoterVerificationJurisdictionRelsMaxOrderBy>;
  min?: InputMaybe<VoterVerificationJurisdictionRelsMinOrderBy>;
};

/** input type for inserting array relation for remote table "voter_verification_jurisdiction_rels" */
export type VoterVerificationJurisdictionRelsArrRelInsertInput = {
  data: Array<VoterVerificationJurisdictionRelsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VoterVerificationJurisdictionRelsOnConflict>;
};

/** Boolean expression to filter rows from the table "voter_verification_jurisdiction_rels". All fields are combined with a logical 'AND'. */
export type VoterVerificationJurisdictionRelsBoolExp = {
  _and?: InputMaybe<Array<VoterVerificationJurisdictionRelsBoolExp>>;
  _not?: InputMaybe<VoterVerificationJurisdictionRelsBoolExp>;
  _or?: InputMaybe<Array<VoterVerificationJurisdictionRelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  jurisdiction?: InputMaybe<JurisdictionsBoolExp>;
  jurisdictionId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  voterVerification?: InputMaybe<VoterVerificationsBoolExp>;
  voterVerificationId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "voter_verification_jurisdiction_rels" */
export enum VoterVerificationJurisdictionRelsConstraint {
  /** unique or primary key constraint on columns "id" */
  VOTER_VERIFICATION_JURISDICTION_RELS_PKEY = 'voter_verification_jurisdiction_rels_pkey',
  /** unique or primary key constraint on columns "jurisdiction_id", "voter_verification_id" */
  VOTER_VERIFICATION_JURISDICTION_RELS_VOTER_VERIFICATION_ID_JURI = 'voter_verification_jurisdiction_rels_voter_verification_id_juri'
}

/** input type for inserting data into table "voter_verification_jurisdiction_rels" */
export type VoterVerificationJurisdictionRelsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdiction?: InputMaybe<JurisdictionsObjRelInsertInput>;
  jurisdictionId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  voterVerification?: InputMaybe<VoterVerificationsObjRelInsertInput>;
  voterVerificationId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type VoterVerificationJurisdictionRelsMaxFields = {
  __typename?: 'VoterVerificationJurisdictionRelsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jurisdictionId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  voterVerificationId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "voter_verification_jurisdiction_rels" */
export type VoterVerificationJurisdictionRelsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jurisdictionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  voterVerificationId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VoterVerificationJurisdictionRelsMinFields = {
  __typename?: 'VoterVerificationJurisdictionRelsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jurisdictionId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  voterVerificationId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "voter_verification_jurisdiction_rels" */
export type VoterVerificationJurisdictionRelsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jurisdictionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  voterVerificationId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "voter_verification_jurisdiction_rels" */
export type VoterVerificationJurisdictionRelsMutationResponse = {
  __typename?: 'VoterVerificationJurisdictionRelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<VoterVerificationJurisdictionRels>;
};

/** on_conflict condition type for table "voter_verification_jurisdiction_rels" */
export type VoterVerificationJurisdictionRelsOnConflict = {
  constraint: VoterVerificationJurisdictionRelsConstraint;
  updateColumns?: Array<VoterVerificationJurisdictionRelsUpdateColumn>;
  where?: InputMaybe<VoterVerificationJurisdictionRelsBoolExp>;
};

/** Ordering options when selecting data from "voter_verification_jurisdiction_rels". */
export type VoterVerificationJurisdictionRelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jurisdiction?: InputMaybe<JurisdictionsOrderBy>;
  jurisdictionId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  voterVerification?: InputMaybe<VoterVerificationsOrderBy>;
  voterVerificationId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: voter_verification_jurisdiction_rels */
export type VoterVerificationJurisdictionRelsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "voter_verification_jurisdiction_rels" */
export enum VoterVerificationJurisdictionRelsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  JURISDICTIONID = 'jurisdictionId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  VOTERVERIFICATIONID = 'voterVerificationId'
}

/** input type for updating data in table "voter_verification_jurisdiction_rels" */
export type VoterVerificationJurisdictionRelsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictionId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  voterVerificationId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "voter_verification_jurisdiction_rels" */
export type VoterVerificationJurisdictionRelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VoterVerificationJurisdictionRelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VoterVerificationJurisdictionRelsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictionId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  voterVerificationId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "voter_verification_jurisdiction_rels" */
export enum VoterVerificationJurisdictionRelsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  JURISDICTIONID = 'jurisdictionId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  VOTERVERIFICATIONID = 'voterVerificationId'
}

export type VoterVerificationJurisdictionRelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VoterVerificationJurisdictionRelsSetInput>;
  /** filter the rows which have to be updated */
  where: VoterVerificationJurisdictionRelsBoolExp;
};

/** columns and relationships of "voter_verifications" */
export type VoterVerifications = {
  __typename?: 'VoterVerifications';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  person: Persons;
  personId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  voterVerificationJurisdictionRels: Array<VoterVerificationJurisdictionRels>;
  /** An aggregate relationship */
  voterVerificationJurisdictionRelsAggregate: VoterVerificationJurisdictionRelsAggregate;
};


/** columns and relationships of "voter_verifications" */
export type VoterVerificationsVoterVerificationJurisdictionRelsArgs = {
  distinctOn?: InputMaybe<Array<VoterVerificationJurisdictionRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoterVerificationJurisdictionRelsOrderBy>>;
  where?: InputMaybe<VoterVerificationJurisdictionRelsBoolExp>;
};


/** columns and relationships of "voter_verifications" */
export type VoterVerificationsVoterVerificationJurisdictionRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VoterVerificationJurisdictionRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoterVerificationJurisdictionRelsOrderBy>>;
  where?: InputMaybe<VoterVerificationJurisdictionRelsBoolExp>;
};

/** aggregated selection of "voter_verifications" */
export type VoterVerificationsAggregate = {
  __typename?: 'VoterVerificationsAggregate';
  aggregate?: Maybe<VoterVerificationsAggregateFields>;
  nodes: Array<VoterVerifications>;
};

export type VoterVerificationsAggregateBoolExp = {
  count?: InputMaybe<VoterVerificationsAggregateBoolExpCount>;
};

/** aggregate fields of "voter_verifications" */
export type VoterVerificationsAggregateFields = {
  __typename?: 'VoterVerificationsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<VoterVerificationsMaxFields>;
  min?: Maybe<VoterVerificationsMinFields>;
};


/** aggregate fields of "voter_verifications" */
export type VoterVerificationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VoterVerificationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "voter_verifications" */
export type VoterVerificationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VoterVerificationsMaxOrderBy>;
  min?: InputMaybe<VoterVerificationsMinOrderBy>;
};

/** input type for inserting array relation for remote table "voter_verifications" */
export type VoterVerificationsArrRelInsertInput = {
  data: Array<VoterVerificationsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<VoterVerificationsOnConflict>;
};

/** Boolean expression to filter rows from the table "voter_verifications". All fields are combined with a logical 'AND'. */
export type VoterVerificationsBoolExp = {
  _and?: InputMaybe<Array<VoterVerificationsBoolExp>>;
  _not?: InputMaybe<VoterVerificationsBoolExp>;
  _or?: InputMaybe<Array<VoterVerificationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  person?: InputMaybe<PersonsBoolExp>;
  personId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  voterVerificationJurisdictionRels?: InputMaybe<VoterVerificationJurisdictionRelsBoolExp>;
  voterVerificationJurisdictionRelsAggregate?: InputMaybe<VoterVerificationJurisdictionRelsAggregateBoolExp>;
};

/** unique or primary key constraints on table "voter_verifications" */
export enum VoterVerificationsConstraint {
  /** unique or primary key constraint on columns "id" */
  VOTER_VERIFICATIONS_PKEY = 'voter_verifications_pkey'
}

/** input type for inserting data into table "voter_verifications" */
export type VoterVerificationsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  person?: InputMaybe<PersonsObjRelInsertInput>;
  personId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  voterVerificationJurisdictionRels?: InputMaybe<VoterVerificationJurisdictionRelsArrRelInsertInput>;
};

/** aggregate max on columns */
export type VoterVerificationsMaxFields = {
  __typename?: 'VoterVerificationsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  personId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "voter_verifications" */
export type VoterVerificationsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  personId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VoterVerificationsMinFields = {
  __typename?: 'VoterVerificationsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  personId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "voter_verifications" */
export type VoterVerificationsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  personId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "voter_verifications" */
export type VoterVerificationsMutationResponse = {
  __typename?: 'VoterVerificationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<VoterVerifications>;
};

/** input type for inserting object relation for remote table "voter_verifications" */
export type VoterVerificationsObjRelInsertInput = {
  data: VoterVerificationsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<VoterVerificationsOnConflict>;
};

/** on_conflict condition type for table "voter_verifications" */
export type VoterVerificationsOnConflict = {
  constraint: VoterVerificationsConstraint;
  updateColumns?: Array<VoterVerificationsUpdateColumn>;
  where?: InputMaybe<VoterVerificationsBoolExp>;
};

/** Ordering options when selecting data from "voter_verifications". */
export type VoterVerificationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  person?: InputMaybe<PersonsOrderBy>;
  personId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  voterVerificationJurisdictionRelsAggregate?: InputMaybe<VoterVerificationJurisdictionRelsAggregateOrderBy>;
};

/** primary key columns input for table: voter_verifications */
export type VoterVerificationsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "voter_verifications" */
export enum VoterVerificationsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  PERSONID = 'personId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "voter_verifications" */
export type VoterVerificationsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  personId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "voter_verifications" */
export type VoterVerificationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VoterVerificationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VoterVerificationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  personId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "voter_verifications" */
export enum VoterVerificationsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  PERSONID = 'personId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type VoterVerificationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VoterVerificationsSetInput>;
  /** filter the rows which have to be updated */
  where: VoterVerificationsBoolExp;
};

export type VotingDay = DatabaseIdentifiable & Node & Timestamps & {
  __typename?: 'VotingDay';
  /** UTC date and time polling place closes. Use `timezone` to convert to local date and time. */
  closeAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isDropOff: Scalars['Boolean']['output'];
  isEarlyVoting: Scalars['Boolean']['output'];
  isInPerson: Scalars['Boolean']['output'];
  /** UTC date and time polling place opens. Use `timezone` to convert to local date and time. */
  openAt: Scalars['ISO8601DateTime']['output'];
  timezone: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for VotingDay. */
export type VotingDayConnection = {
  __typename?: 'VotingDayConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VotingDayEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<VotingDay>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type VotingDayEdge = {
  __typename?: 'VotingDayEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<VotingDay>;
};

/**
 * BallotReady collects information about ballot drop boxes and in person voting locations (both listed here).
 * Generally, this does not include precinct-based voting locations available on election day.
 * If you query by latitude/longitude, you will see the voting locations available at that location.
 * The MTFCC and geoID values attached to each voting location note which area the voting location is available to (usually county).
 *
 */
export type VotingLocation = DatabaseIdentifiable & GeographicalIdentifiers & Node & Timestamps & {
  __typename?: 'VotingLocation';
  address?: Maybe<Address>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  election: Election;
  /**
   * GEOIDs are numeric codes that uniquely identify all administrative/legal and statistical geographic areas for which the Census Bureau tabulates data.
   *
   * More information: https://www.census.gov/programs-surveys/geography/guidance/geo-identifiers.html
   *
   */
  geoId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * MAF/TIGER Feature Class Code, a census designated code of 1 letter and 4 numbers (e.g. G4000) designating what kind of geographical entity is being described (Congressional District, Incorporated Place, County or Equivalent Features, etc).
   *
   * More information: https://www.census.gov/library/reference/code-lists/mt-feature-class-codes.html
   *
   * List of commonly used MTFCC:
   *
   * * State: `G4000`
   * * County: `G4020`
   * * City: `G4110`
   *
   * Any MTFCC starting with `X` is a BallotReady defined custom code.
   *
   */
  mtfcc?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  party?: Maybe<Party>;
  precinct?: Maybe<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Collection of dates and times when this voting location is open
   *
   * A single date might have multiple entries. This could be because there are different times
   * for in person voting and dropping off your ballot. It could also be that a voting location is
   * closed part of the day (e.g. because of a lunch break).
   *
   */
  votingDays: VotingDayConnection;
};


/**
 * BallotReady collects information about ballot drop boxes and in person voting locations (both listed here).
 * Generally, this does not include precinct-based voting locations available on election day.
 * If you query by latitude/longitude, you will see the voting locations available at that location.
 * The MTFCC and geoID values attached to each voting location note which area the voting location is available to (usually county).
 *
 */
export type VotingLocationVotingDaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for VotingLocation. */
export type VotingLocationConnection = {
  __typename?: 'VotingLocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VotingLocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<VotingLocation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type VotingLocationEdge = {
  __typename?: 'VotingLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<VotingLocation>;
};

/** Filtering options for polling places. */
export type VotingLocationFilter = {
  electionId: Scalars['ID']['input'];
  /**
   * Filter by GEOID.
   *
   * Supports 3 options:
   *
   * 1. Filter by a single, exact GEOID (e.g. `geoId: "02"` to find all state-level objects in Alaska)
   * 2. Filter by a single, inexact GEOID with a wild card at the end (e.g. `geoId: "02*"` to find all objects in Alaska)
   * 3. Filter by multiple exact GEOIDs at the same time (e.g. `geoId: ["02", "17"]` to return state-level objects in both Alaska and Illinois)
   *
   * More information about GEOIDs: https://www.census.gov/programs-surveys/geography/guidance/geo-identifiers.html
   *
   */
  geoId?: InputMaybe<Array<Scalars['String']['input']>>;
  isDropOff?: InputMaybe<Scalars['Boolean']['input']>;
  isEarlyVoting?: InputMaybe<Scalars['Boolean']['input']>;
  isInPerson?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * MAF/TIGER Feature Class Code, a census designated code of 1 letter and 4 numbers (e.g. G4000) designating what kind of geographical entity is being described (Congressional District, Incorporated Place, County or Equivalent Features, etc).
   *
   * More information: https://www.census.gov/library/reference/code-lists/mt-feature-class-codes.html
   *
   * List of commonly used MTFCC:
   *
   * * State: `G4000`
   * * County: `G4020`
   * * City: `G4110`
   *
   */
  mtfcc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 2 character state code (e.g. `IL` for Illinois). */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "waitlist" */
export type Waitlist = {
  __typename?: 'Waitlist';
  createdAt: Scalars['timestamptz']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isIssueLeader?: Maybe<Scalars['Boolean']['output']>;
  issueDescription?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "waitlist" */
export type WaitlistAggregate = {
  __typename?: 'WaitlistAggregate';
  aggregate?: Maybe<WaitlistAggregateFields>;
  nodes: Array<Waitlist>;
};

/** aggregate fields of "waitlist" */
export type WaitlistAggregateFields = {
  __typename?: 'WaitlistAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<WaitlistMaxFields>;
  min?: Maybe<WaitlistMinFields>;
};


/** aggregate fields of "waitlist" */
export type WaitlistAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WaitlistSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "waitlist". All fields are combined with a logical 'AND'. */
export type WaitlistBoolExp = {
  _and?: InputMaybe<Array<WaitlistBoolExp>>;
  _not?: InputMaybe<WaitlistBoolExp>;
  _or?: InputMaybe<Array<WaitlistBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isIssueLeader?: InputMaybe<BooleanComparisonExp>;
  issueDescription?: InputMaybe<StringComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  location?: InputMaybe<StringComparisonExp>;
  organizationName?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "waitlist" */
export enum WaitlistConstraint {
  /** unique or primary key constraint on columns "id" */
  WAITLIST_PKEY = 'waitlist_pkey'
}

/** input type for inserting data into table "waitlist" */
export type WaitlistInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isIssueLeader?: InputMaybe<Scalars['Boolean']['input']>;
  issueDescription?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type WaitlistMaxFields = {
  __typename?: 'WaitlistMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  issueDescription?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type WaitlistMinFields = {
  __typename?: 'WaitlistMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  issueDescription?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "waitlist" */
export type WaitlistMutationResponse = {
  __typename?: 'WaitlistMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Waitlist>;
};

/** on_conflict condition type for table "waitlist" */
export type WaitlistOnConflict = {
  constraint: WaitlistConstraint;
  updateColumns?: Array<WaitlistUpdateColumn>;
  where?: InputMaybe<WaitlistBoolExp>;
};

/** Ordering options when selecting data from "waitlist". */
export type WaitlistOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isIssueLeader?: InputMaybe<OrderBy>;
  issueDescription?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  location?: InputMaybe<OrderBy>;
  organizationName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: waitlist */
export type WaitlistPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "waitlist" */
export enum WaitlistSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  EMAIL = 'email',
  /** column name */
  FIRSTNAME = 'firstName',
  /** column name */
  ID = 'id',
  /** column name */
  ISISSUELEADER = 'isIssueLeader',
  /** column name */
  ISSUEDESCRIPTION = 'issueDescription',
  /** column name */
  LASTNAME = 'lastName',
  /** column name */
  LOCATION = 'location',
  /** column name */
  ORGANIZATIONNAME = 'organizationName',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "waitlist" */
export type WaitlistSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isIssueLeader?: InputMaybe<Scalars['Boolean']['input']>;
  issueDescription?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "waitlist" */
export type WaitlistStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: WaitlistStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WaitlistStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isIssueLeader?: InputMaybe<Scalars['Boolean']['input']>;
  issueDescription?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "waitlist" */
export enum WaitlistUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  EMAIL = 'email',
  /** column name */
  FIRSTNAME = 'firstName',
  /** column name */
  ID = 'id',
  /** column name */
  ISISSUELEADER = 'isIssueLeader',
  /** column name */
  ISSUEDESCRIPTION = 'issueDescription',
  /** column name */
  LASTNAME = 'lastName',
  /** column name */
  LOCATION = 'location',
  /** column name */
  ORGANIZATIONNAME = 'organizationName',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type WaitlistUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WaitlistSetInput>;
  /** filter the rows which have to be updated */
  where: WaitlistBoolExp;
};

export type EntitiesAggregateBoolExpBool_And = {
  arguments: EntitiesSelectColumnEntitiesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EntitiesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EntitiesAggregateBoolExpBool_Or = {
  arguments: EntitiesSelectColumnEntitiesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EntitiesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EntitiesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EntitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EntitiesBoolExp>;
  predicate: IntComparisonExp;
};

export type EntityPersonRelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EntityPersonRelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EntityPersonRelsBoolExp>;
  predicate: IntComparisonExp;
};

export type InfluenceTargetsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InfluenceTargetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InfluenceTargetsBoolExp>;
  predicate: IntComparisonExp;
};

export type IssueExternalLinkRelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IssueExternalLinkRelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<IssueExternalLinkRelsBoolExp>;
  predicate: IntComparisonExp;
};

export type IssueInfluenceTargetRelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IssueInfluenceTargetRelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<IssueInfluenceTargetRelsBoolExp>;
  predicate: IntComparisonExp;
};

export type IssueMediaRelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IssueMediaRelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<IssueMediaRelsBoolExp>;
  predicate: IntComparisonExp;
};

export type IssueSupporterRelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IssueSupporterRelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<IssueSupporterRelsBoolExp>;
  predicate: IntComparisonExp;
};

export type IssuesAggregateBoolExpBool_And = {
  arguments: IssuesSelectColumnIssuesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<IssuesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type IssuesAggregateBoolExpBool_Or = {
  arguments: IssuesSelectColumnIssuesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<IssuesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type IssuesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IssuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<IssuesBoolExp>;
  predicate: IntComparisonExp;
};

export type MeasuresAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MeasuresSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MeasuresBoolExp>;
  predicate: IntComparisonExp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  CivicEngine?: Maybe<CivicEngineMutation>;
  /** delete data from the table: "entities" */
  deleteEntities?: Maybe<EntitiesMutationResponse>;
  /** delete single row from the table: "entities" */
  deleteEntitiesByPk?: Maybe<Entities>;
  /** delete data from the table: "entity_person_rels" */
  deleteEntityPersonRels?: Maybe<EntityPersonRelsMutationResponse>;
  /** delete single row from the table: "entity_person_rels" */
  deleteEntityPersonRelsByPk?: Maybe<EntityPersonRels>;
  /** delete data from the table: "entity_types" */
  deleteEntityTypes?: Maybe<EntityTypesMutationResponse>;
  /** delete single row from the table: "entity_types" */
  deleteEntityTypesByPk?: Maybe<EntityTypes>;
  /** delete data from the table: "external_links" */
  deleteExternalLinks?: Maybe<ExternalLinksMutationResponse>;
  /** delete single row from the table: "external_links" */
  deleteExternalLinksByPk?: Maybe<ExternalLinks>;
  /** delete data from the table: "influence_targets" */
  deleteInfluenceTargets?: Maybe<InfluenceTargetsMutationResponse>;
  /** delete single row from the table: "influence_targets" */
  deleteInfluenceTargetsByPk?: Maybe<InfluenceTargets>;
  /** delete data from the table: "issue_external_link_rels" */
  deleteIssueExternalLinkRels?: Maybe<IssueExternalLinkRelsMutationResponse>;
  /** delete single row from the table: "issue_external_link_rels" */
  deleteIssueExternalLinkRelsByPk?: Maybe<IssueExternalLinkRels>;
  /** delete data from the table: "issue_influence_target_rels" */
  deleteIssueInfluenceTargetRels?: Maybe<IssueInfluenceTargetRelsMutationResponse>;
  /** delete single row from the table: "issue_influence_target_rels" */
  deleteIssueInfluenceTargetRelsByPk?: Maybe<IssueInfluenceTargetRels>;
  /** delete data from the table: "issue_media_rels" */
  deleteIssueMediaRels?: Maybe<IssueMediaRelsMutationResponse>;
  /** delete single row from the table: "issue_media_rels" */
  deleteIssueMediaRelsByPk?: Maybe<IssueMediaRels>;
  /** delete data from the table: "issue_supporter_rels" */
  deleteIssueSupporterRels?: Maybe<IssueSupporterRelsMutationResponse>;
  /** delete single row from the table: "issue_supporter_rels" */
  deleteIssueSupporterRelsByPk?: Maybe<IssueSupporterRels>;
  /** delete data from the table: "issues" */
  deleteIssues?: Maybe<IssuesMutationResponse>;
  /** delete single row from the table: "issues" */
  deleteIssuesByPk?: Maybe<Issues>;
  /** delete data from the table: "jurisdictions" */
  deleteJurisdictions?: Maybe<JurisdictionsMutationResponse>;
  /** delete single row from the table: "jurisdictions" */
  deleteJurisdictionsByPk?: Maybe<Jurisdictions>;
  /** delete data from the table: "measures" */
  deleteMeasures?: Maybe<MeasuresMutationResponse>;
  /** delete single row from the table: "measures" */
  deleteMeasuresByPk?: Maybe<Measures>;
  /** delete data from the table: "media" */
  deleteMedia?: Maybe<MediaMutationResponse>;
  /** delete single row from the table: "media" */
  deleteMediaByPk?: Maybe<Media>;
  /** delete data from the table: "offices" */
  deleteOffices?: Maybe<OfficesMutationResponse>;
  /** delete single row from the table: "offices" */
  deleteOfficesByPk?: Maybe<Offices>;
  /** delete data from the table: "persons" */
  deletePersons?: Maybe<PersonsMutationResponse>;
  /** delete single row from the table: "persons" */
  deletePersonsByPk?: Maybe<Persons>;
  /** delete data from the table: "registered_voters" */
  deleteRegisteredVoters?: Maybe<RegisteredVotersMutationResponse>;
  /** delete single row from the table: "registered_voters" */
  deleteRegisteredVotersByPk?: Maybe<RegisteredVoters>;
  /** delete data from the table: "users" */
  deleteUsers?: Maybe<UsersMutationResponse>;
  /** delete single row from the table: "users" */
  deleteUsersByPk?: Maybe<Users>;
  /** delete data from the table: "voter_verification_jurisdiction_rels" */
  deleteVoterVerificationJurisdictionRels?: Maybe<VoterVerificationJurisdictionRelsMutationResponse>;
  /** delete single row from the table: "voter_verification_jurisdiction_rels" */
  deleteVoterVerificationJurisdictionRelsByPk?: Maybe<VoterVerificationJurisdictionRels>;
  /** delete data from the table: "voter_verifications" */
  deleteVoterVerifications?: Maybe<VoterVerificationsMutationResponse>;
  /** delete single row from the table: "voter_verifications" */
  deleteVoterVerificationsByPk?: Maybe<VoterVerifications>;
  /** delete data from the table: "waitlist" */
  deleteWaitlist?: Maybe<WaitlistMutationResponse>;
  /** delete single row from the table: "waitlist" */
  deleteWaitlistByPk?: Maybe<Waitlist>;
  /** insert data into the table: "entities" */
  insertEntities?: Maybe<EntitiesMutationResponse>;
  /** insert a single row into the table: "entities" */
  insertEntitiesOne?: Maybe<Entities>;
  /** insert data into the table: "entity_person_rels" */
  insertEntityPersonRels?: Maybe<EntityPersonRelsMutationResponse>;
  /** insert a single row into the table: "entity_person_rels" */
  insertEntityPersonRelsOne?: Maybe<EntityPersonRels>;
  /** insert data into the table: "entity_types" */
  insertEntityTypes?: Maybe<EntityTypesMutationResponse>;
  /** insert a single row into the table: "entity_types" */
  insertEntityTypesOne?: Maybe<EntityTypes>;
  /** insert data into the table: "external_links" */
  insertExternalLinks?: Maybe<ExternalLinksMutationResponse>;
  /** insert a single row into the table: "external_links" */
  insertExternalLinksOne?: Maybe<ExternalLinks>;
  /** insert data into the table: "influence_targets" */
  insertInfluenceTargets?: Maybe<InfluenceTargetsMutationResponse>;
  /** insert a single row into the table: "influence_targets" */
  insertInfluenceTargetsOne?: Maybe<InfluenceTargets>;
  /** insert data into the table: "issue_external_link_rels" */
  insertIssueExternalLinkRels?: Maybe<IssueExternalLinkRelsMutationResponse>;
  /** insert a single row into the table: "issue_external_link_rels" */
  insertIssueExternalLinkRelsOne?: Maybe<IssueExternalLinkRels>;
  /** insert data into the table: "issue_influence_target_rels" */
  insertIssueInfluenceTargetRels?: Maybe<IssueInfluenceTargetRelsMutationResponse>;
  /** insert a single row into the table: "issue_influence_target_rels" */
  insertIssueInfluenceTargetRelsOne?: Maybe<IssueInfluenceTargetRels>;
  /** insert data into the table: "issue_media_rels" */
  insertIssueMediaRels?: Maybe<IssueMediaRelsMutationResponse>;
  /** insert a single row into the table: "issue_media_rels" */
  insertIssueMediaRelsOne?: Maybe<IssueMediaRels>;
  /** insert data into the table: "issue_supporter_rels" */
  insertIssueSupporterRels?: Maybe<IssueSupporterRelsMutationResponse>;
  /** insert a single row into the table: "issue_supporter_rels" */
  insertIssueSupporterRelsOne?: Maybe<IssueSupporterRels>;
  /** insert data into the table: "issues" */
  insertIssues?: Maybe<IssuesMutationResponse>;
  /** insert a single row into the table: "issues" */
  insertIssuesOne?: Maybe<Issues>;
  /** insert data into the table: "jurisdictions" */
  insertJurisdictions?: Maybe<JurisdictionsMutationResponse>;
  /** insert a single row into the table: "jurisdictions" */
  insertJurisdictionsOne?: Maybe<Jurisdictions>;
  /** insert data into the table: "measures" */
  insertMeasures?: Maybe<MeasuresMutationResponse>;
  /** insert a single row into the table: "measures" */
  insertMeasuresOne?: Maybe<Measures>;
  /** insert data into the table: "media" */
  insertMedia?: Maybe<MediaMutationResponse>;
  /** insert a single row into the table: "media" */
  insertMediaOne?: Maybe<Media>;
  /** insert data into the table: "offices" */
  insertOffices?: Maybe<OfficesMutationResponse>;
  /** insert a single row into the table: "offices" */
  insertOfficesOne?: Maybe<Offices>;
  /** insert data into the table: "persons" */
  insertPersons?: Maybe<PersonsMutationResponse>;
  /** insert a single row into the table: "persons" */
  insertPersonsOne?: Maybe<Persons>;
  /** insert data into the table: "registered_voters" */
  insertRegisteredVoters?: Maybe<RegisteredVotersMutationResponse>;
  /** insert a single row into the table: "registered_voters" */
  insertRegisteredVotersOne?: Maybe<RegisteredVoters>;
  /** insert data into the table: "users" */
  insertUsers?: Maybe<UsersMutationResponse>;
  /** insert a single row into the table: "users" */
  insertUsersOne?: Maybe<Users>;
  /** insert data into the table: "voter_verification_jurisdiction_rels" */
  insertVoterVerificationJurisdictionRels?: Maybe<VoterVerificationJurisdictionRelsMutationResponse>;
  /** insert a single row into the table: "voter_verification_jurisdiction_rels" */
  insertVoterVerificationJurisdictionRelsOne?: Maybe<VoterVerificationJurisdictionRels>;
  /** insert data into the table: "voter_verifications" */
  insertVoterVerifications?: Maybe<VoterVerificationsMutationResponse>;
  /** insert a single row into the table: "voter_verifications" */
  insertVoterVerificationsOne?: Maybe<VoterVerifications>;
  /** insert data into the table: "waitlist" */
  insertWaitlist?: Maybe<WaitlistMutationResponse>;
  /** insert a single row into the table: "waitlist" */
  insertWaitlistOne?: Maybe<Waitlist>;
  /** update data of the table: "entities" */
  updateEntities?: Maybe<EntitiesMutationResponse>;
  /** update single row of the table: "entities" */
  updateEntitiesByPk?: Maybe<Entities>;
  /** update multiples rows of table: "entities" */
  updateEntitiesMany?: Maybe<Array<Maybe<EntitiesMutationResponse>>>;
  /** update data of the table: "entity_person_rels" */
  updateEntityPersonRels?: Maybe<EntityPersonRelsMutationResponse>;
  /** update single row of the table: "entity_person_rels" */
  updateEntityPersonRelsByPk?: Maybe<EntityPersonRels>;
  /** update multiples rows of table: "entity_person_rels" */
  updateEntityPersonRelsMany?: Maybe<Array<Maybe<EntityPersonRelsMutationResponse>>>;
  /** update data of the table: "entity_types" */
  updateEntityTypes?: Maybe<EntityTypesMutationResponse>;
  /** update single row of the table: "entity_types" */
  updateEntityTypesByPk?: Maybe<EntityTypes>;
  /** update multiples rows of table: "entity_types" */
  updateEntityTypesMany?: Maybe<Array<Maybe<EntityTypesMutationResponse>>>;
  /** update data of the table: "external_links" */
  updateExternalLinks?: Maybe<ExternalLinksMutationResponse>;
  /** update single row of the table: "external_links" */
  updateExternalLinksByPk?: Maybe<ExternalLinks>;
  /** update multiples rows of table: "external_links" */
  updateExternalLinksMany?: Maybe<Array<Maybe<ExternalLinksMutationResponse>>>;
  /** update data of the table: "influence_targets" */
  updateInfluenceTargets?: Maybe<InfluenceTargetsMutationResponse>;
  /** update single row of the table: "influence_targets" */
  updateInfluenceTargetsByPk?: Maybe<InfluenceTargets>;
  /** update multiples rows of table: "influence_targets" */
  updateInfluenceTargetsMany?: Maybe<Array<Maybe<InfluenceTargetsMutationResponse>>>;
  /** update data of the table: "issue_external_link_rels" */
  updateIssueExternalLinkRels?: Maybe<IssueExternalLinkRelsMutationResponse>;
  /** update single row of the table: "issue_external_link_rels" */
  updateIssueExternalLinkRelsByPk?: Maybe<IssueExternalLinkRels>;
  /** update multiples rows of table: "issue_external_link_rels" */
  updateIssueExternalLinkRelsMany?: Maybe<Array<Maybe<IssueExternalLinkRelsMutationResponse>>>;
  /** update data of the table: "issue_influence_target_rels" */
  updateIssueInfluenceTargetRels?: Maybe<IssueInfluenceTargetRelsMutationResponse>;
  /** update single row of the table: "issue_influence_target_rels" */
  updateIssueInfluenceTargetRelsByPk?: Maybe<IssueInfluenceTargetRels>;
  /** update multiples rows of table: "issue_influence_target_rels" */
  updateIssueInfluenceTargetRelsMany?: Maybe<Array<Maybe<IssueInfluenceTargetRelsMutationResponse>>>;
  /** update data of the table: "issue_media_rels" */
  updateIssueMediaRels?: Maybe<IssueMediaRelsMutationResponse>;
  /** update single row of the table: "issue_media_rels" */
  updateIssueMediaRelsByPk?: Maybe<IssueMediaRels>;
  /** update multiples rows of table: "issue_media_rels" */
  updateIssueMediaRelsMany?: Maybe<Array<Maybe<IssueMediaRelsMutationResponse>>>;
  /** update data of the table: "issue_supporter_rels" */
  updateIssueSupporterRels?: Maybe<IssueSupporterRelsMutationResponse>;
  /** update single row of the table: "issue_supporter_rels" */
  updateIssueSupporterRelsByPk?: Maybe<IssueSupporterRels>;
  /** update multiples rows of table: "issue_supporter_rels" */
  updateIssueSupporterRelsMany?: Maybe<Array<Maybe<IssueSupporterRelsMutationResponse>>>;
  /** update data of the table: "issues" */
  updateIssues?: Maybe<IssuesMutationResponse>;
  /** update single row of the table: "issues" */
  updateIssuesByPk?: Maybe<Issues>;
  /** update multiples rows of table: "issues" */
  updateIssuesMany?: Maybe<Array<Maybe<IssuesMutationResponse>>>;
  /** update data of the table: "jurisdictions" */
  updateJurisdictions?: Maybe<JurisdictionsMutationResponse>;
  /** update single row of the table: "jurisdictions" */
  updateJurisdictionsByPk?: Maybe<Jurisdictions>;
  /** update multiples rows of table: "jurisdictions" */
  updateJurisdictionsMany?: Maybe<Array<Maybe<JurisdictionsMutationResponse>>>;
  /** update data of the table: "measures" */
  updateMeasures?: Maybe<MeasuresMutationResponse>;
  /** update single row of the table: "measures" */
  updateMeasuresByPk?: Maybe<Measures>;
  /** update multiples rows of table: "measures" */
  updateMeasuresMany?: Maybe<Array<Maybe<MeasuresMutationResponse>>>;
  /** update data of the table: "media" */
  updateMedia?: Maybe<MediaMutationResponse>;
  /** update single row of the table: "media" */
  updateMediaByPk?: Maybe<Media>;
  /** update multiples rows of table: "media" */
  updateMediaMany?: Maybe<Array<Maybe<MediaMutationResponse>>>;
  /** update data of the table: "offices" */
  updateOffices?: Maybe<OfficesMutationResponse>;
  /** update single row of the table: "offices" */
  updateOfficesByPk?: Maybe<Offices>;
  /** update multiples rows of table: "offices" */
  updateOfficesMany?: Maybe<Array<Maybe<OfficesMutationResponse>>>;
  /** update data of the table: "persons" */
  updatePersons?: Maybe<PersonsMutationResponse>;
  /** update single row of the table: "persons" */
  updatePersonsByPk?: Maybe<Persons>;
  /** update multiples rows of table: "persons" */
  updatePersonsMany?: Maybe<Array<Maybe<PersonsMutationResponse>>>;
  /** update data of the table: "registered_voters" */
  updateRegisteredVoters?: Maybe<RegisteredVotersMutationResponse>;
  /** update single row of the table: "registered_voters" */
  updateRegisteredVotersByPk?: Maybe<RegisteredVoters>;
  /** update multiples rows of table: "registered_voters" */
  updateRegisteredVotersMany?: Maybe<Array<Maybe<RegisteredVotersMutationResponse>>>;
  /** update data of the table: "users" */
  updateUsers?: Maybe<UsersMutationResponse>;
  /** update single row of the table: "users" */
  updateUsersByPk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  updateUsersMany?: Maybe<Array<Maybe<UsersMutationResponse>>>;
  /** update data of the table: "voter_verification_jurisdiction_rels" */
  updateVoterVerificationJurisdictionRels?: Maybe<VoterVerificationJurisdictionRelsMutationResponse>;
  /** update single row of the table: "voter_verification_jurisdiction_rels" */
  updateVoterVerificationJurisdictionRelsByPk?: Maybe<VoterVerificationJurisdictionRels>;
  /** update multiples rows of table: "voter_verification_jurisdiction_rels" */
  updateVoterVerificationJurisdictionRelsMany?: Maybe<Array<Maybe<VoterVerificationJurisdictionRelsMutationResponse>>>;
  /** update data of the table: "voter_verifications" */
  updateVoterVerifications?: Maybe<VoterVerificationsMutationResponse>;
  /** update single row of the table: "voter_verifications" */
  updateVoterVerificationsByPk?: Maybe<VoterVerifications>;
  /** update multiples rows of table: "voter_verifications" */
  updateVoterVerificationsMany?: Maybe<Array<Maybe<VoterVerificationsMutationResponse>>>;
  /** update data of the table: "waitlist" */
  updateWaitlist?: Maybe<WaitlistMutationResponse>;
  /** update single row of the table: "waitlist" */
  updateWaitlistByPk?: Maybe<Waitlist>;
  /** update multiples rows of table: "waitlist" */
  updateWaitlistMany?: Maybe<Array<Maybe<WaitlistMutationResponse>>>;
};


/** mutation root */
export type Mutation_RootDeleteEntitiesArgs = {
  where: EntitiesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEntitiesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteEntityPersonRelsArgs = {
  where: EntityPersonRelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEntityPersonRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteEntityTypesArgs = {
  where: EntityTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEntityTypesByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteExternalLinksArgs = {
  where: ExternalLinksBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteExternalLinksByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteInfluenceTargetsArgs = {
  where: InfluenceTargetsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInfluenceTargetsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteIssueExternalLinkRelsArgs = {
  where: IssueExternalLinkRelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIssueExternalLinkRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteIssueInfluenceTargetRelsArgs = {
  where: IssueInfluenceTargetRelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIssueInfluenceTargetRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteIssueMediaRelsArgs = {
  where: IssueMediaRelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIssueMediaRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteIssueSupporterRelsArgs = {
  where: IssueSupporterRelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIssueSupporterRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteIssuesArgs = {
  where: IssuesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIssuesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteJurisdictionsArgs = {
  where: JurisdictionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJurisdictionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteMeasuresArgs = {
  where: MeasuresBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMeasuresByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteMediaArgs = {
  where: MediaBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMediaByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteOfficesArgs = {
  where: OfficesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteOfficesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeletePersonsArgs = {
  where: PersonsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePersonsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRegisteredVotersArgs = {
  where: RegisteredVotersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRegisteredVotersByPkArgs = {
  voterbaseId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUsersArgs = {
  where: UsersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteVoterVerificationJurisdictionRelsArgs = {
  where: VoterVerificationJurisdictionRelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVoterVerificationJurisdictionRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteVoterVerificationsArgs = {
  where: VoterVerificationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteVoterVerificationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteWaitlistArgs = {
  where: WaitlistBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteWaitlistByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsertEntitiesArgs = {
  objects: Array<EntitiesInsertInput>;
  onConflict?: InputMaybe<EntitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEntitiesOneArgs = {
  object: EntitiesInsertInput;
  onConflict?: InputMaybe<EntitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityPersonRelsArgs = {
  objects: Array<EntityPersonRelsInsertInput>;
  onConflict?: InputMaybe<EntityPersonRelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityPersonRelsOneArgs = {
  object: EntityPersonRelsInsertInput;
  onConflict?: InputMaybe<EntityPersonRelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityTypesArgs = {
  objects: Array<EntityTypesInsertInput>;
  onConflict?: InputMaybe<EntityTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityTypesOneArgs = {
  object: EntityTypesInsertInput;
  onConflict?: InputMaybe<EntityTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertExternalLinksArgs = {
  objects: Array<ExternalLinksInsertInput>;
  onConflict?: InputMaybe<ExternalLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertExternalLinksOneArgs = {
  object: ExternalLinksInsertInput;
  onConflict?: InputMaybe<ExternalLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInfluenceTargetsArgs = {
  objects: Array<InfluenceTargetsInsertInput>;
  onConflict?: InputMaybe<InfluenceTargetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInfluenceTargetsOneArgs = {
  object: InfluenceTargetsInsertInput;
  onConflict?: InputMaybe<InfluenceTargetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIssueExternalLinkRelsArgs = {
  objects: Array<IssueExternalLinkRelsInsertInput>;
  onConflict?: InputMaybe<IssueExternalLinkRelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIssueExternalLinkRelsOneArgs = {
  object: IssueExternalLinkRelsInsertInput;
  onConflict?: InputMaybe<IssueExternalLinkRelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIssueInfluenceTargetRelsArgs = {
  objects: Array<IssueInfluenceTargetRelsInsertInput>;
  onConflict?: InputMaybe<IssueInfluenceTargetRelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIssueInfluenceTargetRelsOneArgs = {
  object: IssueInfluenceTargetRelsInsertInput;
  onConflict?: InputMaybe<IssueInfluenceTargetRelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIssueMediaRelsArgs = {
  objects: Array<IssueMediaRelsInsertInput>;
  onConflict?: InputMaybe<IssueMediaRelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIssueMediaRelsOneArgs = {
  object: IssueMediaRelsInsertInput;
  onConflict?: InputMaybe<IssueMediaRelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIssueSupporterRelsArgs = {
  objects: Array<IssueSupporterRelsInsertInput>;
  onConflict?: InputMaybe<IssueSupporterRelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIssueSupporterRelsOneArgs = {
  object: IssueSupporterRelsInsertInput;
  onConflict?: InputMaybe<IssueSupporterRelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIssuesArgs = {
  objects: Array<IssuesInsertInput>;
  onConflict?: InputMaybe<IssuesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIssuesOneArgs = {
  object: IssuesInsertInput;
  onConflict?: InputMaybe<IssuesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJurisdictionsArgs = {
  objects: Array<JurisdictionsInsertInput>;
  onConflict?: InputMaybe<JurisdictionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJurisdictionsOneArgs = {
  object: JurisdictionsInsertInput;
  onConflict?: InputMaybe<JurisdictionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMeasuresArgs = {
  objects: Array<MeasuresInsertInput>;
  onConflict?: InputMaybe<MeasuresOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMeasuresOneArgs = {
  object: MeasuresInsertInput;
  onConflict?: InputMaybe<MeasuresOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMediaArgs = {
  objects: Array<MediaInsertInput>;
  onConflict?: InputMaybe<MediaOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMediaOneArgs = {
  object: MediaInsertInput;
  onConflict?: InputMaybe<MediaOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOfficesArgs = {
  objects: Array<OfficesInsertInput>;
  onConflict?: InputMaybe<OfficesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOfficesOneArgs = {
  object: OfficesInsertInput;
  onConflict?: InputMaybe<OfficesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPersonsArgs = {
  objects: Array<PersonsInsertInput>;
  onConflict?: InputMaybe<PersonsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPersonsOneArgs = {
  object: PersonsInsertInput;
  onConflict?: InputMaybe<PersonsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRegisteredVotersArgs = {
  objects: Array<RegisteredVotersInsertInput>;
  onConflict?: InputMaybe<RegisteredVotersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRegisteredVotersOneArgs = {
  object: RegisteredVotersInsertInput;
  onConflict?: InputMaybe<RegisteredVotersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersArgs = {
  objects: Array<UsersInsertInput>;
  onConflict?: InputMaybe<UsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersOneArgs = {
  object: UsersInsertInput;
  onConflict?: InputMaybe<UsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVoterVerificationJurisdictionRelsArgs = {
  objects: Array<VoterVerificationJurisdictionRelsInsertInput>;
  onConflict?: InputMaybe<VoterVerificationJurisdictionRelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVoterVerificationJurisdictionRelsOneArgs = {
  object: VoterVerificationJurisdictionRelsInsertInput;
  onConflict?: InputMaybe<VoterVerificationJurisdictionRelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVoterVerificationsArgs = {
  objects: Array<VoterVerificationsInsertInput>;
  onConflict?: InputMaybe<VoterVerificationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertVoterVerificationsOneArgs = {
  object: VoterVerificationsInsertInput;
  onConflict?: InputMaybe<VoterVerificationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertWaitlistArgs = {
  objects: Array<WaitlistInsertInput>;
  onConflict?: InputMaybe<WaitlistOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertWaitlistOneArgs = {
  object: WaitlistInsertInput;
  onConflict?: InputMaybe<WaitlistOnConflict>;
};


/** mutation root */
export type Mutation_RootUpdateEntitiesArgs = {
  _set?: InputMaybe<EntitiesSetInput>;
  where: EntitiesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEntitiesByPkArgs = {
  _set?: InputMaybe<EntitiesSetInput>;
  pkColumns: EntitiesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEntitiesManyArgs = {
  updates: Array<EntitiesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEntityPersonRelsArgs = {
  _set?: InputMaybe<EntityPersonRelsSetInput>;
  where: EntityPersonRelsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEntityPersonRelsByPkArgs = {
  _set?: InputMaybe<EntityPersonRelsSetInput>;
  pkColumns: EntityPersonRelsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEntityPersonRelsManyArgs = {
  updates: Array<EntityPersonRelsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEntityTypesArgs = {
  _set?: InputMaybe<EntityTypesSetInput>;
  where: EntityTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEntityTypesByPkArgs = {
  _set?: InputMaybe<EntityTypesSetInput>;
  pkColumns: EntityTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEntityTypesManyArgs = {
  updates: Array<EntityTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateExternalLinksArgs = {
  _set?: InputMaybe<ExternalLinksSetInput>;
  where: ExternalLinksBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateExternalLinksByPkArgs = {
  _set?: InputMaybe<ExternalLinksSetInput>;
  pkColumns: ExternalLinksPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateExternalLinksManyArgs = {
  updates: Array<ExternalLinksUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInfluenceTargetsArgs = {
  _set?: InputMaybe<InfluenceTargetsSetInput>;
  where: InfluenceTargetsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInfluenceTargetsByPkArgs = {
  _set?: InputMaybe<InfluenceTargetsSetInput>;
  pkColumns: InfluenceTargetsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInfluenceTargetsManyArgs = {
  updates: Array<InfluenceTargetsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIssueExternalLinkRelsArgs = {
  _set?: InputMaybe<IssueExternalLinkRelsSetInput>;
  where: IssueExternalLinkRelsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIssueExternalLinkRelsByPkArgs = {
  _set?: InputMaybe<IssueExternalLinkRelsSetInput>;
  pkColumns: IssueExternalLinkRelsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIssueExternalLinkRelsManyArgs = {
  updates: Array<IssueExternalLinkRelsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIssueInfluenceTargetRelsArgs = {
  _inc?: InputMaybe<IssueInfluenceTargetRelsIncInput>;
  _set?: InputMaybe<IssueInfluenceTargetRelsSetInput>;
  where: IssueInfluenceTargetRelsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIssueInfluenceTargetRelsByPkArgs = {
  _inc?: InputMaybe<IssueInfluenceTargetRelsIncInput>;
  _set?: InputMaybe<IssueInfluenceTargetRelsSetInput>;
  pkColumns: IssueInfluenceTargetRelsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIssueInfluenceTargetRelsManyArgs = {
  updates: Array<IssueInfluenceTargetRelsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIssueMediaRelsArgs = {
  _set?: InputMaybe<IssueMediaRelsSetInput>;
  where: IssueMediaRelsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIssueMediaRelsByPkArgs = {
  _set?: InputMaybe<IssueMediaRelsSetInput>;
  pkColumns: IssueMediaRelsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIssueMediaRelsManyArgs = {
  updates: Array<IssueMediaRelsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIssueSupporterRelsArgs = {
  _set?: InputMaybe<IssueSupporterRelsSetInput>;
  where: IssueSupporterRelsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIssueSupporterRelsByPkArgs = {
  _set?: InputMaybe<IssueSupporterRelsSetInput>;
  pkColumns: IssueSupporterRelsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIssueSupporterRelsManyArgs = {
  updates: Array<IssueSupporterRelsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIssuesArgs = {
  _set?: InputMaybe<IssuesSetInput>;
  where: IssuesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIssuesByPkArgs = {
  _set?: InputMaybe<IssuesSetInput>;
  pkColumns: IssuesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIssuesManyArgs = {
  updates: Array<IssuesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJurisdictionsArgs = {
  _set?: InputMaybe<JurisdictionsSetInput>;
  where: JurisdictionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJurisdictionsByPkArgs = {
  _set?: InputMaybe<JurisdictionsSetInput>;
  pkColumns: JurisdictionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJurisdictionsManyArgs = {
  updates: Array<JurisdictionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMeasuresArgs = {
  _set?: InputMaybe<MeasuresSetInput>;
  where: MeasuresBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMeasuresByPkArgs = {
  _set?: InputMaybe<MeasuresSetInput>;
  pkColumns: MeasuresPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMeasuresManyArgs = {
  updates: Array<MeasuresUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMediaArgs = {
  _set?: InputMaybe<MediaSetInput>;
  where: MediaBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMediaByPkArgs = {
  _set?: InputMaybe<MediaSetInput>;
  pkColumns: MediaPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMediaManyArgs = {
  updates: Array<MediaUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateOfficesArgs = {
  _set?: InputMaybe<OfficesSetInput>;
  where: OfficesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateOfficesByPkArgs = {
  _set?: InputMaybe<OfficesSetInput>;
  pkColumns: OfficesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateOfficesManyArgs = {
  updates: Array<OfficesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePersonsArgs = {
  _set?: InputMaybe<PersonsSetInput>;
  where: PersonsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePersonsByPkArgs = {
  _set?: InputMaybe<PersonsSetInput>;
  pkColumns: PersonsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePersonsManyArgs = {
  updates: Array<PersonsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRegisteredVotersArgs = {
  _set?: InputMaybe<RegisteredVotersSetInput>;
  where: RegisteredVotersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRegisteredVotersByPkArgs = {
  _set?: InputMaybe<RegisteredVotersSetInput>;
  pkColumns: RegisteredVotersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRegisteredVotersManyArgs = {
  updates: Array<RegisteredVotersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  _set?: InputMaybe<UsersSetInput>;
  where: UsersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUsersByPkArgs = {
  _set?: InputMaybe<UsersSetInput>;
  pkColumns: UsersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUsersManyArgs = {
  updates: Array<UsersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVoterVerificationJurisdictionRelsArgs = {
  _set?: InputMaybe<VoterVerificationJurisdictionRelsSetInput>;
  where: VoterVerificationJurisdictionRelsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVoterVerificationJurisdictionRelsByPkArgs = {
  _set?: InputMaybe<VoterVerificationJurisdictionRelsSetInput>;
  pkColumns: VoterVerificationJurisdictionRelsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVoterVerificationJurisdictionRelsManyArgs = {
  updates: Array<VoterVerificationJurisdictionRelsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateVoterVerificationsArgs = {
  _set?: InputMaybe<VoterVerificationsSetInput>;
  where: VoterVerificationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateVoterVerificationsByPkArgs = {
  _set?: InputMaybe<VoterVerificationsSetInput>;
  pkColumns: VoterVerificationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateVoterVerificationsManyArgs = {
  updates: Array<VoterVerificationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateWaitlistArgs = {
  _set?: InputMaybe<WaitlistSetInput>;
  where: WaitlistBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateWaitlistByPkArgs = {
  _set?: InputMaybe<WaitlistSetInput>;
  pkColumns: WaitlistPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateWaitlistManyArgs = {
  updates: Array<WaitlistUpdates>;
};

export type OfficesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<OfficesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OfficesBoolExp>;
  predicate: IntComparisonExp;
};

export type Query_Root = {
  __typename?: 'query_root';
  CivicEngine?: Maybe<CivicEngineQuery>;
  /** An array relationship */
  entities: Array<Entities>;
  /** An aggregate relationship */
  entitiesAggregate: EntitiesAggregate;
  /** fetch data from the table: "entities" using primary key columns */
  entitiesByPk?: Maybe<Entities>;
  /** An array relationship */
  entityPersonRels: Array<EntityPersonRels>;
  /** An aggregate relationship */
  entityPersonRelsAggregate: EntityPersonRelsAggregate;
  /** fetch data from the table: "entity_person_rels" using primary key columns */
  entityPersonRelsByPk?: Maybe<EntityPersonRels>;
  /** fetch data from the table: "entity_types" */
  entityTypes: Array<EntityTypes>;
  /** fetch aggregated fields from the table: "entity_types" */
  entityTypesAggregate: EntityTypesAggregate;
  /** fetch data from the table: "entity_types" using primary key columns */
  entityTypesByPk?: Maybe<EntityTypes>;
  /** fetch data from the table: "external_links" */
  externalLinks: Array<ExternalLinks>;
  /** fetch aggregated fields from the table: "external_links" */
  externalLinksAggregate: ExternalLinksAggregate;
  /** fetch data from the table: "external_links" using primary key columns */
  externalLinksByPk?: Maybe<ExternalLinks>;
  /** An array relationship */
  influenceTargets: Array<InfluenceTargets>;
  /** An aggregate relationship */
  influenceTargetsAggregate: InfluenceTargetsAggregate;
  /** fetch data from the table: "influence_targets" using primary key columns */
  influenceTargetsByPk?: Maybe<InfluenceTargets>;
  /** An array relationship */
  issueExternalLinkRels: Array<IssueExternalLinkRels>;
  /** An aggregate relationship */
  issueExternalLinkRelsAggregate: IssueExternalLinkRelsAggregate;
  /** fetch data from the table: "issue_external_link_rels" using primary key columns */
  issueExternalLinkRelsByPk?: Maybe<IssueExternalLinkRels>;
  /** An array relationship */
  issueInfluenceTargetRels: Array<IssueInfluenceTargetRels>;
  /** An aggregate relationship */
  issueInfluenceTargetRelsAggregate: IssueInfluenceTargetRelsAggregate;
  /** fetch data from the table: "issue_influence_target_rels" using primary key columns */
  issueInfluenceTargetRelsByPk?: Maybe<IssueInfluenceTargetRels>;
  /** An array relationship */
  issueMediaRels: Array<IssueMediaRels>;
  /** An aggregate relationship */
  issueMediaRelsAggregate: IssueMediaRelsAggregate;
  /** fetch data from the table: "issue_media_rels" using primary key columns */
  issueMediaRelsByPk?: Maybe<IssueMediaRels>;
  /** An array relationship */
  issueSupporterRels: Array<IssueSupporterRels>;
  /** An aggregate relationship */
  issueSupporterRelsAggregate: IssueSupporterRelsAggregate;
  /** fetch data from the table: "issue_supporter_rels" using primary key columns */
  issueSupporterRelsByPk?: Maybe<IssueSupporterRels>;
  /** An array relationship */
  issues: Array<Issues>;
  /** An aggregate relationship */
  issuesAggregate: IssuesAggregate;
  /** fetch data from the table: "issues" using primary key columns */
  issuesByPk?: Maybe<Issues>;
  /** fetch data from the table: "jurisdictions" */
  jurisdictions: Array<Jurisdictions>;
  /** fetch aggregated fields from the table: "jurisdictions" */
  jurisdictionsAggregate: JurisdictionsAggregate;
  /** fetch data from the table: "jurisdictions" using primary key columns */
  jurisdictionsByPk?: Maybe<Jurisdictions>;
  /** An array relationship */
  measures: Array<Measures>;
  /** An aggregate relationship */
  measuresAggregate: MeasuresAggregate;
  /** fetch data from the table: "measures" using primary key columns */
  measuresByPk?: Maybe<Measures>;
  /** fetch data from the table: "media" */
  media: Array<Media>;
  /** fetch aggregated fields from the table: "media" */
  mediaAggregate: MediaAggregate;
  /** fetch data from the table: "media" using primary key columns */
  mediaByPk?: Maybe<Media>;
  /** An array relationship */
  offices: Array<Offices>;
  /** An aggregate relationship */
  officesAggregate: OfficesAggregate;
  /** fetch data from the table: "offices" using primary key columns */
  officesByPk?: Maybe<Offices>;
  /** fetch data from the table: "persons" */
  persons: Array<Persons>;
  /** fetch aggregated fields from the table: "persons" */
  personsAggregate: PersonsAggregate;
  /** fetch data from the table: "persons" using primary key columns */
  personsByPk?: Maybe<Persons>;
  /** fetch data from the table: "registered_voters" */
  registeredVoters: Array<RegisteredVoters>;
  /** fetch aggregated fields from the table: "registered_voters" */
  registeredVotersAggregate: RegisteredVotersAggregate;
  /** fetch data from the table: "registered_voters" using primary key columns */
  registeredVotersByPk?: Maybe<RegisteredVoters>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  usersAggregate: UsersAggregate;
  /** fetch data from the table: "users" using primary key columns */
  usersByPk?: Maybe<Users>;
  /** An array relationship */
  voterVerificationJurisdictionRels: Array<VoterVerificationJurisdictionRels>;
  /** An aggregate relationship */
  voterVerificationJurisdictionRelsAggregate: VoterVerificationJurisdictionRelsAggregate;
  /** fetch data from the table: "voter_verification_jurisdiction_rels" using primary key columns */
  voterVerificationJurisdictionRelsByPk?: Maybe<VoterVerificationJurisdictionRels>;
  /** An array relationship */
  voterVerifications: Array<VoterVerifications>;
  /** An aggregate relationship */
  voterVerificationsAggregate: VoterVerificationsAggregate;
  /** fetch data from the table: "voter_verifications" using primary key columns */
  voterVerificationsByPk?: Maybe<VoterVerifications>;
  /** fetch data from the table: "waitlist" */
  waitlist: Array<Waitlist>;
  /** fetch aggregated fields from the table: "waitlist" */
  waitlistAggregate: WaitlistAggregate;
  /** fetch data from the table: "waitlist" using primary key columns */
  waitlistByPk?: Maybe<Waitlist>;
};


export type Query_RootEntitiesArgs = {
  distinctOn?: InputMaybe<Array<EntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntitiesOrderBy>>;
  where?: InputMaybe<EntitiesBoolExp>;
};


export type Query_RootEntitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntitiesOrderBy>>;
  where?: InputMaybe<EntitiesBoolExp>;
};


export type Query_RootEntitiesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEntityPersonRelsArgs = {
  distinctOn?: InputMaybe<Array<EntityPersonRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityPersonRelsOrderBy>>;
  where?: InputMaybe<EntityPersonRelsBoolExp>;
};


export type Query_RootEntityPersonRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EntityPersonRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityPersonRelsOrderBy>>;
  where?: InputMaybe<EntityPersonRelsBoolExp>;
};


export type Query_RootEntityPersonRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEntityTypesArgs = {
  distinctOn?: InputMaybe<Array<EntityTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityTypesOrderBy>>;
  where?: InputMaybe<EntityTypesBoolExp>;
};


export type Query_RootEntityTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EntityTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityTypesOrderBy>>;
  where?: InputMaybe<EntityTypesBoolExp>;
};


export type Query_RootEntityTypesByPkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootExternalLinksArgs = {
  distinctOn?: InputMaybe<Array<ExternalLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ExternalLinksOrderBy>>;
  where?: InputMaybe<ExternalLinksBoolExp>;
};


export type Query_RootExternalLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<ExternalLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ExternalLinksOrderBy>>;
  where?: InputMaybe<ExternalLinksBoolExp>;
};


export type Query_RootExternalLinksByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootInfluenceTargetsArgs = {
  distinctOn?: InputMaybe<Array<InfluenceTargetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InfluenceTargetsOrderBy>>;
  where?: InputMaybe<InfluenceTargetsBoolExp>;
};


export type Query_RootInfluenceTargetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InfluenceTargetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InfluenceTargetsOrderBy>>;
  where?: InputMaybe<InfluenceTargetsBoolExp>;
};


export type Query_RootInfluenceTargetsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIssueExternalLinkRelsArgs = {
  distinctOn?: InputMaybe<Array<IssueExternalLinkRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueExternalLinkRelsOrderBy>>;
  where?: InputMaybe<IssueExternalLinkRelsBoolExp>;
};


export type Query_RootIssueExternalLinkRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssueExternalLinkRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueExternalLinkRelsOrderBy>>;
  where?: InputMaybe<IssueExternalLinkRelsBoolExp>;
};


export type Query_RootIssueExternalLinkRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIssueInfluenceTargetRelsArgs = {
  distinctOn?: InputMaybe<Array<IssueInfluenceTargetRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueInfluenceTargetRelsOrderBy>>;
  where?: InputMaybe<IssueInfluenceTargetRelsBoolExp>;
};


export type Query_RootIssueInfluenceTargetRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssueInfluenceTargetRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueInfluenceTargetRelsOrderBy>>;
  where?: InputMaybe<IssueInfluenceTargetRelsBoolExp>;
};


export type Query_RootIssueInfluenceTargetRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIssueMediaRelsArgs = {
  distinctOn?: InputMaybe<Array<IssueMediaRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueMediaRelsOrderBy>>;
  where?: InputMaybe<IssueMediaRelsBoolExp>;
};


export type Query_RootIssueMediaRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssueMediaRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueMediaRelsOrderBy>>;
  where?: InputMaybe<IssueMediaRelsBoolExp>;
};


export type Query_RootIssueMediaRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIssueSupporterRelsArgs = {
  distinctOn?: InputMaybe<Array<IssueSupporterRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueSupporterRelsOrderBy>>;
  where?: InputMaybe<IssueSupporterRelsBoolExp>;
};


export type Query_RootIssueSupporterRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssueSupporterRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueSupporterRelsOrderBy>>;
  where?: InputMaybe<IssueSupporterRelsBoolExp>;
};


export type Query_RootIssueSupporterRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIssuesArgs = {
  distinctOn?: InputMaybe<Array<IssuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssuesOrderBy>>;
  where?: InputMaybe<IssuesBoolExp>;
};


export type Query_RootIssuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssuesOrderBy>>;
  where?: InputMaybe<IssuesBoolExp>;
};


export type Query_RootIssuesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootJurisdictionsArgs = {
  distinctOn?: InputMaybe<Array<JurisdictionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JurisdictionsOrderBy>>;
  where?: InputMaybe<JurisdictionsBoolExp>;
};


export type Query_RootJurisdictionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JurisdictionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JurisdictionsOrderBy>>;
  where?: InputMaybe<JurisdictionsBoolExp>;
};


export type Query_RootJurisdictionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMeasuresArgs = {
  distinctOn?: InputMaybe<Array<MeasuresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeasuresOrderBy>>;
  where?: InputMaybe<MeasuresBoolExp>;
};


export type Query_RootMeasuresAggregateArgs = {
  distinctOn?: InputMaybe<Array<MeasuresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeasuresOrderBy>>;
  where?: InputMaybe<MeasuresBoolExp>;
};


export type Query_RootMeasuresByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMediaArgs = {
  distinctOn?: InputMaybe<Array<MediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
  where?: InputMaybe<MediaBoolExp>;
};


export type Query_RootMediaAggregateArgs = {
  distinctOn?: InputMaybe<Array<MediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
  where?: InputMaybe<MediaBoolExp>;
};


export type Query_RootMediaByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOfficesArgs = {
  distinctOn?: InputMaybe<Array<OfficesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OfficesOrderBy>>;
  where?: InputMaybe<OfficesBoolExp>;
};


export type Query_RootOfficesAggregateArgs = {
  distinctOn?: InputMaybe<Array<OfficesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OfficesOrderBy>>;
  where?: InputMaybe<OfficesBoolExp>;
};


export type Query_RootOfficesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPersonsArgs = {
  distinctOn?: InputMaybe<Array<PersonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonsOrderBy>>;
  where?: InputMaybe<PersonsBoolExp>;
};


export type Query_RootPersonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PersonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonsOrderBy>>;
  where?: InputMaybe<PersonsBoolExp>;
};


export type Query_RootPersonsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRegisteredVotersArgs = {
  distinctOn?: InputMaybe<Array<RegisteredVotersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegisteredVotersOrderBy>>;
  where?: InputMaybe<RegisteredVotersBoolExp>;
};


export type Query_RootRegisteredVotersAggregateArgs = {
  distinctOn?: InputMaybe<Array<RegisteredVotersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegisteredVotersOrderBy>>;
  where?: InputMaybe<RegisteredVotersBoolExp>;
};


export type Query_RootRegisteredVotersByPkArgs = {
  voterbaseId: Scalars['String']['input'];
};


export type Query_RootUsersArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Query_RootUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Query_RootUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVoterVerificationJurisdictionRelsArgs = {
  distinctOn?: InputMaybe<Array<VoterVerificationJurisdictionRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoterVerificationJurisdictionRelsOrderBy>>;
  where?: InputMaybe<VoterVerificationJurisdictionRelsBoolExp>;
};


export type Query_RootVoterVerificationJurisdictionRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VoterVerificationJurisdictionRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoterVerificationJurisdictionRelsOrderBy>>;
  where?: InputMaybe<VoterVerificationJurisdictionRelsBoolExp>;
};


export type Query_RootVoterVerificationJurisdictionRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVoterVerificationsArgs = {
  distinctOn?: InputMaybe<Array<VoterVerificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoterVerificationsOrderBy>>;
  where?: InputMaybe<VoterVerificationsBoolExp>;
};


export type Query_RootVoterVerificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VoterVerificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoterVerificationsOrderBy>>;
  where?: InputMaybe<VoterVerificationsBoolExp>;
};


export type Query_RootVoterVerificationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootWaitlistArgs = {
  distinctOn?: InputMaybe<Array<WaitlistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WaitlistOrderBy>>;
  where?: InputMaybe<WaitlistBoolExp>;
};


export type Query_RootWaitlistAggregateArgs = {
  distinctOn?: InputMaybe<Array<WaitlistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WaitlistOrderBy>>;
  where?: InputMaybe<WaitlistBoolExp>;
};


export type Query_RootWaitlistByPkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** An array relationship */
  entities: Array<Entities>;
  /** An aggregate relationship */
  entitiesAggregate: EntitiesAggregate;
  /** fetch data from the table: "entities" using primary key columns */
  entitiesByPk?: Maybe<Entities>;
  /** fetch data from the table in a streaming manner: "entities" */
  entitiesStream: Array<Entities>;
  /** An array relationship */
  entityPersonRels: Array<EntityPersonRels>;
  /** An aggregate relationship */
  entityPersonRelsAggregate: EntityPersonRelsAggregate;
  /** fetch data from the table: "entity_person_rels" using primary key columns */
  entityPersonRelsByPk?: Maybe<EntityPersonRels>;
  /** fetch data from the table in a streaming manner: "entity_person_rels" */
  entityPersonRelsStream: Array<EntityPersonRels>;
  /** fetch data from the table: "entity_types" */
  entityTypes: Array<EntityTypes>;
  /** fetch aggregated fields from the table: "entity_types" */
  entityTypesAggregate: EntityTypesAggregate;
  /** fetch data from the table: "entity_types" using primary key columns */
  entityTypesByPk?: Maybe<EntityTypes>;
  /** fetch data from the table in a streaming manner: "entity_types" */
  entityTypesStream: Array<EntityTypes>;
  /** fetch data from the table: "external_links" */
  externalLinks: Array<ExternalLinks>;
  /** fetch aggregated fields from the table: "external_links" */
  externalLinksAggregate: ExternalLinksAggregate;
  /** fetch data from the table: "external_links" using primary key columns */
  externalLinksByPk?: Maybe<ExternalLinks>;
  /** fetch data from the table in a streaming manner: "external_links" */
  externalLinksStream: Array<ExternalLinks>;
  /** An array relationship */
  influenceTargets: Array<InfluenceTargets>;
  /** An aggregate relationship */
  influenceTargetsAggregate: InfluenceTargetsAggregate;
  /** fetch data from the table: "influence_targets" using primary key columns */
  influenceTargetsByPk?: Maybe<InfluenceTargets>;
  /** fetch data from the table in a streaming manner: "influence_targets" */
  influenceTargetsStream: Array<InfluenceTargets>;
  /** An array relationship */
  issueExternalLinkRels: Array<IssueExternalLinkRels>;
  /** An aggregate relationship */
  issueExternalLinkRelsAggregate: IssueExternalLinkRelsAggregate;
  /** fetch data from the table: "issue_external_link_rels" using primary key columns */
  issueExternalLinkRelsByPk?: Maybe<IssueExternalLinkRels>;
  /** fetch data from the table in a streaming manner: "issue_external_link_rels" */
  issueExternalLinkRelsStream: Array<IssueExternalLinkRels>;
  /** An array relationship */
  issueInfluenceTargetRels: Array<IssueInfluenceTargetRels>;
  /** An aggregate relationship */
  issueInfluenceTargetRelsAggregate: IssueInfluenceTargetRelsAggregate;
  /** fetch data from the table: "issue_influence_target_rels" using primary key columns */
  issueInfluenceTargetRelsByPk?: Maybe<IssueInfluenceTargetRels>;
  /** fetch data from the table in a streaming manner: "issue_influence_target_rels" */
  issueInfluenceTargetRelsStream: Array<IssueInfluenceTargetRels>;
  /** An array relationship */
  issueMediaRels: Array<IssueMediaRels>;
  /** An aggregate relationship */
  issueMediaRelsAggregate: IssueMediaRelsAggregate;
  /** fetch data from the table: "issue_media_rels" using primary key columns */
  issueMediaRelsByPk?: Maybe<IssueMediaRels>;
  /** fetch data from the table in a streaming manner: "issue_media_rels" */
  issueMediaRelsStream: Array<IssueMediaRels>;
  /** An array relationship */
  issueSupporterRels: Array<IssueSupporterRels>;
  /** An aggregate relationship */
  issueSupporterRelsAggregate: IssueSupporterRelsAggregate;
  /** fetch data from the table: "issue_supporter_rels" using primary key columns */
  issueSupporterRelsByPk?: Maybe<IssueSupporterRels>;
  /** fetch data from the table in a streaming manner: "issue_supporter_rels" */
  issueSupporterRelsStream: Array<IssueSupporterRels>;
  /** An array relationship */
  issues: Array<Issues>;
  /** An aggregate relationship */
  issuesAggregate: IssuesAggregate;
  /** fetch data from the table: "issues" using primary key columns */
  issuesByPk?: Maybe<Issues>;
  /** fetch data from the table in a streaming manner: "issues" */
  issuesStream: Array<Issues>;
  /** fetch data from the table: "jurisdictions" */
  jurisdictions: Array<Jurisdictions>;
  /** fetch aggregated fields from the table: "jurisdictions" */
  jurisdictionsAggregate: JurisdictionsAggregate;
  /** fetch data from the table: "jurisdictions" using primary key columns */
  jurisdictionsByPk?: Maybe<Jurisdictions>;
  /** fetch data from the table in a streaming manner: "jurisdictions" */
  jurisdictionsStream: Array<Jurisdictions>;
  /** An array relationship */
  measures: Array<Measures>;
  /** An aggregate relationship */
  measuresAggregate: MeasuresAggregate;
  /** fetch data from the table: "measures" using primary key columns */
  measuresByPk?: Maybe<Measures>;
  /** fetch data from the table in a streaming manner: "measures" */
  measuresStream: Array<Measures>;
  /** fetch data from the table: "media" */
  media: Array<Media>;
  /** fetch aggregated fields from the table: "media" */
  mediaAggregate: MediaAggregate;
  /** fetch data from the table: "media" using primary key columns */
  mediaByPk?: Maybe<Media>;
  /** fetch data from the table in a streaming manner: "media" */
  mediaStream: Array<Media>;
  /** An array relationship */
  offices: Array<Offices>;
  /** An aggregate relationship */
  officesAggregate: OfficesAggregate;
  /** fetch data from the table: "offices" using primary key columns */
  officesByPk?: Maybe<Offices>;
  /** fetch data from the table in a streaming manner: "offices" */
  officesStream: Array<Offices>;
  /** fetch data from the table: "persons" */
  persons: Array<Persons>;
  /** fetch aggregated fields from the table: "persons" */
  personsAggregate: PersonsAggregate;
  /** fetch data from the table: "persons" using primary key columns */
  personsByPk?: Maybe<Persons>;
  /** fetch data from the table in a streaming manner: "persons" */
  personsStream: Array<Persons>;
  /** fetch data from the table: "registered_voters" */
  registeredVoters: Array<RegisteredVoters>;
  /** fetch aggregated fields from the table: "registered_voters" */
  registeredVotersAggregate: RegisteredVotersAggregate;
  /** fetch data from the table: "registered_voters" using primary key columns */
  registeredVotersByPk?: Maybe<RegisteredVoters>;
  /** fetch data from the table in a streaming manner: "registered_voters" */
  registeredVotersStream: Array<RegisteredVoters>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  usersAggregate: UsersAggregate;
  /** fetch data from the table: "users" using primary key columns */
  usersByPk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  usersStream: Array<Users>;
  /** An array relationship */
  voterVerificationJurisdictionRels: Array<VoterVerificationJurisdictionRels>;
  /** An aggregate relationship */
  voterVerificationJurisdictionRelsAggregate: VoterVerificationJurisdictionRelsAggregate;
  /** fetch data from the table: "voter_verification_jurisdiction_rels" using primary key columns */
  voterVerificationJurisdictionRelsByPk?: Maybe<VoterVerificationJurisdictionRels>;
  /** fetch data from the table in a streaming manner: "voter_verification_jurisdiction_rels" */
  voterVerificationJurisdictionRelsStream: Array<VoterVerificationJurisdictionRels>;
  /** An array relationship */
  voterVerifications: Array<VoterVerifications>;
  /** An aggregate relationship */
  voterVerificationsAggregate: VoterVerificationsAggregate;
  /** fetch data from the table: "voter_verifications" using primary key columns */
  voterVerificationsByPk?: Maybe<VoterVerifications>;
  /** fetch data from the table in a streaming manner: "voter_verifications" */
  voterVerificationsStream: Array<VoterVerifications>;
  /** fetch data from the table: "waitlist" */
  waitlist: Array<Waitlist>;
  /** fetch aggregated fields from the table: "waitlist" */
  waitlistAggregate: WaitlistAggregate;
  /** fetch data from the table: "waitlist" using primary key columns */
  waitlistByPk?: Maybe<Waitlist>;
  /** fetch data from the table in a streaming manner: "waitlist" */
  waitlistStream: Array<Waitlist>;
};


export type Subscription_RootEntitiesArgs = {
  distinctOn?: InputMaybe<Array<EntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntitiesOrderBy>>;
  where?: InputMaybe<EntitiesBoolExp>;
};


export type Subscription_RootEntitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntitiesOrderBy>>;
  where?: InputMaybe<EntitiesBoolExp>;
};


export type Subscription_RootEntitiesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEntitiesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EntitiesStreamCursorInput>>;
  where?: InputMaybe<EntitiesBoolExp>;
};


export type Subscription_RootEntityPersonRelsArgs = {
  distinctOn?: InputMaybe<Array<EntityPersonRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityPersonRelsOrderBy>>;
  where?: InputMaybe<EntityPersonRelsBoolExp>;
};


export type Subscription_RootEntityPersonRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EntityPersonRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityPersonRelsOrderBy>>;
  where?: InputMaybe<EntityPersonRelsBoolExp>;
};


export type Subscription_RootEntityPersonRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEntityPersonRelsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EntityPersonRelsStreamCursorInput>>;
  where?: InputMaybe<EntityPersonRelsBoolExp>;
};


export type Subscription_RootEntityTypesArgs = {
  distinctOn?: InputMaybe<Array<EntityTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityTypesOrderBy>>;
  where?: InputMaybe<EntityTypesBoolExp>;
};


export type Subscription_RootEntityTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EntityTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityTypesOrderBy>>;
  where?: InputMaybe<EntityTypesBoolExp>;
};


export type Subscription_RootEntityTypesByPkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEntityTypesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EntityTypesStreamCursorInput>>;
  where?: InputMaybe<EntityTypesBoolExp>;
};


export type Subscription_RootExternalLinksArgs = {
  distinctOn?: InputMaybe<Array<ExternalLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ExternalLinksOrderBy>>;
  where?: InputMaybe<ExternalLinksBoolExp>;
};


export type Subscription_RootExternalLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<ExternalLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ExternalLinksOrderBy>>;
  where?: InputMaybe<ExternalLinksBoolExp>;
};


export type Subscription_RootExternalLinksByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootExternalLinksStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ExternalLinksStreamCursorInput>>;
  where?: InputMaybe<ExternalLinksBoolExp>;
};


export type Subscription_RootInfluenceTargetsArgs = {
  distinctOn?: InputMaybe<Array<InfluenceTargetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InfluenceTargetsOrderBy>>;
  where?: InputMaybe<InfluenceTargetsBoolExp>;
};


export type Subscription_RootInfluenceTargetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InfluenceTargetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InfluenceTargetsOrderBy>>;
  where?: InputMaybe<InfluenceTargetsBoolExp>;
};


export type Subscription_RootInfluenceTargetsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInfluenceTargetsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<InfluenceTargetsStreamCursorInput>>;
  where?: InputMaybe<InfluenceTargetsBoolExp>;
};


export type Subscription_RootIssueExternalLinkRelsArgs = {
  distinctOn?: InputMaybe<Array<IssueExternalLinkRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueExternalLinkRelsOrderBy>>;
  where?: InputMaybe<IssueExternalLinkRelsBoolExp>;
};


export type Subscription_RootIssueExternalLinkRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssueExternalLinkRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueExternalLinkRelsOrderBy>>;
  where?: InputMaybe<IssueExternalLinkRelsBoolExp>;
};


export type Subscription_RootIssueExternalLinkRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIssueExternalLinkRelsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<IssueExternalLinkRelsStreamCursorInput>>;
  where?: InputMaybe<IssueExternalLinkRelsBoolExp>;
};


export type Subscription_RootIssueInfluenceTargetRelsArgs = {
  distinctOn?: InputMaybe<Array<IssueInfluenceTargetRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueInfluenceTargetRelsOrderBy>>;
  where?: InputMaybe<IssueInfluenceTargetRelsBoolExp>;
};


export type Subscription_RootIssueInfluenceTargetRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssueInfluenceTargetRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueInfluenceTargetRelsOrderBy>>;
  where?: InputMaybe<IssueInfluenceTargetRelsBoolExp>;
};


export type Subscription_RootIssueInfluenceTargetRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIssueInfluenceTargetRelsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<IssueInfluenceTargetRelsStreamCursorInput>>;
  where?: InputMaybe<IssueInfluenceTargetRelsBoolExp>;
};


export type Subscription_RootIssueMediaRelsArgs = {
  distinctOn?: InputMaybe<Array<IssueMediaRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueMediaRelsOrderBy>>;
  where?: InputMaybe<IssueMediaRelsBoolExp>;
};


export type Subscription_RootIssueMediaRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssueMediaRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueMediaRelsOrderBy>>;
  where?: InputMaybe<IssueMediaRelsBoolExp>;
};


export type Subscription_RootIssueMediaRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIssueMediaRelsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<IssueMediaRelsStreamCursorInput>>;
  where?: InputMaybe<IssueMediaRelsBoolExp>;
};


export type Subscription_RootIssueSupporterRelsArgs = {
  distinctOn?: InputMaybe<Array<IssueSupporterRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueSupporterRelsOrderBy>>;
  where?: InputMaybe<IssueSupporterRelsBoolExp>;
};


export type Subscription_RootIssueSupporterRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssueSupporterRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssueSupporterRelsOrderBy>>;
  where?: InputMaybe<IssueSupporterRelsBoolExp>;
};


export type Subscription_RootIssueSupporterRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIssueSupporterRelsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<IssueSupporterRelsStreamCursorInput>>;
  where?: InputMaybe<IssueSupporterRelsBoolExp>;
};


export type Subscription_RootIssuesArgs = {
  distinctOn?: InputMaybe<Array<IssuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssuesOrderBy>>;
  where?: InputMaybe<IssuesBoolExp>;
};


export type Subscription_RootIssuesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IssuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IssuesOrderBy>>;
  where?: InputMaybe<IssuesBoolExp>;
};


export type Subscription_RootIssuesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIssuesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<IssuesStreamCursorInput>>;
  where?: InputMaybe<IssuesBoolExp>;
};


export type Subscription_RootJurisdictionsArgs = {
  distinctOn?: InputMaybe<Array<JurisdictionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JurisdictionsOrderBy>>;
  where?: InputMaybe<JurisdictionsBoolExp>;
};


export type Subscription_RootJurisdictionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JurisdictionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JurisdictionsOrderBy>>;
  where?: InputMaybe<JurisdictionsBoolExp>;
};


export type Subscription_RootJurisdictionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootJurisdictionsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<JurisdictionsStreamCursorInput>>;
  where?: InputMaybe<JurisdictionsBoolExp>;
};


export type Subscription_RootMeasuresArgs = {
  distinctOn?: InputMaybe<Array<MeasuresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeasuresOrderBy>>;
  where?: InputMaybe<MeasuresBoolExp>;
};


export type Subscription_RootMeasuresAggregateArgs = {
  distinctOn?: InputMaybe<Array<MeasuresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeasuresOrderBy>>;
  where?: InputMaybe<MeasuresBoolExp>;
};


export type Subscription_RootMeasuresByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMeasuresStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MeasuresStreamCursorInput>>;
  where?: InputMaybe<MeasuresBoolExp>;
};


export type Subscription_RootMediaArgs = {
  distinctOn?: InputMaybe<Array<MediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
  where?: InputMaybe<MediaBoolExp>;
};


export type Subscription_RootMediaAggregateArgs = {
  distinctOn?: InputMaybe<Array<MediaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaOrderBy>>;
  where?: InputMaybe<MediaBoolExp>;
};


export type Subscription_RootMediaByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMediaStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MediaStreamCursorInput>>;
  where?: InputMaybe<MediaBoolExp>;
};


export type Subscription_RootOfficesArgs = {
  distinctOn?: InputMaybe<Array<OfficesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OfficesOrderBy>>;
  where?: InputMaybe<OfficesBoolExp>;
};


export type Subscription_RootOfficesAggregateArgs = {
  distinctOn?: InputMaybe<Array<OfficesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OfficesOrderBy>>;
  where?: InputMaybe<OfficesBoolExp>;
};


export type Subscription_RootOfficesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOfficesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OfficesStreamCursorInput>>;
  where?: InputMaybe<OfficesBoolExp>;
};


export type Subscription_RootPersonsArgs = {
  distinctOn?: InputMaybe<Array<PersonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonsOrderBy>>;
  where?: InputMaybe<PersonsBoolExp>;
};


export type Subscription_RootPersonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PersonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonsOrderBy>>;
  where?: InputMaybe<PersonsBoolExp>;
};


export type Subscription_RootPersonsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPersonsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PersonsStreamCursorInput>>;
  where?: InputMaybe<PersonsBoolExp>;
};


export type Subscription_RootRegisteredVotersArgs = {
  distinctOn?: InputMaybe<Array<RegisteredVotersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegisteredVotersOrderBy>>;
  where?: InputMaybe<RegisteredVotersBoolExp>;
};


export type Subscription_RootRegisteredVotersAggregateArgs = {
  distinctOn?: InputMaybe<Array<RegisteredVotersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegisteredVotersOrderBy>>;
  where?: InputMaybe<RegisteredVotersBoolExp>;
};


export type Subscription_RootRegisteredVotersByPkArgs = {
  voterbaseId: Scalars['String']['input'];
};


export type Subscription_RootRegisteredVotersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RegisteredVotersStreamCursorInput>>;
  where?: InputMaybe<RegisteredVotersBoolExp>;
};


export type Subscription_RootUsersArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Subscription_RootUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Subscription_RootUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUsersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UsersStreamCursorInput>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Subscription_RootVoterVerificationJurisdictionRelsArgs = {
  distinctOn?: InputMaybe<Array<VoterVerificationJurisdictionRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoterVerificationJurisdictionRelsOrderBy>>;
  where?: InputMaybe<VoterVerificationJurisdictionRelsBoolExp>;
};


export type Subscription_RootVoterVerificationJurisdictionRelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VoterVerificationJurisdictionRelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoterVerificationJurisdictionRelsOrderBy>>;
  where?: InputMaybe<VoterVerificationJurisdictionRelsBoolExp>;
};


export type Subscription_RootVoterVerificationJurisdictionRelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVoterVerificationJurisdictionRelsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<VoterVerificationJurisdictionRelsStreamCursorInput>>;
  where?: InputMaybe<VoterVerificationJurisdictionRelsBoolExp>;
};


export type Subscription_RootVoterVerificationsArgs = {
  distinctOn?: InputMaybe<Array<VoterVerificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoterVerificationsOrderBy>>;
  where?: InputMaybe<VoterVerificationsBoolExp>;
};


export type Subscription_RootVoterVerificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<VoterVerificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoterVerificationsOrderBy>>;
  where?: InputMaybe<VoterVerificationsBoolExp>;
};


export type Subscription_RootVoterVerificationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVoterVerificationsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<VoterVerificationsStreamCursorInput>>;
  where?: InputMaybe<VoterVerificationsBoolExp>;
};


export type Subscription_RootWaitlistArgs = {
  distinctOn?: InputMaybe<Array<WaitlistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WaitlistOrderBy>>;
  where?: InputMaybe<WaitlistBoolExp>;
};


export type Subscription_RootWaitlistAggregateArgs = {
  distinctOn?: InputMaybe<Array<WaitlistSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WaitlistOrderBy>>;
  where?: InputMaybe<WaitlistBoolExp>;
};


export type Subscription_RootWaitlistByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWaitlistStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<WaitlistStreamCursorInput>>;
  where?: InputMaybe<WaitlistBoolExp>;
};

export type VoterVerificationJurisdictionRelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VoterVerificationJurisdictionRelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<VoterVerificationJurisdictionRelsBoolExp>;
  predicate: IntComparisonExp;
};

export type VoterVerificationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VoterVerificationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<VoterVerificationsBoolExp>;
  predicate: IntComparisonExp;
};

export type LoginPage_UserFragment = { __typename?: 'Users', id: any, person: { __typename?: 'Persons', id: any, firstName: string, lastName: string, entityPersonRels: Array<{ __typename?: 'EntityPersonRels', id: any, entity: { __typename?: 'Entities', id: any, displayNameLong: string, displayNameShort?: string | null, entityType?: EntityTypesEnum | null, isIdVerified: boolean, bio?: string | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null } }> } };

export type LoginPage_GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type LoginPage_GetUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, person: { __typename?: 'Persons', id: any, firstName: string, lastName: string, entityPersonRels: Array<{ __typename?: 'EntityPersonRels', id: any, entity: { __typename?: 'Entities', id: any, displayNameLong: string, displayNameShort?: string | null, entityType?: EntityTypesEnum | null, isIdVerified: boolean, bio?: string | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null } }> } }> };

export type LoginPage_GetUserInfoByPhoneQueryVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type LoginPage_GetUserInfoByPhoneQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, person: { __typename?: 'Persons', id: any, voterVerifications: Array<{ __typename?: 'VoterVerifications', id: any }>, entityPersonRels: Array<{ __typename?: 'EntityPersonRels', id: any, entity: { __typename?: 'Entities', id: any, profilePhotoId?: any | null, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null } }> } }> };

export type LoginPage_CreatePersonAndEntityMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
}>;


export type LoginPage_CreatePersonAndEntityMutation = { __typename?: 'mutation_root', person?: { __typename?: 'PersonsMutationResponse', returning: Array<{ __typename?: 'Persons', id: any }> } | null, entity?: { __typename?: 'EntitiesMutationResponse', returning: Array<{ __typename?: 'Entities', id: any }> } | null };

export type LoginPage_CreateUserMutationVariables = Exact<{
  personId: Scalars['uuid']['input'];
  phoneNumber: Scalars['String']['input'];
  oryId: Scalars['uuid']['input'];
}>;


export type LoginPage_CreateUserMutation = { __typename?: 'mutation_root', insertUsers?: { __typename?: 'UsersMutationResponse', returning: Array<{ __typename?: 'Users', id: any }> } | null };

export type LoginPage_CreateEntityPersonRelMutationVariables = Exact<{
  entityId: Scalars['uuid']['input'];
  personId: Scalars['uuid']['input'];
}>;


export type LoginPage_CreateEntityPersonRelMutation = { __typename?: 'mutation_root', insertEntityPersonRels?: { __typename?: 'EntityPersonRelsMutationResponse', returning: Array<{ __typename?: 'EntityPersonRels', id: any }> } | null };

export type MePage_UserFragment = { __typename?: 'Users', id: any, person: { __typename?: 'Persons', id: any, firstName: string, lastName: string, entityPersonRels: Array<{ __typename?: 'EntityPersonRels', id: any, entity: { __typename?: 'Entities', id: any, displayNameLong: string, displayNameShort?: string | null, entityType?: EntityTypesEnum | null, isIdVerified: boolean, bio?: string | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null } }> } };

export type MePage_GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type MePage_GetCurrentUserQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, person: { __typename?: 'Persons', id: any, firstName: string, lastName: string, entityPersonRels: Array<{ __typename?: 'EntityPersonRels', id: any, entity: { __typename?: 'Entities', id: any, displayNameLong: string, displayNameShort?: string | null, entityType?: EntityTypesEnum | null, isIdVerified: boolean, bio?: string | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null } }> } }> };

export type ProfileEntityPage_GetEntityQueryQueryVariables = Exact<{
  entityId: Scalars['uuid']['input'];
}>;


export type ProfileEntityPage_GetEntityQueryQuery = { __typename?: 'query_root', entitiesByPk?: { __typename?: 'Entities', id: any, displayNameLong: string, displayNameShort?: string | null, bio?: string | null, entityType?: EntityTypesEnum | null, isIdVerified: boolean, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null, issues: Array<{ __typename?: 'Issues', id: any, topic: string, slogan?: string | null, summary?: string | null, location?: string | null, isActive: boolean, supporterCount?: number | null, verifiedSupporterCount?: number | null, createdAt: any, updatedAt: any, issueMediaRels: Array<{ __typename?: 'IssueMediaRels', medium: { __typename?: 'Media', id: any, link: string } }>, leader: { __typename?: 'Entities', id: any, displayNameShort?: string | null, profilePhoto?: { __typename?: 'Media', link: string } | null } }>, issueSupporterRels: Array<{ __typename?: 'IssueSupporterRels', issue: { __typename?: 'Issues', id: any, topic: string, slogan?: string | null, summary?: string | null, location?: string | null, isActive: boolean, supporterCount?: number | null, verifiedSupporterCount?: number | null, createdAt: any, updatedAt: any, issueMediaRels: Array<{ __typename?: 'IssueMediaRels', medium: { __typename?: 'Media', id: any, link: string } }>, leader: { __typename?: 'Entities', id: any, displayNameShort?: string | null, profilePhoto?: { __typename?: 'Media', link: string } | null } } }> } | null };

export type ProfileEntityPage_GetPublicEntityQueryQueryVariables = Exact<{
  entityId: Scalars['uuid']['input'];
}>;


export type ProfileEntityPage_GetPublicEntityQueryQuery = { __typename?: 'query_root', entitiesByPk?: { __typename?: 'Entities', id: any, displayNameLong: string, displayNameShort?: string | null, bio?: string | null, entityType?: EntityTypesEnum | null, isIdVerified: boolean, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null, issues: Array<{ __typename?: 'Issues', id: any, topic: string, slogan?: string | null, summary?: string | null, location?: string | null, isActive: boolean, supporterCount?: number | null, verifiedSupporterCount?: number | null, createdAt: any, updatedAt: any, issueMediaRels: Array<{ __typename?: 'IssueMediaRels', medium: { __typename?: 'Media', id: any, link: string } }>, leader: { __typename?: 'Entities', id: any, displayNameShort?: string | null, profilePhoto?: { __typename?: 'Media', link: string } | null } }> } | null };

export type SettingsPage_EntityFragment = { __typename?: 'Entities', id: any, displayNameLong: string, displayNameShort?: string | null, bio?: string | null, entityType?: EntityTypesEnum | null, isIdVerified: boolean, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null, entityPersonRels: Array<{ __typename?: 'EntityPersonRels', person: { __typename?: 'Persons', id: any, firstName: string, lastName: string, user?: { __typename?: 'Users', email?: string | null, isDisabled: boolean, oryId?: any | null, phoneNumber: string } | null } }> };

export type SettingsPage_GetEntityQueryQueryVariables = Exact<{
  entityId: Scalars['uuid']['input'];
}>;


export type SettingsPage_GetEntityQueryQuery = { __typename?: 'query_root', entitiesByPk?: { __typename?: 'Entities', id: any, displayNameLong: string, displayNameShort?: string | null, bio?: string | null, entityType?: EntityTypesEnum | null, isIdVerified: boolean, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null, entityPersonRels: Array<{ __typename?: 'EntityPersonRels', person: { __typename?: 'Persons', id: any, firstName: string, lastName: string, user?: { __typename?: 'Users', email?: string | null, isDisabled: boolean, oryId?: any | null, phoneNumber: string } | null } }> } | null };

export type SettingsPage_UpdateEntityMutationMutationVariables = Exact<{
  entityId: Scalars['uuid']['input'];
  bio?: InputMaybe<Scalars['String']['input']>;
  displayNameShort?: InputMaybe<Scalars['String']['input']>;
  displayNameLong?: InputMaybe<Scalars['String']['input']>;
}>;


export type SettingsPage_UpdateEntityMutationMutation = { __typename?: 'mutation_root', updateEntitiesByPk?: { __typename?: 'Entities', id: any, bio?: string | null, displayNameShort?: string | null, displayNameLong: string } | null };

export type SettingsPage_UpdatePersonMutationMutationVariables = Exact<{
  personId: Scalars['uuid']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SettingsPage_UpdatePersonMutationMutation = { __typename?: 'mutation_root', updatePersonsByPk?: { __typename?: 'Persons', id: any, firstName: string, lastName: string } | null };

export type IssuesNewPage_CreateIssueMutationVariables = Exact<{
  input: IssuesInsertInput;
}>;


export type IssuesNewPage_CreateIssueMutation = { __typename?: 'mutation_root', insertIssuesOne?: { __typename?: 'Issues', id: any, topic: string, location?: string | null, slogan?: string | null, summary?: string | null, supporterCount?: number | null, verifiedSupporterCount?: number | null, isActive: boolean, createdAt: any, updatedAt: any, leader: { __typename?: 'Entities', id: any, displayNameShort?: string | null, displayNameLong: string, entityType?: EntityTypesEnum | null, bio?: string | null, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null }, issueInfluenceTargetRels: Array<{ __typename?: 'IssueInfluenceTargetRels', id: any, title?: string | null, subtitle?: string | null }>, issueMediaRels: Array<{ __typename?: 'IssueMediaRels', id: any, medium: { __typename?: 'Media', id: any, link: string } }> } | null };

export type Entity_InfoFragment = { __typename?: 'Entities', id: any, displayNameShort?: string | null, displayNameLong: string, entityType?: EntityTypesEnum | null, bio?: string | null, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null };

export type IssuesPage_IssueInfluenceTargetRelsFragment = { __typename?: 'IssueInfluenceTargetRels', id: any, title?: string | null, subtitle?: string | null };

export type IssuesPage_IssueMediaRelFragment = { __typename?: 'IssueMediaRels', id: any, medium: { __typename?: 'Media', id: any, link: string } };

export type IssuesPage_IssueFragment = { __typename?: 'Issues', id: any, topic: string, location?: string | null, slogan?: string | null, summary?: string | null, supporterCount?: number | null, verifiedSupporterCount?: number | null, isActive: boolean, createdAt: any, updatedAt: any, leader: { __typename?: 'Entities', id: any, displayNameShort?: string | null, displayNameLong: string, entityType?: EntityTypesEnum | null, bio?: string | null, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null }, issueInfluenceTargetRels: Array<{ __typename?: 'IssueInfluenceTargetRels', id: any, title?: string | null, subtitle?: string | null }>, issueMediaRels: Array<{ __typename?: 'IssueMediaRels', id: any, medium: { __typename?: 'Media', id: any, link: string } }> };

export type IssuesPage_GetIssuesQueryVariables = Exact<{ [key: string]: never; }>;


export type IssuesPage_GetIssuesQuery = { __typename?: 'query_root', issues: Array<{ __typename?: 'Issues', id: any, topic: string, location?: string | null, slogan?: string | null, summary?: string | null, supporterCount?: number | null, verifiedSupporterCount?: number | null, isActive: boolean, createdAt: any, updatedAt: any, leader: { __typename?: 'Entities', id: any, displayNameShort?: string | null, displayNameLong: string, entityType?: EntityTypesEnum | null, bio?: string | null, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null }, issueInfluenceTargetRels: Array<{ __typename?: 'IssueInfluenceTargetRels', id: any, title?: string | null, subtitle?: string | null }>, issueMediaRels: Array<{ __typename?: 'IssueMediaRels', id: any, medium: { __typename?: 'Media', id: any, link: string } }> }> };

export type IssuesPage_GetIssueQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type IssuesPage_GetIssueQuery = { __typename?: 'query_root', issuesByPk?: { __typename?: 'Issues', id: any, topic: string, location?: string | null, slogan?: string | null, summary?: string | null, supporterCount?: number | null, verifiedSupporterCount?: number | null, isActive: boolean, createdAt: any, updatedAt: any, leader: { __typename?: 'Entities', id: any, displayNameShort?: string | null, displayNameLong: string, entityType?: EntityTypesEnum | null, bio?: string | null, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null }, issueInfluenceTargetRels: Array<{ __typename?: 'IssueInfluenceTargetRels', id: any, title?: string | null, subtitle?: string | null }>, issueMediaRels: Array<{ __typename?: 'IssueMediaRels', id: any, medium: { __typename?: 'Media', id: any, link: string } }> } | null };

export type IssuesPage_UpdateIssueMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  slogan?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  influenceTargets: Array<IssueInfluenceTargetRelsInsertInput> | IssueInfluenceTargetRelsInsertInput;
}>;


export type IssuesPage_UpdateIssueMutation = { __typename?: 'mutation_root', updateIssuesByPk?: { __typename?: 'Issues', id: any, topic: string, location?: string | null, slogan?: string | null, summary?: string | null, supporterCount?: number | null, verifiedSupporterCount?: number | null, isActive: boolean, createdAt: any, updatedAt: any, leader: { __typename?: 'Entities', id: any, displayNameShort?: string | null, displayNameLong: string, entityType?: EntityTypesEnum | null, bio?: string | null, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null }, issueInfluenceTargetRels: Array<{ __typename?: 'IssueInfluenceTargetRels', id: any, title?: string | null, subtitle?: string | null }>, issueMediaRels: Array<{ __typename?: 'IssueMediaRels', id: any, medium: { __typename?: 'Media', id: any, link: string } }> } | null, deleteIssueInfluenceTargetRels?: { __typename?: 'IssueInfluenceTargetRelsMutationResponse', affectedRows: number } | null, insertIssueInfluenceTargetRels?: { __typename?: 'IssueInfluenceTargetRelsMutationResponse', returning: Array<{ __typename?: 'IssueInfluenceTargetRels', id: any, title?: string | null, subtitle?: string | null }> } | null };

export type IssuesPage_MakeIssueInactiveMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type IssuesPage_MakeIssueInactiveMutation = { __typename?: 'mutation_root', updateIssuesByPk?: { __typename?: 'Issues', id: any } | null };

export type IssuesPage_MakeIssueActiveMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type IssuesPage_MakeIssueActiveMutation = { __typename?: 'mutation_root', updateIssuesByPk?: { __typename?: 'Issues', id: any } | null };

export type IssuesPage_DeleteIssueMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type IssuesPage_DeleteIssueMutation = { __typename?: 'mutation_root', deleteIssuesByPk?: { __typename?: 'Issues', id: any } | null };

export type IssuesPage_CreateIssueMutationVariables = Exact<{
  topic: Scalars['String']['input'];
  slogan?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  leaderId: Scalars['uuid']['input'];
  influenceTargets: Array<IssueInfluenceTargetRelsInsertInput> | IssueInfluenceTargetRelsInsertInput;
}>;


export type IssuesPage_CreateIssueMutation = { __typename?: 'mutation_root', insertIssuesOne?: { __typename?: 'Issues', id: any, topic: string, location?: string | null, slogan?: string | null, summary?: string | null, supporterCount?: number | null, verifiedSupporterCount?: number | null, isActive: boolean, createdAt: any, updatedAt: any, leader: { __typename?: 'Entities', id: any, displayNameShort?: string | null, displayNameLong: string, entityType?: EntityTypesEnum | null, bio?: string | null, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null }, issueInfluenceTargetRels: Array<{ __typename?: 'IssueInfluenceTargetRels', id: any, title?: string | null, subtitle?: string | null }>, issueMediaRels: Array<{ __typename?: 'IssueMediaRels', id: any, medium: { __typename?: 'Media', id: any, link: string } }> } | null };

export type IssuesPage_VoteWithMeMutationVariables = Exact<{
  issueId: Scalars['uuid']['input'];
  supporterId: Scalars['uuid']['input'];
}>;


export type IssuesPage_VoteWithMeMutation = { __typename?: 'mutation_root', insertIssueSupporterRelsOne?: { __typename?: 'IssueSupporterRels', id: any, issueId: any, supporterId?: any | null, createdAt: any } | null };

export type IssuesPage_UnvoteMutationVariables = Exact<{
  issueId: Scalars['uuid']['input'];
  supporterId: Scalars['uuid']['input'];
}>;


export type IssuesPage_UnvoteMutation = { __typename?: 'mutation_root', deleteIssueSupporterRels?: { __typename?: 'IssueSupporterRelsMutationResponse', affectedRows: number } | null };

export type IssuesPage_CheckSupporterQueryVariables = Exact<{
  issueId: Scalars['uuid']['input'];
  supporterId: Scalars['uuid']['input'];
}>;


export type IssuesPage_CheckSupporterQuery = { __typename?: 'query_root', issueSupporterRels: Array<{ __typename?: 'IssueSupporterRels', id: any }> };

export type IssuesPage_VoterVerificationFragment = { __typename?: 'EntityPersonRels', person: { __typename?: 'Persons', voterVerifications: Array<{ __typename?: 'VoterVerifications', id: any }> } };

export type IssuesPage_IsVerifiedVoterQueryVariables = Exact<{
  entityId: Scalars['uuid']['input'];
}>;


export type IssuesPage_IsVerifiedVoterQuery = { __typename?: 'query_root', entitiesByPk?: { __typename?: 'Entities', id: any, entityPersonRels: Array<{ __typename?: 'EntityPersonRels', person: { __typename?: 'Persons', voterVerifications: Array<{ __typename?: 'VoterVerifications', id: any }> } }> } | null };

export type IssuesPage_LeaderQueryVariables = Exact<{
  entityId: Scalars['uuid']['input'];
}>;


export type IssuesPage_LeaderQuery = { __typename?: 'query_root', entitiesByPk?: { __typename?: 'Entities', id: any, displayNameShort?: string | null, displayNameLong: string, entityType?: EntityTypesEnum | null, bio?: string | null, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null } | null };

export type IssuesPage_InsertIssueMediaRelMutationVariables = Exact<{
  issueId: Scalars['uuid']['input'];
  mediaId: Scalars['uuid']['input'];
}>;


export type IssuesPage_InsertIssueMediaRelMutation = { __typename?: 'mutation_root', insertIssueMediaRelsOne?: { __typename?: 'IssueMediaRels', id: any } | null };

export type AddEmailToWaitlistMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type AddEmailToWaitlistMutation = { __typename?: 'mutation_root', insertWaitlistOne?: { __typename?: 'Waitlist', id: any } | null };

export type UpdateWaitlistMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  issueDescription?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  isIssueLeader?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateWaitlistMutation = { __typename?: 'mutation_root', updateWaitlistByPk?: { __typename?: 'Waitlist', id: any } | null };

export type AuthProvider_EntityFragment = { __typename?: 'Entities', id: any, profilePhotoId?: any | null, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null };

export type AuthProvider_UserFragment = { __typename?: 'Users', id: any, person: { __typename?: 'Persons', id: any, voterVerifications: Array<{ __typename?: 'VoterVerifications', id: any }>, entityPersonRels: Array<{ __typename?: 'EntityPersonRels', id: any, entity: { __typename?: 'Entities', id: any, profilePhotoId?: any | null, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null } }> } };

export type AuthProvider_GetCurrentUserQueryVariables = Exact<{
  oryId: Scalars['uuid']['input'];
}>;


export type AuthProvider_GetCurrentUserQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, person: { __typename?: 'Persons', id: any, voterVerifications: Array<{ __typename?: 'VoterVerifications', id: any }>, entityPersonRels: Array<{ __typename?: 'EntityPersonRels', id: any, entity: { __typename?: 'Entities', id: any, profilePhotoId?: any | null, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null } }> } }> };

export type LoginForm_GetUserByPhoneQueryVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type LoginForm_GetUserByPhoneQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any }> };

export type LoginForm_UpdateUserOryIdMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  oryId: Scalars['uuid']['input'];
}>;


export type LoginForm_UpdateUserOryIdMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any, person: { __typename?: 'Persons', id: any, voterVerifications: Array<{ __typename?: 'VoterVerifications', id: any }>, entityPersonRels: Array<{ __typename?: 'EntityPersonRels', id: any, entity: { __typename?: 'Entities', id: any, profilePhotoId?: any | null, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null } }> } } | null };

export type LoginForm_CreateUserAndRelationsMutationVariables = Exact<{
  oryId: Scalars['uuid']['input'];
  phoneNumber: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
}>;


export type LoginForm_CreateUserAndRelationsMutation = { __typename?: 'mutation_root', insertUsers?: { __typename?: 'UsersMutationResponse', returning: Array<{ __typename?: 'Users', id: any, person: { __typename?: 'Persons', id: any, voterVerifications: Array<{ __typename?: 'VoterVerifications', id: any }>, entityPersonRels: Array<{ __typename?: 'EntityPersonRels', id: any, entity: { __typename?: 'Entities', id: any, profilePhotoId?: any | null, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null } }> } }> } | null };

export type ProfileContent_IssuesFragment = { __typename?: 'Issues', id: any, topic: string, slogan?: string | null, summary?: string | null, location?: string | null, isActive: boolean, supporterCount?: number | null, verifiedSupporterCount?: number | null, createdAt: any, updatedAt: any, issueMediaRels: Array<{ __typename?: 'IssueMediaRels', medium: { __typename?: 'Media', id: any, link: string } }>, leader: { __typename?: 'Entities', id: any, displayNameShort?: string | null, profilePhoto?: { __typename?: 'Media', link: string } | null } };

export type ProfileContent_EntityFragment = { __typename?: 'Entities', id: any, displayNameLong: string, displayNameShort?: string | null, bio?: string | null, entityType?: EntityTypesEnum | null, isIdVerified: boolean, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null, issues: Array<{ __typename?: 'Issues', id: any, topic: string, slogan?: string | null, summary?: string | null, location?: string | null, isActive: boolean, supporterCount?: number | null, verifiedSupporterCount?: number | null, createdAt: any, updatedAt: any, issueMediaRels: Array<{ __typename?: 'IssueMediaRels', medium: { __typename?: 'Media', id: any, link: string } }>, leader: { __typename?: 'Entities', id: any, displayNameShort?: string | null, profilePhoto?: { __typename?: 'Media', link: string } | null } }>, issueSupporterRels: Array<{ __typename?: 'IssueSupporterRels', issue: { __typename?: 'Issues', id: any, topic: string, slogan?: string | null, summary?: string | null, location?: string | null, isActive: boolean, supporterCount?: number | null, verifiedSupporterCount?: number | null, createdAt: any, updatedAt: any, issueMediaRels: Array<{ __typename?: 'IssueMediaRels', medium: { __typename?: 'Media', id: any, link: string } }>, leader: { __typename?: 'Entities', id: any, displayNameShort?: string | null, profilePhoto?: { __typename?: 'Media', link: string } | null } } }> };

export type PublicContent_PublicEntityFragment = { __typename?: 'Entities', id: any, displayNameLong: string, displayNameShort?: string | null, bio?: string | null, entityType?: EntityTypesEnum | null, isIdVerified: boolean, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null, issues: Array<{ __typename?: 'Issues', id: any, topic: string, slogan?: string | null, summary?: string | null, location?: string | null, isActive: boolean, supporterCount?: number | null, verifiedSupporterCount?: number | null, createdAt: any, updatedAt: any, issueMediaRels: Array<{ __typename?: 'IssueMediaRels', medium: { __typename?: 'Media', id: any, link: string } }>, leader: { __typename?: 'Entities', id: any, displayNameShort?: string | null, profilePhoto?: { __typename?: 'Media', link: string } | null } }> };

export type ProfileContent_GetEntityQueryVariables = Exact<{
  entityId: Scalars['uuid']['input'];
}>;


export type ProfileContent_GetEntityQuery = { __typename?: 'query_root', entitiesByPk?: { __typename?: 'Entities', id: any, displayNameLong: string, displayNameShort?: string | null, bio?: string | null, entityType?: EntityTypesEnum | null, isIdVerified: boolean, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null, issues: Array<{ __typename?: 'Issues', id: any, topic: string, slogan?: string | null, summary?: string | null, location?: string | null, isActive: boolean, supporterCount?: number | null, verifiedSupporterCount?: number | null, createdAt: any, updatedAt: any, issueMediaRels: Array<{ __typename?: 'IssueMediaRels', medium: { __typename?: 'Media', id: any, link: string } }>, leader: { __typename?: 'Entities', id: any, displayNameShort?: string | null, profilePhoto?: { __typename?: 'Media', link: string } | null } }>, issueSupporterRels: Array<{ __typename?: 'IssueSupporterRels', issue: { __typename?: 'Issues', id: any, topic: string, slogan?: string | null, summary?: string | null, location?: string | null, isActive: boolean, supporterCount?: number | null, verifiedSupporterCount?: number | null, createdAt: any, updatedAt: any, issueMediaRels: Array<{ __typename?: 'IssueMediaRels', medium: { __typename?: 'Media', id: any, link: string } }>, leader: { __typename?: 'Entities', id: any, displayNameShort?: string | null, profilePhoto?: { __typename?: 'Media', link: string } | null } } }> } | null };

export type ProfilePhotoUpload_EntityFragment = { __typename?: 'Entities', id: any, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null };

export type ProfilePhotoUpload_InsertMediaMutationVariables = Exact<{
  photoUrl: Scalars['String']['input'];
}>;


export type ProfilePhotoUpload_InsertMediaMutation = { __typename?: 'mutation_root', insertMedia?: { __typename?: 'Media', id: any, link: string } | null };

export type ProfilePhotoUpload_UpdateEntityProfilePhotoMutationVariables = Exact<{
  entityId: Scalars['uuid']['input'];
  mediaId: Scalars['uuid']['input'];
}>;


export type ProfilePhotoUpload_UpdateEntityProfilePhotoMutation = { __typename?: 'mutation_root', updateEntities?: { __typename?: 'Entities', id: any, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null } | null };

export type ProfilePhotoUpload_RemoveProfilePhotoMutationVariables = Exact<{
  mediaId: Scalars['uuid']['input'];
}>;


export type ProfilePhotoUpload_RemoveProfilePhotoMutation = { __typename?: 'mutation_root', deleteMediaByPk?: { __typename?: 'Media', id: any } | null };

export type UserProfile_EntityFragment = { __typename?: 'Entities', id: any, displayNameLong: string, displayNameShort?: string | null, bio?: string | null, entityType?: EntityTypesEnum | null, isIdVerified: boolean, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null, issues: Array<{ __typename?: 'Issues', id: any, topic: string, slogan?: string | null, summary?: string | null, location?: string | null, isActive: boolean, createdAt: any, updatedAt: any }>, issueSupporterRels: Array<{ __typename?: 'IssueSupporterRels', issue: { __typename?: 'Issues', id: any, topic: string, slogan?: string | null, summary?: string | null, location?: string | null, isActive: boolean, createdAt: any, updatedAt: any, leader: { __typename?: 'Entities', id: any, displayNameLong: string, profilePhoto?: { __typename?: 'Media', link: string } | null } } }> };

export type UserProfile_UpdateBioMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  bio: Scalars['String']['input'];
}>;


export type UserProfile_UpdateBioMutation = { __typename?: 'mutation_root', updateEntitiesByPk?: { __typename?: 'Entities', id: any } | null };

export type VoterVerificationForm_InsertVoterVerificationMutationVariables = Exact<{
  personId: Scalars['uuid']['input'];
  voterbaseId: Scalars['String']['input'];
}>;


export type VoterVerificationForm_InsertVoterVerificationMutation = { __typename?: 'mutation_root', insertVoterVerificationsOne?: { __typename?: 'VoterVerifications', id: any } | null, insertRegisteredVotersOne?: { __typename?: 'RegisteredVoters', voterbaseId: string } | null };

export type VoterVerificationForm_UpsertJurisdictionsMutationVariables = Exact<{
  objects: Array<JurisdictionsInsertInput> | JurisdictionsInsertInput;
}>;


export type VoterVerificationForm_UpsertJurisdictionsMutation = { __typename?: 'mutation_root', insertJurisdictions?: { __typename?: 'JurisdictionsMutationResponse', affectedRows: number } | null };

export type JurisdictionFragment = { __typename?: 'Jurisdictions', id: any, geoid?: string | null };

export type VoterVerificationForm_GetJurisdictionsQueryVariables = Exact<{
  geoids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type VoterVerificationForm_GetJurisdictionsQuery = { __typename?: 'query_root', jurisdictions: Array<{ __typename?: 'Jurisdictions', id: any, geoid?: string | null }> };

export type VoterVerificationForm_InsertRelsMutationVariables = Exact<{
  rels: Array<VoterVerificationJurisdictionRelsInsertInput> | VoterVerificationJurisdictionRelsInsertInput;
}>;


export type VoterVerificationForm_InsertRelsMutation = { __typename?: 'mutation_root', insertVoterVerificationJurisdictionRels?: { __typename?: 'VoterVerificationJurisdictionRelsMutationResponse', affectedRows: number } | null };

export type VoterVerificationForm_GetRegisteredVoterQueryVariables = Exact<{
  voterbaseId: Scalars['String']['input'];
}>;


export type VoterVerificationForm_GetRegisteredVoterQuery = { __typename?: 'query_root', registeredVotersByPk?: { __typename?: 'RegisteredVoters', voterbaseId: string } | null };

export type AuthMachine_GetUserQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type AuthMachine_GetUserQuery = { __typename?: 'query_root', usersByPk?: { __typename?: 'Users', id: any, person: { __typename?: 'Persons', id: any, voterVerifications: Array<{ __typename?: 'VoterVerifications', id: any }>, entityPersonRels: Array<{ __typename?: 'EntityPersonRels', id: any, entity: { __typename?: 'Entities', id: any, profilePhotoId?: any | null, isLeader?: boolean | null, profilePhoto?: { __typename?: 'Media', id: any, link: string } | null } }> } } | null };

export type UserOperations_GetUserByPhoneQueryVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type UserOperations_GetUserByPhoneQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', id: any, oryId?: any | null }> };

export type UserOperations_UpdateUserOryIdMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  oryId: Scalars['uuid']['input'];
}>;


export type UserOperations_UpdateUserOryIdMutation = { __typename?: 'mutation_root', updateUsersByPk?: { __typename?: 'Users', id: any } | null };

export type UserOperations_CreateUserAndRelationsMutationVariables = Exact<{
  oryId: Scalars['uuid']['input'];
  phoneNumber: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
}>;


export type UserOperations_CreateUserAndRelationsMutation = { __typename?: 'mutation_root', insertUsers?: { __typename?: 'UsersMutationResponse', returning: Array<{ __typename?: 'Users', id: any, oryId?: any | null, person: { __typename?: 'Persons', id: any, firstName: string, lastName: string, entityPersonRels: Array<{ __typename?: 'EntityPersonRels', entity: { __typename?: 'Entities', id: any, displayNameShort?: string | null, displayNameLong: string, entityType?: EntityTypesEnum | null } }> } }> } | null };

export const LoginPage_UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoginPage_User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityPersonRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"isIdVerified"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bio"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoginPage_UserFragment, unknown>;
export const MePage_UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MePage_User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityPersonRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"isIdVerified"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bio"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MePage_UserFragment, unknown>;
export const SettingsPage_EntityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SettingsPage_Entity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"isIdVerified"}},{"kind":"Field","name":{"kind":"Name","value":"entityPersonRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isDisabled"}},{"kind":"Field","name":{"kind":"Name","value":"oryId"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SettingsPage_EntityFragment, unknown>;
export const Entity_InfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Entity_Info"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}}]}}]} as unknown as DocumentNode<Entity_InfoFragment, unknown>;
export const IssuesPage_IssueInfluenceTargetRelsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_IssueInfluenceTargetRels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IssueInfluenceTargetRels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}}]}}]} as unknown as DocumentNode<IssuesPage_IssueInfluenceTargetRelsFragment, unknown>;
export const IssuesPage_IssueMediaRelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_IssueMediaRel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IssueMediaRels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]} as unknown as DocumentNode<IssuesPage_IssueMediaRelFragment, unknown>;
export const IssuesPage_IssueFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_Issue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Issues"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"slogan"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"supporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedSupporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"leader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Entity_Info"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueInfluenceTargetRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_IssueInfluenceTargetRels"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueMediaRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_IssueMediaRel"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Entity_Info"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_IssueInfluenceTargetRels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IssueInfluenceTargetRels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_IssueMediaRel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IssueMediaRels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]} as unknown as DocumentNode<IssuesPage_IssueFragment, unknown>;
export const IssuesPage_VoterVerificationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_VoterVerification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityPersonRels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voterVerifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<IssuesPage_VoterVerificationFragment, unknown>;
export const AuthProvider_EntityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthProvider_Entity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhotoId"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}}]}}]} as unknown as DocumentNode<AuthProvider_EntityFragment, unknown>;
export const AuthProvider_UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthProvider_User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voterVerifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"entityPersonRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthProvider_Entity"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthProvider_Entity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhotoId"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}}]}}]} as unknown as DocumentNode<AuthProvider_UserFragment, unknown>;
export const ProfileContent_IssuesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileContent_Issues"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Issues"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"slogan"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"supporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedSupporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"issueMediaRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medium"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileContent_IssuesFragment, unknown>;
export const ProfileContent_EntityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileContent_Entity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"isIdVerified"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"leaderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileContent_Issues"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueSupporterRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileContent_Issues"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileContent_Issues"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Issues"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"slogan"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"supporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedSupporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"issueMediaRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medium"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileContent_EntityFragment, unknown>;
export const PublicContent_PublicEntityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicContent_PublicEntity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"isIdVerified"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"leaderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileContent_Issues"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileContent_Issues"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Issues"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"slogan"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"supporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedSupporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"issueMediaRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medium"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]}}]} as unknown as DocumentNode<PublicContent_PublicEntityFragment, unknown>;
export const ProfilePhotoUpload_EntityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfilePhotoUpload_Entity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]} as unknown as DocumentNode<ProfilePhotoUpload_EntityFragment, unknown>;
export const UserProfile_EntityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserProfile_Entity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"isIdVerified"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"slogan"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueSupporterRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"slogan"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"leader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserProfile_EntityFragment, unknown>;
export const JurisdictionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Jurisdiction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Jurisdictions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"geoid"}}]}}]} as unknown as DocumentNode<JurisdictionFragment, unknown>;
export const LoginPage_GetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoginPage_GetUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoginPage_User"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoginPage_User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityPersonRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"isIdVerified"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bio"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoginPage_GetUsersQuery, LoginPage_GetUsersQueryVariables>;
export const LoginPage_GetUserInfoByPhoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoginPage_GetUserInfoByPhone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthProvider_User"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthProvider_Entity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhotoId"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthProvider_User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voterVerifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"entityPersonRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthProvider_Entity"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoginPage_GetUserInfoByPhoneQuery, LoginPage_GetUserInfoByPhoneQueryVariables>;
export const LoginPage_CreatePersonAndEntityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginPage_CreatePersonAndEntity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"person"},"name":{"kind":"Name","value":"insertPersons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"entity"},"name":{"kind":"Name","value":"insertEntities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayNameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"displayNameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"entityType"},"value":{"kind":"EnumValue","value":"PERSONAL"}},{"kind":"ObjectField","name":{"kind":"Name","value":"isIdVerified"},"value":{"kind":"BooleanValue","value":false}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<LoginPage_CreatePersonAndEntityMutation, LoginPage_CreatePersonAndEntityMutationVariables>;
export const LoginPage_CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginPage_CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"personId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"oryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oryId"}}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<LoginPage_CreateUserMutation, LoginPage_CreateUserMutationVariables>;
export const LoginPage_CreateEntityPersonRelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginPage_CreateEntityPersonRel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertEntityPersonRels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"personId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<LoginPage_CreateEntityPersonRelMutation, LoginPage_CreateEntityPersonRelMutationVariables>;
export const MePage_GetCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MePage_GetCurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MePage_User"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MePage_User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityPersonRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"isIdVerified"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bio"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MePage_GetCurrentUserQuery, MePage_GetCurrentUserQueryVariables>;
export const ProfileEntityPage_GetEntityQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileEntityPage_GetEntityQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entitiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileContent_Entity"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileContent_Issues"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Issues"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"slogan"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"supporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedSupporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"issueMediaRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medium"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileContent_Entity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"isIdVerified"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"leaderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileContent_Issues"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueSupporterRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileContent_Issues"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileEntityPage_GetEntityQueryQuery, ProfileEntityPage_GetEntityQueryQueryVariables>;
export const ProfileEntityPage_GetPublicEntityQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileEntityPage_GetPublicEntityQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entitiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicContent_PublicEntity"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileContent_Issues"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Issues"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"slogan"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"supporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedSupporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"issueMediaRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medium"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicContent_PublicEntity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"isIdVerified"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"leaderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileContent_Issues"}}]}}]}}]} as unknown as DocumentNode<ProfileEntityPage_GetPublicEntityQueryQuery, ProfileEntityPage_GetPublicEntityQueryQueryVariables>;
export const SettingsPage_GetEntityQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SettingsPage_GetEntityQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entitiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SettingsPage_Entity"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SettingsPage_Entity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"isIdVerified"}},{"kind":"Field","name":{"kind":"Name","value":"entityPersonRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isDisabled"}},{"kind":"Field","name":{"kind":"Name","value":"oryId"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SettingsPage_GetEntityQueryQuery, SettingsPage_GetEntityQueryQueryVariables>;
export const SettingsPage_UpdateEntityMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SettingsPage_UpdateEntityMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bio"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayNameShort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayNameLong"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEntitiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"bio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bio"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"displayNameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayNameShort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"displayNameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayNameLong"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}}]}}]}}]} as unknown as DocumentNode<SettingsPage_UpdateEntityMutationMutation, SettingsPage_UpdateEntityMutationMutationVariables>;
export const SettingsPage_UpdatePersonMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SettingsPage_UpdatePersonMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePersonsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<SettingsPage_UpdatePersonMutationMutation, SettingsPage_UpdatePersonMutationMutationVariables>;
export const IssuesNewPage_CreateIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IssuesNewPage_CreateIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IssuesInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertIssuesOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_Issue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Entity_Info"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_IssueInfluenceTargetRels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IssueInfluenceTargetRels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_IssueMediaRel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IssueMediaRels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_Issue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Issues"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"slogan"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"supporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedSupporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"leader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Entity_Info"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueInfluenceTargetRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_IssueInfluenceTargetRels"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueMediaRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_IssueMediaRel"}}]}}]}}]} as unknown as DocumentNode<IssuesNewPage_CreateIssueMutation, IssuesNewPage_CreateIssueMutationVariables>;
export const IssuesPage_GetIssuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IssuesPage_GetIssues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_Issue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Entity_Info"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_IssueInfluenceTargetRels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IssueInfluenceTargetRels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_IssueMediaRel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IssueMediaRels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_Issue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Issues"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"slogan"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"supporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedSupporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"leader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Entity_Info"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueInfluenceTargetRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_IssueInfluenceTargetRels"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueMediaRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_IssueMediaRel"}}]}}]}}]} as unknown as DocumentNode<IssuesPage_GetIssuesQuery, IssuesPage_GetIssuesQueryVariables>;
export const IssuesPage_GetIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IssuesPage_GetIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_Issue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Entity_Info"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_IssueInfluenceTargetRels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IssueInfluenceTargetRels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_IssueMediaRel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IssueMediaRels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_Issue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Issues"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"slogan"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"supporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedSupporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"leader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Entity_Info"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueInfluenceTargetRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_IssueInfluenceTargetRels"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueMediaRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_IssueMediaRel"}}]}}]}}]} as unknown as DocumentNode<IssuesPage_GetIssueQuery, IssuesPage_GetIssueQueryVariables>;
export const IssuesPage_UpdateIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IssuesPage_UpdateIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slogan"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"summary"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"influenceTargets"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IssueInfluenceTargetRelsInsertInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIssuesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slogan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slogan"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"summary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"summary"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_Issue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteIssueInfluenceTargetRels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issueId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertIssueInfluenceTargetRels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"influenceTargets"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Entity_Info"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_IssueInfluenceTargetRels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IssueInfluenceTargetRels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_IssueMediaRel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IssueMediaRels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_Issue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Issues"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"slogan"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"supporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedSupporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"leader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Entity_Info"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueInfluenceTargetRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_IssueInfluenceTargetRels"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueMediaRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_IssueMediaRel"}}]}}]}}]} as unknown as DocumentNode<IssuesPage_UpdateIssueMutation, IssuesPage_UpdateIssueMutationVariables>;
export const IssuesPage_MakeIssueInactiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IssuesPage_MakeIssueInactive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIssuesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<IssuesPage_MakeIssueInactiveMutation, IssuesPage_MakeIssueInactiveMutationVariables>;
export const IssuesPage_MakeIssueActiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IssuesPage_MakeIssueActive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIssuesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<IssuesPage_MakeIssueActiveMutation, IssuesPage_MakeIssueActiveMutationVariables>;
export const IssuesPage_DeleteIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IssuesPage_DeleteIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteIssuesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<IssuesPage_DeleteIssueMutation, IssuesPage_DeleteIssueMutationVariables>;
export const IssuesPage_CreateIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IssuesPage_CreateIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"topic"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slogan"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"summary"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leaderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"influenceTargets"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IssueInfluenceTargetRelsInsertInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertIssuesOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"topic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"topic"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"slogan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slogan"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"summary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"summary"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"leaderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leaderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"issueInfluenceTargetRels"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"influenceTargets"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_Issue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Entity_Info"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_IssueInfluenceTargetRels"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IssueInfluenceTargetRels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_IssueMediaRel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IssueMediaRels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_Issue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Issues"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"slogan"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"supporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedSupporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"leader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Entity_Info"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueInfluenceTargetRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_IssueInfluenceTargetRels"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueMediaRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_IssueMediaRel"}}]}}]}}]} as unknown as DocumentNode<IssuesPage_CreateIssueMutation, IssuesPage_CreateIssueMutationVariables>;
export const IssuesPage_VoteWithMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IssuesPage_VoteWithMe"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supporterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertIssueSupporterRelsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"supporterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supporterId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"supporterId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<IssuesPage_VoteWithMeMutation, IssuesPage_VoteWithMeMutationVariables>;
export const IssuesPage_UnvoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IssuesPage_Unvote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supporterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteIssueSupporterRels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issueId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"supporterId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supporterId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<IssuesPage_UnvoteMutation, IssuesPage_UnvoteMutationVariables>;
export const IssuesPage_CheckSupporterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IssuesPage_CheckSupporter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supporterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueSupporterRels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issueId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"supporterId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supporterId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<IssuesPage_CheckSupporterQuery, IssuesPage_CheckSupporterQueryVariables>;
export const IssuesPage_IsVerifiedVoterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IssuesPage_IsVerifiedVoter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entitiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entityPersonRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IssuesPage_VoterVerification"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IssuesPage_VoterVerification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityPersonRels"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voterVerifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<IssuesPage_IsVerifiedVoterQuery, IssuesPage_IsVerifiedVoterQueryVariables>;
export const IssuesPage_LeaderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IssuesPage_Leader"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entitiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Entity_Info"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Entity_Info"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}}]}}]} as unknown as DocumentNode<IssuesPage_LeaderQuery, IssuesPage_LeaderQueryVariables>;
export const IssuesPage_InsertIssueMediaRelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IssuesPage_InsertIssueMediaRel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertIssueMediaRelsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mediaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<IssuesPage_InsertIssueMediaRelMutation, IssuesPage_InsertIssueMediaRelMutationVariables>;
export const AddEmailToWaitlistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddEmailToWaitlist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertWaitlistOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddEmailToWaitlistMutation, AddEmailToWaitlistMutationVariables>;
export const UpdateWaitlistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWaitlist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueDescription"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isIssueLeader"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWaitlistByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"issueDescription"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueDescription"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isIssueLeader"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isIssueLeader"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateWaitlistMutation, UpdateWaitlistMutationVariables>;
export const AuthProvider_GetCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthProvider_GetCurrentUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"oryId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oryId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthProvider_User"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthProvider_Entity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhotoId"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthProvider_User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voterVerifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"entityPersonRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthProvider_Entity"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthProvider_GetCurrentUserQuery, AuthProvider_GetCurrentUserQueryVariables>;
export const LoginForm_GetUserByPhoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoginForm_GetUserByPhone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<LoginForm_GetUserByPhoneQuery, LoginForm_GetUserByPhoneQueryVariables>;
export const LoginForm_UpdateUserOryIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginForm_UpdateUserOryId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUsersByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"oryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oryId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthProvider_User"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthProvider_Entity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhotoId"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthProvider_User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voterVerifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"entityPersonRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthProvider_Entity"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoginForm_UpdateUserOryIdMutation, LoginForm_UpdateUserOryIdMutationVariables>;
export const LoginForm_CreateUserAndRelationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginForm_CreateUserAndRelations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"oryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oryId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"person"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"entityPersonRels"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entity"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayNameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"displayNameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"entityType"},"value":{"kind":"EnumValue","value":"PERSONAL"}},{"kind":"ObjectField","name":{"kind":"Name","value":"isIdVerified"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthProvider_User"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthProvider_Entity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhotoId"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthProvider_User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voterVerifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"entityPersonRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthProvider_Entity"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoginForm_CreateUserAndRelationsMutation, LoginForm_CreateUserAndRelationsMutationVariables>;
export const ProfileContent_GetEntityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileContent_GetEntity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entitiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileContent_Entity"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileContent_Issues"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Issues"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"slogan"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"supporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedSupporterCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"issueMediaRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medium"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileContent_Entity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"isIdVerified"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"leaderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileContent_Issues"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueSupporterRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileContent_Issues"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileContent_GetEntityQuery, ProfileContent_GetEntityQueryVariables>;
export const ProfilePhotoUpload_InsertMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProfilePhotoUpload_InsertMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photoUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"insertMedia"},"name":{"kind":"Name","value":"insertMediaOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"link"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photoUrl"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]} as unknown as DocumentNode<ProfilePhotoUpload_InsertMediaMutation, ProfilePhotoUpload_InsertMediaMutationVariables>;
export const ProfilePhotoUpload_UpdateEntityProfilePhotoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProfilePhotoUpload_UpdateEntityProfilePhoto"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateEntities"},"name":{"kind":"Name","value":"updateEntitiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"profilePhotoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfilePhotoUpload_Entity"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfilePhotoUpload_Entity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]} as unknown as DocumentNode<ProfilePhotoUpload_UpdateEntityProfilePhotoMutation, ProfilePhotoUpload_UpdateEntityProfilePhotoMutationVariables>;
export const ProfilePhotoUpload_RemoveProfilePhotoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProfilePhotoUpload_RemoveProfilePhoto"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMediaByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mediaId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ProfilePhotoUpload_RemoveProfilePhotoMutation, ProfilePhotoUpload_RemoveProfilePhotoMutationVariables>;
export const UserProfile_UpdateBioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserProfile_UpdateBio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEntitiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"bio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bio"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UserProfile_UpdateBioMutation, UserProfile_UpdateBioMutationVariables>;
export const VoterVerificationForm_InsertVoterVerificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VoterVerificationForm_InsertVoterVerification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voterbaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertVoterVerificationsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"personId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertRegisteredVotersOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"voterbaseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voterbaseId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voterbaseId"}}]}}]}}]} as unknown as DocumentNode<VoterVerificationForm_InsertVoterVerificationMutation, VoterVerificationForm_InsertVoterVerificationMutationVariables>;
export const VoterVerificationForm_UpsertJurisdictionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VoterVerificationForm_UpsertJurisdictions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JurisdictionsInsertInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertJurisdictions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"jurisdictions_geoid_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<VoterVerificationForm_UpsertJurisdictionsMutation, VoterVerificationForm_UpsertJurisdictionsMutationVariables>;
export const VoterVerificationForm_GetJurisdictionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VoterVerificationForm_GetJurisdictions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"geoids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jurisdictions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geoid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"geoids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Jurisdiction"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Jurisdiction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Jurisdictions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"geoid"}}]}}]} as unknown as DocumentNode<VoterVerificationForm_GetJurisdictionsQuery, VoterVerificationForm_GetJurisdictionsQueryVariables>;
export const VoterVerificationForm_InsertRelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VoterVerificationForm_InsertRels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rels"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VoterVerificationJurisdictionRelsInsertInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertVoterVerificationJurisdictionRels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rels"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<VoterVerificationForm_InsertRelsMutation, VoterVerificationForm_InsertRelsMutationVariables>;
export const VoterVerificationForm_GetRegisteredVoterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VoterVerificationForm_GetRegisteredVoter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voterbaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registeredVotersByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"voterbaseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voterbaseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voterbaseId"}}]}}]}}]} as unknown as DocumentNode<VoterVerificationForm_GetRegisteredVoterQuery, VoterVerificationForm_GetRegisteredVoterQueryVariables>;
export const AuthMachine_GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthMachine_GetUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthProvider_User"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthProvider_Entity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhotoId"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthProvider_User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voterVerifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"entityPersonRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthProvider_Entity"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthMachine_GetUserQuery, AuthMachine_GetUserQueryVariables>;
export const UserOperations_GetUserByPhoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserOperations_GetUserByPhone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oryId"}}]}}]}}]} as unknown as DocumentNode<UserOperations_GetUserByPhoneQuery, UserOperations_GetUserByPhoneQueryVariables>;
export const UserOperations_UpdateUserOryIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserOperations_UpdateUserOryId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUsersByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"oryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oryId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UserOperations_UpdateUserOryIdMutation, UserOperations_UpdateUserOryIdMutationVariables>;
export const UserOperations_CreateUserAndRelationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserOperations_CreateUserAndRelations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"oryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oryId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"person"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"entityPersonRels"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entity"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayNameLong"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"displayNameShort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"entityType"},"value":{"kind":"EnumValue","value":"PERSONAL"}},{"kind":"ObjectField","name":{"kind":"Name","value":"isIdVerified"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oryId"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityPersonRels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameShort"}},{"kind":"Field","name":{"kind":"Name","value":"displayNameLong"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserOperations_CreateUserAndRelationsMutation, UserOperations_CreateUserAndRelationsMutationVariables>;